export const translations = {
  english: {
    // Header
    inAssociationWith: "In association with",
    
    // User Data Labels
    name: "Name",
    mobile: "Mobile",
    address: "Address",
    cityState: "City/State",
    previousCrop: "Previous Crop",
    farmSize: "Farm Size",
    farmName: "Farm Name",
    nextCrop: "Next Crop",
    sampleCode: "Sample Code",
    treatmentType: "Treatment Type",
    sampleType: "Sample Type",
    reportDate: "Date",
    
    // Section Titles
    section1Title: "Soil Analysis Summary",
    section1Subtitle: "This is what we tested in your soil sample.",
    section2Title: "Detailed Nutrient Insights",
    section2Subtitle: "Deep-dive into each tested parameter.",
    section3Title: "Fertilizer Recommendation",
    section3Subtitle: "This page tells you exactly what fertilizers to use, how much, and when. Follow this plan.",
    section4Title: "Derived Insights & Nutrient Balance",
    section4Subtitle: "This section gives deeper insights. Useful but not mandatory to read.",
    section5Title: "Crop-Specific Tips",
    section5Subtitle: "Expert tips for cultivation. Follow these practices for better results.",

    //Water Report Section Title
    waterSection1Title: "Water Analysis Summary",
    waterSection1Subtitle: "This is what we tested in your water sample.",
    waterRecommendationTitle: "Water Treatment Recommendations",
    waterRecommendationSubtitle: "Suggested corrective measures for your water quality",
    waterPerfect: "Water Quality is Optimal",
    waterPerfectDesc: "No corrective treatments are required based on the tested parameters.",
    waterRecommendationNote: "Note: Avoid repeating the same action when it is recommended for multiple parameter. A single practice commonly improves several parameters, so one application is sufficient.",

    // Table Headers - Soil Analysis
    sNo: "S. No.",
    parameter: "Parameter",
    idealRange: "Ideal Range",
    actualValue: "Actual Value",
    status: "Status",
    derivedParameters: "Derived Parameters",

    //BODL Note
    note: "Note",
    bodlLabel: "BODL (Below Our Detection Limit)",
    bodlDescription:
      "indicates that the concentration of the parameter is below the minimum detection limit of the test method. It does not necessarily mean the parameter is completely absent.",
        
    // Table Headers - Detailed Insights
    fertilityRating: "Fertility Rating",
    whatItMeans: "What it means?",
    functionInCropGrowth: "Function in Crop Growth",
    
    // Nutrient Insights - Meanings
    phMeaning: "Acidity/alkalinity of soil",
    ecMeaning: "Salt level in soil",
    ocMeaning: "Soil organic matter",
    nitrogenMeaning: "Growth nutrient",
    phosphorusMeaning: "Energy transfer",
    potassiumMeaning: "Fruit quality regulator",
    sulphurMeaning: "Protein synthesis",
    magnesiumMeaning: "Core of chlorophyll",
    calciumMeaning: "Cell strength",
    zincMeaning: "Growth hormone support",
    ironMeaning: "Chlorophyll synthesis",
    copperMeaning: "Enzyme activator",
    boronMeaning: "Pollination & fruit set",
    
    // Nutrient Insights - Functions
    phFunction: "Affects nutrient availability and microbial activity",
    ecFunction: "Influences root water uptake and nutrient solubility",
    ocFunction: "Enhances microbial life, structure, and water retention",
    nitrogenFunction: "Promotes leafy growth and chlorophyll formation",
    phosphorusFunction: "Supports root development and flowering",
    potassiumFunction: "Helps in water balance, disease resistance, fruit size",
    sulphurFunction: "Improves enzyme function, oil synthesis, and taste",
    magnesiumFunction: "Essential for photosynthesis and enzyme activation",
    calciumFunction: "Builds strong cell walls, prevents blossom-end rot",
    zincFunction: "Needed for enzyme activation, leaf expansion, rooting",
    ironFunction: "Supports green leaf formation and respiration",
    copperFunction: "Influences pollen viability and disease resistance",
    boronFunction: "Aids flowering, fruit set, sugar transport, and seed formation",
    
    // Derived Insights - Meanings
    cnRatioMeaning: "Ratio of soil Organic carbon to available nitrogen",
    cecTendencyMeaning: "Soil's capacity to hold and exchange nutrients (based on OC, Ca, Mg, K, pH)",
    caMgRatioMeaning: "Balance between calcium and magnesium levels in soil",
    kMgRatioMeaning: "Balance between potassium and magnesium availability",
    
    // Derived Insights - Functions
    cnRatioFunction: "Indicates quality of organic matter; affects microbial activity and nitrogen availability",
    cecTendencyFunction: "Influences root water uptake and nutrient solubility",
    caMgRatioFunction: "Influences soil structure, aeration, water movement, and root penetration",
    kMgRatioFunction: "Controls competition for uptake; affects fruit quality, stress tolerance, and leaf strength",
    
    // Derived Indicators - Effects
    cnRatioLowEffect: "Fast breakdown of organic matter, increased nitrate leaching",
    cnRatioHighEffect: "Nutrient lock-up, slower nitrogen mineralization",
    cecTendencyLowEffect: "Poor nutrient retention, higher risk of leaching",
    cecTendencyHighEffect: "Nutrients may bind too tightly",
    caMgRatioLowEffect: "Soil compaction, poor aeration, reduced water infiltration",
    caMgRatioHighEffect: "Nutrient antagonism, especially Mg and K deficiency",
    kMgRatioLowEffect: "Potential Mg excess, may delay fruit maturity",
    kMgRatioHighEffect: "K suppresses Mg uptake, weak stems",
    
    // Nutrient Blocking
    phosphorusBlocks: "Zinc (Zn), Iron (Fe), Copper (Cu)",
    potassiumBlocks: "Magnesium (Mg), Calcium (Ca)",
    nitrogenBlocks: "Copper (Cu), Boron (B)",
    
    // Table Headers - Fertilizer
    stage: "Stage",
    input: "Input",
    dose: "Dose",
    method: "Method",
    
    // Table Headers - Derived Insights
    indicator: "Indicator",
    condition: "Condition",
    imbalanceEffect: "Imbalance Effect",
    
    // Table Headers - Nutrient Blocking
    blockingTitle: "Points to Keep in Mind During Fertilizer Application",
    whenTooMuchOf: "When There Is Too Much Of...",
    itBlocks: "It Blocks...",
    
    // Table Headers - Crop Tips
    practice: "Practice",
    why: "Why",
    
    // Status/Levels
    low: "Low",
    medium: "Normal",
    high: "High",
    
    // Messages
    cropTipsNotAvailable: "Crop-Specific Tips Not Available",
    cropTipsNotAvailableDesc: "We don't have cultivation tips for \"{crop}\" at the moment. Please check back later or contact support for assistance.",
    availableCrops: "Available crops",
    fertilizerNotAvailable: "Fertilizer Recommendation Not Available",
    fertilizerNotAvailableDesc: "We don't have fertilizer recommendations for your soil at the moment. Please check back later or contact support for assistance.",
    
    // Derived Parameters Section
    derivedParametersSubtitle: "Additional soil fertility indicators for comprehensive analysis.",
    
    // Notes
    phosphorusNote: "Note: This report expresses phosphorus values as P₂O₅. To convert P₂O₅ to elemental P, multiply the value by 0.436.",

    // Report Under Review
    underReviewHeading: "REPORT STATUS: UNDER REVIEW",
    underReviewBody: "One or more results require verification. Please contact our technical support team. Repeat testing may be required before the final report is issued!",
    
    warningUnderReview: "WARNING: This report has anomalies and is currently under review. The values displayed are provisional and may be inaccurate.\n\nDo you still want to download it anyway? (Click 'Cancel' to stop and contact support to get anomalies rectified).",

    // Disclaimer
    disclaimer: "DISCLAIMER",
    disclaimerWithPartner: "This soil testing report has been prepared in collaboration with Ekosight Technologies Private Limited and its authorized partner [Partner Name]. [Partner Name] is solely responsible for conducting the soil testing, performing the analysis, and providing the results presented in this report. Ekosight Technologies provides the testing technology, tools, and analytical framework used in this process but does not independently verify or validate individual test results generated by the partner laboratory or personnel. The partner assumes full responsibility for the accuracy, reliability, and interpretation of the results based on the sample(s) provided by the client. The test results are valid only for the sample as received and under the specific testing conditions applied. Recommendations derived from these results should be used as guidance; field conditions, seasonal variations, and agronomic factors may influence actual outcomes.",
    disclaimerWithoutPartner: "This soil testing report has been prepared and issued by Ekosight Technologies Private Limited based on the sample(s) received and the information provided by the client. The testing, analysis, and interpretation presented in this report have been conducted using Ekosight's proprietary technology, tools, and analytical framework. While every effort has been made to ensure accuracy and reliability, the results are limited to the condition and integrity of the sample as received. The results and recommendations provided are intended for guidance purposes only. Actual field outcomes may vary depending on soil variability, environmental factors, crop management practices, and seasonal conditions. Ekosight Technologies shall not be held responsible or liable for any direct, indirect, or consequential loss, damage, or decisions made based on the use of this report or its recommendations. No part of this report may be reproduced or used for commercial or public purposes without prior written permission from Ekosight Technologies Private Limited.",
    waterDisclaimerTextWithPartner:
      "This water testing report has been prepared in collaboration with Ekosight Technologies Private Limited and its authorized partner, [Partner Name] . Ekosight Technologies Private Limited provides the testing technology, tools, and analytical framework used in this process but does not independently verify or validate individual test results generated by the partner laboratory or personal. The authorized partner assumes full responsibility for the accuracy, reliability, and interpretation of the results based on the water sample(s) provided by the client. The test results are valid only for the sample as received and under the specific testing conditions applied at the time of analysis. Recommendations or interpretations derived from these results are intended as general guidance only. Actual water quality and suitability may vary due to source conditions, storage, handling, seasonal variations, and site-specific environmental factors.",
  },
  
  hindi: {
    // Header
    inAssociationWith: "के सहयोग से",
    
    // User Data Labels
    name: "नाम",
    mobile: "मोबाइल",
    address: "पता",
    cityState: "शहर/राज्य",
    previousCrop: "पिछली फसल",
    farmSize: "खेत का आकार",
    farmName: "खेत का नाम",
    nextCrop: "अगली फसल",
    sampleCode: "नमूना कोड",
    treatmentType: "उपचार प्रकार",
    sampleType: "नमूना प्रकार",
    reportDate: "दिनांक",
    
    // Section Titles
    section1Title: "मिट्टी विश्लेषण सारांश",
    section1Subtitle: "यह आपकी मिट्टी के नमूने में हमने क्या परीक्षण किया है।",
    section2Title: "विस्तृत पोषक तत्व जानकारी",
    section2Subtitle: "प्रत्येक परीक्षण किए गए पैरामीटर में गहराई से जानकारी।",
    section3Title: "उर्वरक सिफारिश",
    section3Subtitle: "यह पृष्ठ आपको बताता है कि कौन से उर्वरक का उपयोग करना है, कितना और कब। इस योजना का पालन करें।",
    section4Title: "व्युत्पन्न अंतर्दृष्टि और पोषक संतुलन",
    section4Subtitle: "यह खंड गहरी जानकारी देता है। पढ़ना उपयोगी है लेकिन अनिवार्य नहीं।",
    section5Title: "फसल-विशिष्ट सुझाव",
    section5Subtitle: "खेती के लिए विशेषज्ञ सुझाव। बेहतर परिणामों के लिए इन प्रथाओं का पालन करें।",

    //Water Report Section Title
    waterSection1Title: "पानी विश्लेषण सारांश",
    waterSection1Subtitle: "यह आपकी पानी के नमूने में हमने क्या परीक्षण किया है।",
    waterRecommendationTitle: "जल उपचार सिफारिशें",
    waterRecommendationSubtitle: "आपके पानी की गुणवत्ता के लिए सुझाए गए सुधारात्मक उपाय",
    waterPerfect: "जल गुणवत्ता उत्तम है",
    waterPerfectDesc: "परीक्षण किए गए मानकों के आधार पर किसी सुधारात्मक उपचार की आवश्यकता नहीं है।",
    waterRecommendationNote: "नोट: यदि एक ही कार्य कई मापदंडों के लिए सुझाया गया है, तो उसे बार-बार दोहराने से बचें। एक ही अभ्यास अक्सर कई मापदंडों में सुधार करता है, इसलिए एक बार करना ही पर्याप्त है।",

    // Table Headers - Soil Analysis
    sNo: "क्र.सं.",
    parameter: "पैरामीटर",
    idealRange: "आदर्श सीमा",
    actualValue: "वास्तविक मान",
    status: "स्थिति",
    derivedParameters: "व्युत्पन्न पैरामीटर",

    // BODL Note
    note: "नोट",
    bodlLabel: "BODL (पता लगाने की सीमा से कम)",
    bodlDescription:
      "यह दर्शाता है कि पैरामीटर की सांद्रता परीक्षण विधि की न्यूनतम पता लगाने की सीमा से कम है। इसका यह आवश्यक रूप से मतलब नहीं है कि पैरामीटर पूरी तरह अनुपस्थित है.",
    
    // Table Headers - Detailed Insights
    fertilityRating: "उर्वरता रेटिंग",
    whatItMeans: "इसका क्या मतलब है?",
    functionInCropGrowth: "फसल वृद्धि में कार्य",
    
    // Nutrient Insights - Meanings
    phMeaning: "मिट्टी की अम्लता/क्षारीयता",
    ecMeaning: "मिट्टी में नमक का स्तर",
    ocMeaning: "मिट्टी में जैविक पदार्थ",
    nitrogenMeaning: "वृद्धि पोषक तत्व",
    phosphorusMeaning: "ऊर्जा स्थानांतरण",
    potassiumMeaning: "फल गुणवत्ता नियामक",
    sulphurMeaning: "प्रोटीन संश्लेषण",
    magnesiumMeaning: "क्लोरोफिल का केंद्र",
    calciumMeaning: "कोशिका शक्ति",
    zincMeaning: "वृद्धि हार्मोन समर्थन",
    ironMeaning: "क्लोरोफिल संश्लेषण",
    copperMeaning: "एंजाइम सक्रियक",
    boronMeaning: "परागण और फल सेट",
    
    // Nutrient Insights - Functions
    phFunction: "पोषक तत्व उपलब्धता और सूक्ष्मजीव गतिविधि को प्रभावित करता है",
    ecFunction: "जड़ में पानी के अवशोषण और पोषक घुलनशीलता को प्रभावित करता है",
    ocFunction: "सूक्ष्मजीव जीवन, संरचना और जल प्रतिधारण को बढ़ाता है",
    nitrogenFunction: "पत्तेदार वृद्धि और क्लोरोफिल निर्माण को बढ़ावा देता है",
    phosphorusFunction: "जड़ विकास और फूलों को समर्थन देता है",
    potassiumFunction: "पानी संतुलन, रोग प्रतिरोध, फल आकार में मदद करता है",
    sulphurFunction: "एंजाइम कार्य, तेल संश्लेषण और स्वाद में सुधार करता है",
    magnesiumFunction: "प्रकाश संश्लेषण और एंजाइम सक्रियता के लिए आवश्यक",
    calciumFunction: "मजबूत कोशिका दीवारें बनाता है, फूल गलन रोकता है",
    zincFunction: "एंजाइम सक्रियता, पत्ती विस्तार, जड़ों के लिए आवश्यक",
    ironFunction: "हरी पत्ती निर्माण और श्वसन का समर्थन करता है",
    copperFunction: "पराग व्यवहार्यता और रोग प्रतिरोध को प्रभावित करता है",
    boronFunction: "फूल, फल सेट, चीनी परिवहन और बीज निर्माण में सहायता करता है",
    
    // Derived Insights - Meanings
    cnRatioMeaning: "मिट्टी कार्बनिक कार्बन का उपलब्ध नाइट्रोजन से अनुपात",
    cecTendencyMeaning: "मिट्टी की पोषक तत्वों को पकड़ने और आदान-प्रदान करने की क्षमता (OC, Ca, Mg, K, pH पर आधारित)",
    caMgRatioMeaning: "मिट्टी में कैल्शियम और मैग्नीशियम स्तरों के बीच संतुलन",
    kMgRatioMeaning: "पोटैशियम और मैग्नीशियम उपलब्धता के बीच संतुलन",
    
    // Derived Insights - Functions
    cnRatioFunction: "जैविक पदार्थ की गुणवत्ता को इंगित करता है; सूक्ष्मजीव गतिविधि और नाइट्रोजन उपलब्धता को प्रभावित करता है",
    cecTendencyFunction: "जड़ में पानी के अवशोषण और पोषक घुलनशीलता को प्रभावित करता है",
    caMgRatioFunction: "मिट्टी की संरचना, वातन, पानी की गति और जड़ प्रवेश को प्रभावित करता है",
    kMgRatioFunction: "अवशोषण के लिए प्रतिस्पर्धा को नियंत्रित करता है; फल गुणवत्ता, तनाव सहनशीलता और पत्ती शक्ति को प्रभावित करता है",
    
    // Derived Indicators - Effects
    cnRatioLowEffect: "जैविक पदार्थ का तेजी से टूटना, नाइट्रेट रिसाव में वृद्धि",
    cnRatioHighEffect: "पोषक तत्व लॉक-अप, धीमी नाइट्रोजन खनिजीकरण",
    cecTendencyLowEffect: "खराब पोषक तत्व प्रतिधारण, रिसाव का अधिक जोखिम",
    cecTendencyHighEffect: "पोषक तत्व बहुत कसकर बंध सकते हैं",
    caMgRatioLowEffect: "मिट्टी का संघनन, खराब वातन, कम पानी घुसपैठ",
    caMgRatioHighEffect: "पोषक तत्व प्रतिपक्षता, विशेष रूप से Mg और K की कमी",
    kMgRatioLowEffect: "संभावित Mg अधिकता, फल परिपक्वता में देरी हो सकती है",
    kMgRatioHighEffect: "K, Mg को दबा देता है, कमजोर तने",
    
    // Nutrient Blocking
    phosphorusBlocks: "जिंक (Zn), आयरन (Fe), कॉपर (Cu)",
    potassiumBlocks: "मैग्नीशियम (Mg), कैल्शियम (Ca)",
    nitrogenBlocks: "कॉपर (Cu), बोरॉन (B)",
    
    // Table Headers - Fertilizer
    stage: "चरण",
    input: "इनपुट",
    dose: "खुराक",
    method: "विधि",
    
    // Table Headers - Derived Insights
    indicator: "संकेतक",
    condition: "स्थिति",
    imbalanceEffect: "असंतुलन प्रभाव",
    
    // Table Headers - Nutrient Blocking
    blockingTitle: "उर्वरक अनुप्रयोग के दौरान ध्यान रखने योग्य बातें",
    whenTooMuchOf: "जब बहुत अधिक हो...",
    itBlocks: "यह रोकता है...",
    
    // Table Headers - Crop Tips
    practice: "अभ्यास",
    why: "क्यों",
    
    // Status/Levels
    low: "कम",
    medium: "सामान्य",
    high: "उच्च",
    
    // Messages
    cropTipsNotAvailable: "फसल-विशिष्ट सुझाव उपलब्ध नहीं",
    cropTipsNotAvailableDesc: "हमारे पास \"{crop}\" के लिए खेती के सुझाव इस समय उपलब्ध नहीं हैं। कृपया बाद में जांचें या सहायता के लिए संपर्क करें।",
    availableCrops: "उपलब्ध फसलें",
    fertilizerNotAvailable: "उर्वरक सिफारिश उपलब्ध नहीं",
    fertilizerNotAvailableDesc: "हमारे पास आपकी मिट्टी के लिए उर्वरक सिफारिशें इस समय उपलब्ध नहीं हैं। कृपया बाद में जांचें या सहायता के लिए संपर्क करें।",
    
    // Derived Parameters Section
    derivedParametersSubtitle: "व्यापक विश्लेषण के लिए अतिरिक्त मिट्टी उर्वरता संकेतक।",
    
    // Notes
    phosphorusNote: "नोट: यह रिपोर्ट फास्फोरस मानों को P₂O₅ के रूप में व्यक्त करती है। P₂O₅ को तात्विक P में बदलने के लिए, मान को 0.436 से गुणा करें।",

    // Report Under Review
    underReviewHeading: "रिपोर्ट स्टेटस: जांच चल रही है",
    underReviewBody: "एक या अधिक रिजल्ट को वेरिफाई करने की जरूरत है। कृपया हमारी टेक्निकल सपोर्ट टीम से संपर्क करें। फाइनल रिपोर्ट जारी करने से पहले दोबारा टेस्ट करना पड़ सकता है।",

    warningUnderReview: "चेतावनी: इस रिपोर्ट में कुछ गड़बड़ियां हैं और अभी इसकी जाँच चल रही है। इसमें दिखाए गए रिज़ल्ट (परिणाम) पक्के नहीं हैं और गलत हो सकते हैं।\n\nक्या आप फिर भी इसे डाउनलोड करना चाहते हैं? (रुकने के लिए 'Cancel' दबाएं और गड़बड़ी ठीक कराने के लिए सपोर्ट से संपर्क करें)।",
    
    // Disclaimer
    disclaimer: "अस्वीकरण",
    disclaimerWithPartner: "यह मृदा परीक्षण रिपोर्ट Ekosight Technologies Private Limited और उसके अधिकृत सहयोगी [Partner Name] के सहयोग से तैयार की गई है। मिट्टी का परीक्षण, उसका विश्लेषण और रिपोर्ट में दिए गए परिणाम पूरी तरह से [Partner Name] द्वारा किए गए हैं। Ekosight Technologies केवल इस प्रक्रिया में उपयोग की जाने वाली तकनीक, उपकरण और विश्लेषण प्रणाली उपलब्ध कराता है, लेकिन रिपोर्ट में दिए गए प्रत्येक परिणाम का अलग से सत्यापन नहीं करता। रिपोर्ट में दिखाए गए सभी आंकड़ों और निष्कर्षों की जिम्मेदारी [Partner Name] की है। परिणाम केवल उसी नमूने के लिए मान्य हैं जो परीक्षण के लिए प्राप्त हुआ था, और जिन परिस्थितियों में परीक्षण किया गया। इस रिपोर्ट में दी गई सलाह या अनुशंसा केवल मार्गदर्शन के लिए है। खेत की वास्तविक स्थिति, मौसम, और अन्य कृषि कारक अंतिम परिणामों को प्रभावित कर सकते हैं।",
    disclaimerWithoutPartner: "यह मृदा परीक्षण रिपोर्ट Ekosight Technologies Private Limited द्वारा ग्राहक से प्राप्त नमूने और दी गई जानकारी के आधार पर तैयार और जारी की गई है। इस रिपोर्ट में प्रस्तुत परीक्षण, विश्लेषण और निष्कर्ष Ekosight की स्वामित्व वाली तकनीक, उपकरणों और विश्लेषणात्मक ढाँचे का उपयोग करके किए गए हैं। परिणामों की सटीकता और विश्वसनीयता सुनिश्चित करने के लिए हर संभव प्रयास किया गया है, परंतु ये परिणाम केवल प्राप्त किए गए नमूने की स्थिति और गुणवत्ता तक सीमित हैं। इस रिपोर्ट में दी गई सिफारिशें केवल मार्गदर्शन के उद्देश्य से हैं। वास्तविक परिणाम खेत की स्थिति, पर्यावरणीय परिस्थितियों, फसल प्रबंधन प्रथाओं और मौसमी कारकों के अनुसार भिन्न हो सकते हैं। Ekosight Technologies इस रिपोर्ट या इसकी सिफारिशों के उपयोग से उत्पन्न किसी भी प्रत्यक्ष, अप्रत्यक्ष या परिणामी हानि या निर्णय के लिए जिम्मेदार नहीं होगी। इस रिपोर्ट के किसी भी भाग का पुनरुत्पादन या व्यावसायिक / सार्वजनिक उपयोग Ekosight Technologies Private Limited की पूर्व लिखित अनुमति के बिना नहीं किया जा सकता।",
    waterDisclaimerTextWithPartner:
      "यह जल परीक्षण रिपोर्ट Ekosight Technologies Private Limited और इसके अधिकृत साझेदार [Partner Name] के सहयोग से तैयार की गई है। Ekosight Technologies Private Limited इस प्रक्रिया में उपयोग की गई परीक्षण तकनीक, उपकरण और विश्लेषण ढांचा प्रदान करता है, लेकिन साझेदार प्रयोगशाला या कर्मियों द्वारा किए गए व्यक्तिगत परीक्षण परिणामों का स्वतंत्र रूप से सत्यापन या पुष्टि नहीं करता है। अधिकृत साझेदार, ग्राहक द्वारा दिए गए जल नमूने के आधार पर परिणामों की सटीकता, विश्वसनीयता और व्याख्या की पूरी जिम्मेदारी लेता है। परीक्षण परिणाम केवल प्राप्त किए गए नमूने और परीक्षण के समय लागू परिस्थितियों के लिए ही मान्य हैं। इन परिणामों से निकाली गई सिफारिशें या व्याख्याएँ केवल सामान्य मार्गदर्शन के लिए हैं। वास्तविक जल गुणवत्ता और उसकी उपयुक्तता स्रोत की स्थिति, भंडारण, हैंडलिंग, मौसमी परिवर्तन और स्थान-विशेष पर्यावरणीय कारकों के कारण भिन्न हो सकती है।",
  },

  punjabi: {
    // Header
    inAssociationWith: "ਸਹਿਯੋਗ ਵਿੱਚ",
    
    // User Data Labels
    name: "ਨਾਂ",
    mobile: "ਮੋਬਾਈਲ",
    address: "ਪਤਾ",
    cityState: "ਸ਼ਹਿਰ/ਰਾਜ",
    previousCrop: "ਪਿਛਲੀ ਫਸਲ",
    farmSize: "ਖੇਤ ਦਾ ਆਕਾਰ",
    farmName: "ਖੇਤ ਦਾ ਨਾਮ",
    nextCrop: "ਅਗਲੀ ਫਸਲ",
    sampleCode: "ਨਮੂਨਾ ਕੋਡ",
    treatmentType: "ਇਲਾਜ ਦੀ ਕਿਸਮ",
    sampleType: "ਨਮੂਨਾ ਕਿਸਮ",
    
    // Section Titles
    section1Title: "ਮਿੱਟੀ ਵਿਸ਼ਲੇਸ਼ਣ ਸਾਰ",
    section1Subtitle: "ਇਹ ਉਹ ਹੈ ਜੋ ਅਸੀਂ ਤੁਹਾਡੇ ਮਿੱਟੀ ਦੇ ਨਮੂਨੇ ਵਿੱਚ ਟੈਸਟ ਕੀਤਾ।",
    section2Title: "ਵਿਸਥਾਰਿਤ ਪੋਸ਼ਣ ਜਾਣਕਾਰੀਆਂ",
    section2Subtitle: "ਹਰ ਟੈਸਟ ਕੀਤੇ ਪੈਰਾਮੀਟਰ ਵਿੱਚ ਡੂੰਘੀ ਜਾਣਕਾਰੀ।",
    section3Title: "ਉਰਵਰਕ ਸਿਫ਼ਾਰਸ਼",
    section3Subtitle: "ਇਹ ਪੰਨਾ ਤੁਹਾਨੂੰ ਦੱਸਦਾ ਹੈ ਕਿ ਕਿਹੜੇ ਉਰਵਰਕ ਵਰਤਣੇ ਹਨ, ਕਿੰਨਾ ਅਤੇ ਕਦੋਂ। ਇਸ ਯੋਜਨਾ ਦੀ ਪਾਲਣਾ ਕਰੋ।",
    section4Title: "ਨਿਕਲੀਆਂ ਜਾਣਕਾਰੀਆਂ ਅਤੇ ਪੋਸ਼ਣ ਸੰਤੁਲਨ",
    section4Subtitle: "ਇਹ ਸੈਕਸ਼ਨ ਹੋਰ ਡੂੰਘੀਆਂ ਜਾਣਕਾਰੀਆਂ ਦਿੰਦਾ ਹੈ। ਪੜ੍ਹਨਾ ਲਾਭਕਾਰੀ ਹੈ ਪਰ ਲਾਜ਼ਮੀ ਨਹੀਂ।",
    section5Title: "ਫਸਲ-ਵਿਸ਼ੇਸ਼ ਸੁਝਾਅ",
    section5Subtitle: "ਕاشت ਲਈ ਮਾਹਿਰ ਸੁਝਾਅ। ਬਿਹਤਰ ਨਤੀਜੇ ਲਈ ਇਹ ਅਮਲ ਕਰੋ।",

    //Water Report Section Title
    waterSection1Title: "ਪਾਣੀ ਵਿਸ਼ਲੇਸ਼ਣ ਸਾਰ",
    waterSection1Subtitle: "ਇਹ ਉਹ ਹੈ ਜੋ ਅਸੀਂ ਤੁਹਾਡੇ ਪਾਣੀ ਦੇ ਨਮੂਨੇ ਵਿੱਚ ਟੈਸਟ ਕੀਤਾ।",
    waterRecommendationTitle: "ਪਾਣੀ ਇਲਾਜ ਸਿਫਾਰਸ਼ਾਂ",
    waterRecommendationSubtitle: "ਤੁਹਾਡੇ ਪਾਣੀ ਦੀ ਗੁਣਵੱਤਾ ਲਈ ਸੁਝਾਏ ਗਏ ਸੁਧਾਰਾਤਮਕ ਉਪਾਅ",
    waterPerfect: "ਪਾਣੀ ਦੀ ਗੁਣਵੱਤਾ ਵਧੀਆ ਹੈ",
    waterPerfectDesc: "ਟੈਸਟ ਕੀਤੇ ਗਏ ਮਾਪਦੰਡਾਂ ਦੇ ਆਧਾਰ 'ਤੇ ਕਿਸੇ ਵੀ ਸੁਧਾਰਾਤਮਕ ਇਲਾਜ ਦੀ ਲੋੜ ਨਹੀਂ ਹੈ।",
    waterRecommendationNote: "ਨੋਟ: ਜੇਕਰ ਇੱਕੋ ਕਾਰਵਾਈ ਕਈ ਪੈਰਾਮੀਟਰਾਂ ਲਈ ਸੁਝਾਈ ਗਈ ਹੈ, ਤਾਂ ਇਸਨੂੰ ਵਾਰ-ਵਾਰ ਨਾ ਦੁਹਰਾਓ। ਇੱਕ ਹੀ ਅਭਿਆਸ ਆਮ ਤੌਰ 'ਤੇ ਕਈ ਪੈਰਾਮੀਟਰਾਂ ਵਿੱਚ ਸੁਧਾਰ ਕਰਦਾ ਹੈ, ਇਸ ਲਈ ਇੱਕ ਵਾਰ ਕਰਨਾ ਹੀ ਕਾਫੀ ਹੈ।",

    // Table Headers - Soil Analysis
    sNo: "ਕ੍ਰ. ਸ.",
    parameter: "ਪੈਰਾਮੀਟਰ",
    idealRange: "ਆਦਰਸ਼ ਸੀਮਾ",
    actualValue: "ਅਸਲ ਮਾਪ",
    status: "ਸਥਿਤੀ",
    derivedParameters: "ਨਿਕਲੇ ਹੋਏ ਪੈਰਾਮੀਟਰ",

    // BODL Note
    note: "ਨੋਟ",
    bodlLabel: "BODL (ਪਤਾ ਲਗਾਉਣ ਦੀ ਸੀਮਾ ਤੋਂ ਘੱਟ)",
    bodlDescription:
      "ਇਹ ਦਰਸਾਉਂਦਾ ਹੈ ਕਿ ਪੈਰਾਮੀਟਰ ਦੀ ਸੰਘਣਤਾ ਜਾਂਚ ਵਿਧੀ ਦੀ ਘੱਟੋ-ਘੱਟ ਪਤਾ ਲਗਾਉਣ ਦੀ ਸੀਮਾ ਤੋਂ ਘੱਟ ਹੈ। ਇਸਦਾ ਇਹ ਲਾਜ਼ਮੀ ਤੌਰ 'ਤੇ ਮਤਲਬ ਨਹੀਂ ਹੈ ਕਿ ਪੈਰਾਮੀਟਰ ਪੂਰੀ ਤਰ੍ਹਾਂ ਮੌਜੂਦ ਨਹੀਂ ਹੈ.",

    
    // Table Headers - Detailed Insights
    fertilityRating: "ਉਪਜਾਊ ਦਰਜਾ",
    whatItMeans: "ਇਸ ਦਾ ਕੀ ਮਤਲਬ ਹੈ?",
    functionInCropGrowth: "ਫਸਲ ਵਾਧ ਵਿੱਚ ਭੂਮਿਕਾ",
    
    // Nutrient Insights - Meanings
    phMeaning: "ਮਿੱਟੀ ਦੀ ਤੇਜ਼ਾਬੀ/ਖਾਰਾਪਣ",
    ecMeaning: "ਮਿੱਟੀ ਵਿੱਚ ਨਮਕ ਦਾ ਪੱਧਰ",
    ocMeaning: "ਮਿੱਟੀ ਵਿੱਚ ਜੈਵਿਕ ਪਦਾਰਥ",
    nitrogenMeaning: "ਵਿਕਾਸ ਪੋਸ਼ਕ ਤੱਤ",
    phosphorusMeaning: "ਊਰਜਾ ਟ੍ਰਾਂਸਫਰ",
    potassiumMeaning: "ਫਲ ਕੁਆਲਟੀ ਪ੍ਰਭਾਵਿਤ ਕਰਦਾ",
    sulphurMeaning: "ਪ੍ਰੋਟੀਨ ਬਣਨ ਵਿੱਚ ਮਦਦ",
    magnesiumMeaning: "ਕਲੋਰੀਫਿਲ ਦਾ ਕੇਂਦਰ",
    calciumMeaning: "ਕੋਸ਼ਿਕਾ ਮਜ਼ਬੂਤੀ",
    zincMeaning: "ਵਿਕਾਸ ਲਈ ਮਦਦਗਾਰ",
    ironMeaning: "ਕਲੋਰੀਫਿਲ ਬਣਾਉਣ ਵਿੱਚ ਸਹਾਇਕ",
    copperMeaning: "ਐਂਜ਼ਾਈਮ ਸਰਗਰਮੀ ਲਈ",
    boronMeaning: "ਪਰਾਗਣ ਅਤੇ ਫਲ ਸੈੱਟ ਲਈ",
    
    // Nutrient Insights - Functions
    phFunction: "ਪੋਸ਼ਕ ਤੱਤ ਦੀ ਉਪਲਬਧਤਾ ਅਤੇ ਸੂਖਮਜੀਵ ਕਿਰਿਆ ਨੂੰ ਪ੍ਰਭਾਵਿਤ ਕਰਦਾ ਹੈ",
    ecFunction: "ਜੜਾਂ ਦੁਆਰਾ ਪਾਣੀ ਦੀ ਸਿੱਖਣ ਅਤੇ ਪੋਸ਼ਕ ਤੱਤਾਂ ਦੀ ਘੁਲਨਸ਼ੀਲਤਾ ਪ੍ਰਭਾਵਿਤ ਕਰਦਾ ਹੈ",
    ocFunction: "ਸੂਖਮਜੀਵ ਜੀਵਨ, ਬਣਤਰ ਅਤੇ ਪਾਣੀ ਰੋਕਣ ਨੂੰ ਬਿਹਤਰ ਕਰਦਾ ਹੈ",
    nitrogenFunction: "ਪੱਤਿਆਂ ਦੀ ਵਾਧ ਅਤੇ ਕਲੋਰੀਫਿਲ ਬਣਾਉਂਦਾ ਹੈ",
    phosphorusFunction: "ਜੜਾਂ ਵਿਕਾਸ ਅਤੇ ਫੁੱਲਾਂ ਲਈ ਸਹਾਇਕ ਹੈ",
    potassiumFunction: "ਪਾਣੀ ਸੰਤੁਲਨ, ਰੋਗ-ਰੋਕਥਾਮ ਅਤੇ ਫਲ ਦੇ ਆਕਾਰ ਵਿੱਚ ਸਹਾਇਤਾ ਕਰਦਾ ਹੈ",
    sulphurFunction: "ਐਂਜ਼ਾਈਮ ਕਾਰਜ, ਤੇਲ ਸੰਸ਼ਲੇਸ਼ਣ ਅਤੇ ਸਵਾਦ ਵਿੱਚ ਸੁਧਾਰ",
    magnesiumFunction: "ਫੋਟੋਸਿੰਥੇਸਿਸ ਅਤੇ ਐਂਜ਼ਾਈਮ ਸਰਗਰਮੀ ਲਈ ਜ਼ਰੂਰੀ",
    calciumFunction: "ਮਜ਼ਬੂਤ ਕੋਸ਼ਿਕਾ ਦੀਆਂ diwarਾਂ ਬਣਾਉਂਦਾ ਹੈ",
    zincFunction: "ਐਂਜ਼ਾਈਮ ਸਰਗਰਮੀ ਅਤੇ ਪੱਤੀ ਵਿਸ਼ਾਲਤਾ ਲਈ ਜ਼ਰੂਰੀ",
    ironFunction: "ਹਰੀ ਪੱਤੀ ਬਣਤਰ ਅਤੇ ਸਾਸ ਲੈਣ ਵਿੱਚ ਸਹਾਇਤਾ ਕਰਦਾ ਹੈ",
    copperFunction: "ਪਰਾਗ ਪ੍ਰਜਨਣ ਅਤੇ ਰੋਗ ਸਹਿਣਸ਼ੀਲਤਾ ਪ੍ਰਭਾਵਿਤ ਕਰਦਾ ਹੈ",
    boronFunction: "ਫੁੱਲਾਂ, ਫਲ ਸੈੱਟ ਅਤੇ ਬੀਜ ਬਣਾਉਣ ਵਿੱਚ ਮਦਦ ਕਰਦਾ ਹੈ",
    
    // Derived Insights - Meanings
    cnRatioMeaning: "ਮਿੱਟੀ ਦੇ ਜੈਵਿਕ ਕਾਰਬਨ ਦਾ ਉਪਲਬਧ ਨਾਈਟ੍ਰੋਜਨ ਨਾਲ ਅਨੁਪਾਤ",
    cecTendencyMeaning: "ਮਿੱਟੀ ਦੀ ਪੋਸ਼ਕ ਰਖਣ ਅਤੇ ਬਦਲਣ ਦੀ ਸਮਰੱਥਾ (OC, Ca, Mg, K, pH ਆਧਾਰ)",
    caMgRatioMeaning: "ਕੈਲਸ਼ਿਅਮ ਅਤੇ ਮੈਗਨੀਸ਼ੀਅਮ ਦੀ ਸੰਤੁਲਨ",
    kMgRatioMeaning: "ਪੋਟੈਸ਼ਿਯਮ ਅਤੇ ਮੈਗਨੀਸ਼ੀਅਮ ਦੀ ਉਪਲਬਧਤਾ ਵਿੱਚ ਸੰਤੁਲਨ",
    
    // Derived Insights - Functions
    cnRatioFunction: "ਜੈਵਿਕ ਪਦਾਰਥ ਦੀ ਗੁਣਵੱਤਾ ਦਿਖਾਉਂਦਾ; ਸੂਖਮਜੀਵ ਕਿਰਿਆ ਅਤੇ ਨਾਈਟ੍ਰੋਜਨ ਉਪਲਬਧਤਾ ਪ੍ਰਭਾਵਿਤ ਕਰਦਾ ਹੈ",
    cecTendencyFunction: "ਜੜਾਂ ਦੁਆਰਾ ਪਾਣੀ ਲੈਣਾ ਅਤੇ ਪੋਸ਼ਕ ਤੱਤਾਂ ਦੀ ਘੁਲਨਸ਼ੀਲਤਾ ਪ੍ਰਭਾਵਿਤ ਕਰਦਾ ਹੈ",
    caMgRatioFunction: "ਮਿੱਟੀ ਦੀ ਬਣਤਰ, ਹਵਾ ਅਤੇ ਪਾਣੀ ਦੀ ਚਲਣ ਅਤੇ ਜੜਾਂ ਦੀ ਦਰਜਣ ਪ੍ਰਭਾਵਿਤ ਕਰਦਾ ਹੈ",
    kMgRatioFunction: "ਉਪਲਬਧਤਾ ਲਈ ਮੁਕਾਬਲਾ ਨਿਯੰਤ੍ਰਿਤ ਕਰਦਾ; ਫਲ ਦੀ ਕੁਆਲਟੀ ਅਤੇ ਪੱਤੀ ਤਾਕਤ ਪ੍ਰਭਾਵਿਤ ਹੋ ਸਕਦੀ ਹੈ",
    
    // Derived Indicators - Effects
    cnRatioLowEffect: "ਜੈਵਿਕ ਪਦਾਰਥ ਤੇਜ਼ੀ ਨਾਲ ਟੁੱਟਦਾ, ਨਾਈਟਰੇਟ ਰਿਸ਼ਾਵ ਵੱਧ ਸਕਦਾ ਹੈ",
    cnRatioHighEffect: "ਪੋਸ਼ਕ ਤੱਤ ਲੌਕ-ਅੱਪ, ਨਾਈਟ੍ਰੋਜਨ ਮਿਨਰਲਾਈਜੇਸ਼ਨ ਧੀਮੀ",
    cecTendencyLowEffect: "ਖਰਾਬ ਪੋਸ਼ਕ ਰਖਣ, ਰਿਸ਼ਾਵ ਦਾ ਖਤਰਾ ਵੱਧ",
    cecTendencyHighEffect: "ਪੋਸ਼ਕ ਤੱਤ ਬਹੁਤ ਜ਼ਿਆਦਾ ਬੰਨ੍ਹ ਸਕਦੇ ਹਨ",
    caMgRatioLowEffect: "ਮਿੱਟੀ ਸਖ਼ਤ, ਘੱਟ ਹਵਾ, ਪਾਣੀ ਸੁਕੀਉਂਦਾ ਘੱਟ",
    caMgRatioHighEffect: "ਪੋਸ਼ਕ ਤੱਤ ਦੇ ਪਰਤਿਸpardita, ਵਿਸ਼ੇਸ਼ ਤੌਰ ਤੇ Mg ਅਤੇ K ਦੀ ਕਮੀ",
    kMgRatioLowEffect: "ਸੰਭਵ Mg ਵੱਧ, ਫਲ ਪੱਕਣ ਵਿੱਚ ਦੇਰੀ",
    kMgRatioHighEffect: "K Mg ਦੇ ਅਵਸ਼ੋਸ਼ਣ ਨੂੰ ਘਟਾਉਂਦਾ, ਡਾਲ਼ੇ ਕਮਜ਼ੋਰ",
    
    // Nutrient Blocking
    phosphorusBlocks: "ਜ਼ਿੰਕ (Zn), ਲੋਹਾ (Fe), ਤੇ ਤੰਬਾ (Cu)",
    potassiumBlocks: "ਮੈਗਨੀਸ਼ੀਅਮ (Mg), ਕੈਲਸ਼ਿਅਮ (Ca)",
    nitrogenBlocks: "ਤੰਬਾ (Cu), ਬੋਰੋਨ (B)",
    
    // Table Headers - Fertilizer
    stage: "ਚਰਨ",
    input: "ਇਨਪੁਟ",
    dose: "ਖੁਰਾਕ",
    method: "ਤਰੀਕਾ",
    
    // Table Headers - Derived Insights
    indicator: "ਸੂਚਕ",
    condition: "ਹਾਲਤ",
    imbalanceEffect: "ਅਸੰਤੁਲਨ ਪ੍ਰਭਾਵ",
    
    // Table Headers - Nutrient Blocking
    blockingTitle: "ਉਰਵਰਕ ਲਗਾਉਣ ਦੌਰਾਨ ਧਿਆਨ ਰੱਖਣ ਵਾਲੀਆਂ ਗੱਲਾਂ",
    whenTooMuchOf: "ਜਦੋਂ ਵੱਧ ਹੋਵੇ...",
    itBlocks: "ਇਹ ਰੋਕਦਾ ਹੈ...",
    
    // Table Headers - Crop Tips
    practice: "ਅਭਿਆਸ",
    why: "ਕਿਉਂ",
    
    // Status/Levels
    low: "ਘੱਟ",
    medium: "ਆਮ",
    high: "ਉੱਚ",
    
    // Messages
    cropTipsNotAvailable: "ਫਸਲ-ਵਿਸ਼ੇਸ਼ ਸੁਝਾਅ ਉਪਲਬਧ ਨਹੀਂ ਹਨ",
    cropTipsNotAvailableDesc: "ਸਾਡੇ ਕੋਲ \"{crop}\" ਲਈ ਕਿਰਤੀ ਟਿੱਪਣੀਆਂ ਅਜੇ ਉਪਲਬਧ ਨਹੀਂ ਹਨ। ਕ੍ਰਿਪਾ ਬਾਅਦ ਵਿੱਚ ਚੈੱਕ ਕਰੋ ਜਾਂ ਸਹਾਇਤਾ ਲਈ ਸੰਪਰਕ ਕਰੋ।",
    availableCrops: "ਉਪਲਬਧ ਫਸਲਾਂ",
    fertilizerNotAvailable: "ਉਰਵਰਕ ਸਿਫ਼ਾਰਸ਼ ਉਪਲਬਧ ਨਹੀਂ",
    fertilizerNotAvailableDesc: "ਸਾਡੇ ਕੋਲ ਇਸ ਸਮੇਂ ਤੁਹਾਡੀ ਮਿੱਟੀ ਲਈ ਉਰਵਰਕ ਸਿਫ਼ਾਰਸ਼ ਉਪਲਬਧ ਨਹੀਂ ਹਨ। ਕ੍ਰਿਪਾ ਬਾਅਦ ਵਿੱਚ ਚੈੱਕ ਕਰੋ ਜਾਂ ਸਹਾਇਤਾ ਲਈ ਸੰਪਰਕ ਕਰੋ।",
    
    // Derived Parameters Section
    derivedParametersSubtitle: "ਵਿਆਪਕ ਵਿਸ਼ਲੇਸ਼ਣ ਲਈ ਵਾਧੂ ਮਿੱਟੀ ਉਪਜਾਊ ਸੰਕੇਤ।",
    
    // Notes
    phosphorusNote: "ਨੋਟ: ਇਸ ਰਿਪੋਰਟ ਵਿੱਚ ਫਾਸਫੋਰਸ ਦੇ ਮੁੱਲ P₂O₅ ਵਜੋਂ ਦਰਸਾਏ ਗਏ ਹਨ। P₂O₅ ਨੂੰ ਤੱਤਕ P ਵਿੱਚ ਬਦਲਣ ਲਈ, ਮੁੱਲ ਨੂੰ 0.436 ਨਾਲ ਗੁਣਾ ਕਰੋ।",

    // Report Under Review
    underReviewHeading: "ਰਿਪੋਰਟ ਸਟੇਟਸ: ਜਾਂਚ ਚੱਲ ਰਹੀ ਹੈ",
    underReviewBody: "ਇੱਕ ਜਾਂ ਇੱਕ ਤੋਂ ਵੱਧ ਰਿਜ਼ਲਟ ਨੂੰ ਵੈਰੀਫਾਈ ਕਰਨ ਦੀ ਲੋੜ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਸਾਡੀ ਟੈਕਨੀਕਲ ਸਪੋਰਟ ਟੀਮ ਨਾਲ ਸੰਪਰਕ ਕਰੋ। ਫਾਈਨਲ ਰਿਪੋਰਟ ਜਾਰੀ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਦੁਬਾਰਾ ਟੈਸਟ ਕਰਨਾ ਪੈ ਸਕਦਾ ਹੈ।",

    warningUnderReview: "ਚੇਤਾਵਨੀ: ਇਸ ਰਿਪੋਰਟ ਵਿੱਚ ਕੁਝ ਗਲਤੀਆਂ ਹਨ ਅਤੇ ਅਜੇ ਇਸਦੀ ਜਾਂਚ ਚੱਲ ਰਹੀ ਹੈ। ਦਿਖਾਏ ਗਏ ਨਤੀਜੇ ਪੱਕੇ ਨਹੀਂ ਹਨ ਅਤੇ ਗਲਤ ਹੋ ਸਕਦੇ ਹਨ।\n\nਕੀ ਤੁਸੀਂ ਫਿਰ ਵੀ ਇਸਨੂੰ ਡਾਊਨਲੋਡ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ? (ਰੁਕਣ ਲਈ 'Cancel' ਦਬਾਓ ਅਤੇ ਗਲਤੀ ਠੀਕ ਕਰਵਾਉਣ ਲਈ ਸਪੋਰਟ ਨਾਲ ਸੰਪਰਕ ਕਰੋ)।",
    
    // Disclaimer
    disclaimer: "ਅਸਵੀਕਾਰ",
    disclaimerWithPartner: "ਇਹ ਮਿੱਟੀ ਟੈਸਟ ਰਿਪੋਰਟ Ekosight Technologies Private Limited ਅਤੇ ਉਸਦੇ ਅਧਿਕ੍ਰਿਤ ਭਾਗੀਦਾਰ [Partner Name] ਦੇ ਸਹਿਯੋਗ ਨਾਲ ਤਿਆਰ ਕੀਤੀ ਗਈ ਹੈ। [Partner Name] ਮਿੱਟੀ ਟੈਸਟ ਕਰਨ, ਵਿਸ਼ਲੇਸ਼ਣ ਕਰਨ ਅਤੇ ਰਿਪੋਰਟ ਵਿੱਚ ਦਿੱਤੇ ਨਤੀਜੇ ਪ੍ਰਦਾਨ ਕਰਨ ਦੇ ਲਈ ਪੂਰੀ ਜ਼ਿੰਮੇਵਾਰੀ ਲੈਂਦਾ ਹੈ। Ekosight Technologies ਸਿਰਫ ਇਸ ਪ੍ਰਕਿਰਿਆ ਵਿੱਚ ਵਰਤੇ ਗਏ ਤਕਨਾਲੋਜੀ, ਉਪਕਰਨ ਅਤੇ ਵਿਸ਼ਲੇਸ਼ਣਿਕ ਢਾਂਚੇ ਪ੍ਰਦਾਨ ਕਰਦਾ ਹੈ ਅਤੇ ਹਰੇਕ ਨਤੀਜੇ ਦੀ ਅਲੱਗ ਜਾਂਚ ਨਹੀਂ ਕਰਦਾ।",
    disclaimerWithoutPartner: "ਇਹ ਮਿੱਟੀ ਟੈਸਟ ਰਿਪੋਰਟ Ekosight Technologies Private Limited ਵੱਲੋਂ ਗ੍ਰਾਹਕ ਤੋਂ ਪ੍ਰਾਪਤ ਨਮੂਨੇ ਅਤੇ ਦਿੱਤੀ ਜਾਣਕਾਰੀ ਦੇ ਆਧਾਰ ਤੇ ਤਿਆਰ ਕੀਤੀ ਗਈ ਹੈ। ਰਿਪੋਰਟ ਵਿੱਚ ਦਿੱਤੇ ਨਤੀਜੇ ਅਤੇ ਸੁਝਾਅ ਕੇਵਲ ਮਦਦ ਲਈ ਹਨ; ਖੇਤ ਦੀ ਹਕੀਕਤ, ਮੌਸਮੀ ਹਾਲਾਤ ਅਤੇ ਖੇਤੀ ਦੇ ਤਰੀਕੇ ਨਤੀਜਿਆਂ 'ਤੇ ਅਸਰ ਪਾ ਸਕਦੇ ਹਨ। Ekosight Technologies ਇਸ ਰਿਪੋਰਟ ਜਾਂ ਇਸ ਦੀਆਂ ਸਿਫ਼ਾਰਸ਼ਾਂ ਦੇ ਉਪਯੋਗ ਨਾਲ ਹੋਣ ਵਾਲੀ ਕਿਸੇ ਵੀ ਨੁਕਸਾਨ ਲਈ ਜ਼ਿੰਮੇਵਾਰ ਨਹੀਂ ਹੋਵੇਗਾ।",
    disclaimerText: "ਨਤੀਜੇ ਸਿਰਫ ਪ੍ਰਾਪਤ ਨਮੂਨੇ ਅਤੇ ਗਾਹਕ ਦੁਆਰਾ ਦਿੱਤੀ ਜਾਣਕਾਰੀ ਨਾਲ ਸੰਬੰਧਤ ਹਨ। Ekosight ਪ੍ਰਯੋਗਸ਼ਾਲਾ ਨੂੰ ਨਮੂਨੇ ਪ੍ਰਾਪਤ ਹੋਣ ਤੋਂ ਪਹਿਲਾਂ ਨਮੂਨੇ ਦੀ ਉਤਪੱਤੀ, ਤਬਦੀਲੀ ਜਾਂ ਗੁਣਵੱਤਾ ਲਈ ਕੋਈ ਜ਼ਿੰਮੇਵਾਰੀ ਨਹੀਂ ਲੈਂਦਾ, ਜਿਸ ਨਾਲ ਨਤੀਜਿਆਂ ਦੀ ਗੁਣਵੱਤਾ ਜਾਂ ਸਹੀਤਾ ਪ੍ਰਭਾਵਿਤ ਹੋ ਸਕਦੀ ਹੈ। ਕਿਸੇ ਵੀ ਕਾਰਵਾਈ ਨੂੰ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਤੁਹਾਨੂੰ ਸਚੇਤ ਰਹਿਣਾ ਚਾਹੀਦਾ ਹੈ ਅਤੇ Ekosight ਕਿਸੇ ਵੀ ਆਰਥਿਕ ਨੁਕਸਾਨ ਲਈ ਜ਼ਿੰਮੇਵਾਰ ਨਹੀਂ ਹੋਵੇਗਾ।",
    waterDisclaimerTextWithPartner:
      "ਇਹ ਪਾਣੀ ਜਾਂਚ ਰਿਪੋਰਟ Ekosight Technologies Private Limited ਅਤੇ ਇਸ ਦੇ ਅਧਿਕ੍ਰਿਤ ਭਾਗੀਦਾਰ [Partner Name] ਦੇ ਸਹਿਯੋਗ ਨਾਲ ਤਿਆਰ ਕੀਤੀ ਗਈ ਹੈ। Ekosight Technologies Private Limited ਇਸ ਪ੍ਰਕਿਰਿਆ ਵਿੱਚ ਵਰਤੀ ਗਈ ਜਾਂਚ ਤਕਨਾਲੋਜੀ, ਸੰਦ ਅਤੇ ਵਿਸ਼ਲੇਸ਼ਣ ਢਾਂਚਾ ਪ੍ਰਦਾਨ ਕਰਦਾ ਹੈ, ਪਰ ਭਾਗੀਦਾਰ ਲੈਬੋਰਟਰੀ ਜਾਂ ਕਰਮਚਾਰੀਆਂ ਵੱਲੋਂ ਤਿਆਰ ਕੀਤੇ ਗਏ ਵਿਅਕਤੀਗਤ ਜਾਂਚ ਨਤੀਜਿਆਂ ਦੀ ਸੁਤੰਤਰ ਤੌਰ ’ਤੇ ਪੁਸ਼ਟੀ ਜਾਂ ਪ੍ਰਮਾਣਿਕਤਾ ਨਹੀਂ ਕਰਦਾ। ਅਧਿਕ੍ਰਿਤ ਭਾਗੀਦਾਰ ਗਾਹਕ ਵੱਲੋਂ ਦਿੱਤੇ ਗਏ ਪਾਣੀ ਦੇ ਨਮੂਨੇ ਦੇ ਆਧਾਰ ’ਤੇ ਨਤੀਜਿਆਂ ਦੀ ਸਹੀਤਾ, ਭਰੋਸੇਯੋਗਤਾ ਅਤੇ ਵਿਆਖਿਆ ਦੀ ਪੂਰੀ ਜ਼ਿੰਮੇਵਾਰੀ ਲੈਂਦਾ ਹੈ। ਜਾਂਚ ਨਤੀਜੇ ਕੇਵਲ ਪ੍ਰਾਪਤ ਕੀਤੇ ਗਏ ਨਮੂਨੇ ਅਤੇ ਜਾਂਚ ਸਮੇਂ ਲਾਗੂ ਕੀਤੀਆਂ ਗਈਆਂ ਖਾਸ ਸਥਿਤੀਆਂ ਲਈ ਹੀ ਵੈਧ ਹਨ। ਇਨ੍ਹਾਂ ਨਤੀਜਿਆਂ ਤੋਂ ਨਿਕਲੇ ਸੁਝਾਅ ਜਾਂ ਵਿਆਖਿਆਵਾਂ ਸਿਰਫ਼ ਆਮ ਮਾਰਗਦਰਸ਼ਨ ਲਈ ਹਨ। ਅਸਲ ਪਾਣੀ ਦੀ ਗੁਣਵੱਤਾ ਅਤੇ ਇਸ ਦੀ ਉਪਯੋਗਤਾ ਸਰੋਤ ਦੀ ਹਾਲਤ, ਭੰਡਾਰਣ, ਸੰਭਾਲ, ਮੌਸਮੀ ਤਬਦੀਲੀਆਂ ਅਤੇ ਸਥਾਨ-ਵਿਸ਼ੇਸ਼ ਵਾਤਾਵਰਣੀ ਕਾਰਕਾਂ ਕਾਰਨ ਵੱਖ-ਵੱਖ ਹੋ ਸਕਦੀ ਹੈ।",
  },

  kannada: {
    // Header
    inAssociationWith: "ಜೊತೆಗೂಡಿ",

    // User Data Labels
    name: "ಹೆಸರು",
    mobile: "ಮೊಬೈಲ್",
    address: "ವಿಳಾಸ",
    cityState: "ನಗರ/ರಾಜ್ಯ",
    previousCrop: "ಹಿಂದಿನ ಬೆಳೆ",
    farmSize: "ಜಮೀನಿನ ಗಾತ್ರ",
    farmName: "ಜಮೀನಿನ ಹೆಸರು",
    nextCrop: "ಮುಂದಿನ ಬೆಳೆ",
    sampleCode: "ಮಾದರಿ ಕೋಡ್",
    treatmentType: "ಚಿಕಿತ್ಸೆಯ ವಿಧ",
    sampleType: "ಮಾದರಿ ವಿಧ",
    reportDate: "ದಿನಾಂಕ",

    // Section Titles
    section1Title: "ಮಣ್ಣು ವಿಶ್ಲೇಷಣೆ ಸಾರಾಂಶ",
    section1Subtitle: "ನಿಮ್ಮ ಮಣ್ಣಿನ ಮಾದರಿಯಲ್ಲಿ ನಾವು ಏನು ಪರೀಕ್ಷಿಸಿದ್ದೇವೆ.",
    section2Title: "ವಿವರವಾದ ಪೋಷಕಾಂಶ ಮಾಹಿತಿ",
    section2Subtitle: "ಪ್ರತಿ ಪರೀಕ್ಷಿತ ನಿಯತಾಂಕದ ಆಳವಾದ ಅಧ್ಯಯನ.",
    section3Title: "ರಸಗೊಬ್ಬರ ಶಿಫಾರಸು",
    section3Subtitle: "ಈ ಪುಟ ನಿಮಗೆ ಯಾವ ರಸಗೊಬ್ಬರ ಬಳಸಬೇಕು, ಎಷ್ಟು ಮತ್ತು ಯಾವಾಗ ಎಂದು ತಿಳಿಸುತ್ತದೆ. ಈ ಯೋಜನೆ ಅನುಸರಿಸಿ.",
    section4Title: "ವ್ಯುತ್ಪನ್ನ ಒಳನೋಟಗಳು ಮತ್ತು ಪೋಷಕ ಸಮತೋಲನ",
    section4Subtitle: "ಈ ವಿಭಾಗ ಆಳವಾದ ಒಳನೋಟಗಳನ್ನು ನೀಡುತ್ತದೆ. ಉಪಯುಕ್ತ ಆದರೆ ಕಡ್ಡಾಯವಲ್ಲ.",
    section5Title: "ಬೆಳೆ-ನಿರ್ದಿಷ್ಟ ಸಲಹೆಗಳು",
    section5Subtitle: "ಕೃಷಿಗಾಗಿ ತಜ್ಞರ ಸಲಹೆಗಳು. ಉತ್ತಮ ಫಲಿತಾಂಶಗಳಿಗಾಗಿ ಈ ಅಭ್ಯಾಸಗಳನ್ನು ಅನುಸರಿಸಿ.",

    // Water Report Section Title
    waterSection1Title: "ನೀರಿನ ವಿಶ್ಲೇಷಣೆ ಸಾರಾಂಶ",
    waterSection1Subtitle: "ನಿಮ್ಮ ನೀರಿನ ಮಾದರಿಯಲ್ಲಿ ನಾವು ಏನು ಪರೀಕ್ಷಿಸಿದ್ದೇವೆ.",
    waterRecommendationTitle: "ನೀರಿನ ಚಿಕಿತ್ಸಾ ಶಿಫಾರಸುಗಳು",
    waterRecommendationSubtitle: "ನಿಮ್ಮ ನೀರಿನ ಗುಣಮಟ್ಟಕ್ಕೆ ಶಿಫಾರಸು ಮಾಡಿದ ತಿದ್ದುಪಡಿ ಕ್ರಮಗಳು",
    waterPerfect: "ನೀರಿನ ಗುಣಮಟ್ಟ ಅತ್ಯುತ್ತಮವಾಗಿದೆ",
    waterPerfectDesc: "ಪರೀಕ್ಷಿಸಲಾದ ಮಾನದಂಡಗಳ ಆಧಾರದ ಮೇಲೆ ಯಾವುದೇ ತಿದ್ದುಪಡಿ ಚಿಕಿತ್ಸೆಯ ಅಗತ್ಯವಿಲ್ಲ.",
    waterRecommendationNote: "ಸೂಚನೆ: ಒಂದೇ ಕ್ರಮವನ್ನು ಹಲವು ಪರಿಮಾಣಗಳಿಗೆ ಶಿಫಾರಸು ಮಾಡಿದರೆ ಅದನ್ನು ಮರುಮರು ಮಾಡುವುದನ್ನು ತಪ್ಪಿಸಿ. ಒಂದು ಕ್ರಮವು ಹಲವಾರು ಪರಿಮಾಣಗಳನ್ನು ಸುಧಾರಿಸುತ್ತದೆ, ಆದ್ದರಿಂದ ಒಂದೇ ಬಾರಿ ಮಾಡುವುದು ಸಾಕು.",

    // Table Headers - Soil Analysis
    sNo: "ಕ್ರ.ಸಂ.",
    parameter: "ನಿಯತಾಂಕ",
    idealRange: "ಆದರ್ಶ ಶ್ರೇಣಿ",
    actualValue: "ನಿಜವಾದ ಮೌಲ್ಯ",
    status: "ಸ್ಥಿತಿ",
    derivedParameters: "ವ್ಯುತ್ಪನ್ನ ನಿಯತಾಂಕಗಳು",

    //BODL Note
    note: "ಸೂಚನೆ",
    bodlLabel: "BODL (ಪತ್ತೆಹಚ್ಚುವಿಕೆಯ ಮಿತಿಗಿಂತ ಕಡಿಮೆ)",
    bodlDescription:
      "ಪರೀಕ್ಷಾ ವಿಧಾನದಲ್ಲಿ ಪತ್ತೆಹಚ್ಚಬಹುದಾದ ಕನಿಷ್ಠ ಮಿತಿಗಿಂತ ಪ್ಯಾರಾಮೀಟರ್‌ನ ಸಾಂದ್ರತೆ ಕಡಿಮೆಯಾಗಿದೆ ಎಂಬುದನ್ನು ಇದು ಸೂಚಿಸುತ್ತದೆ. ಪ್ಯಾರಾಮೀಟರ್ ಸಂಪೂರ್ಣವಾಗಿ ಇಲ್ಲ ಎಂದರ್ಥವಲ್ಲ.",

    // Table Headers - Detailed Insights
    fertilityRating: "ಫಲವತ್ತತೆ ರೇಟಿಂಗ್",
    whatItMeans: "ಇದರ ಅರ್ಥವೇನು?",
    functionInCropGrowth: "ಬೆಳೆ ಬೆಳವಣಿಗೆಯಲ್ಲಿ ಕಾರ್ಯ",

    // Nutrient Insights - Meanings
    phMeaning: "ಮಣ್ಣಿನ ಆಮ್ಲೀಯತೆ/ಕ್ಷಾರೀಯತೆ",
    ecMeaning: "ಮಣ್ಣಿನಲ್ಲಿ ಉಪ್ಪಿನ ಮಟ್ಟ",
    ocMeaning: "ಮಣ್ಣಿನ ಸಾವಯವ ಪದಾರ್ಥ",
    nitrogenMeaning: "ಬೆಳವಣಿಗೆ ಪೋಷಕಾಂಶ",
    phosphorusMeaning: "ಶಕ್ತಿ ವರ್ಗಾವಣೆ",
    potassiumMeaning: "ಹಣ್ಣಿನ ಗುಣಮಟ್ಟ ನಿಯಂತ್ರಕ",
    sulphurMeaning: "ಪ್ರೋಟೀನ್ ಸಂಶ್ಲೇಷಣೆ",
    magnesiumMeaning: "ಕ್ಲೋರೊಫಿಲ್‌ನ ಕೇಂದ್ರ",
    calciumMeaning: "ಕೋಶ ಶಕ್ತಿ",
    zincMeaning: "ಬೆಳವಣಿಗೆ ಹಾರ್ಮೋನ್ ಬೆಂಬಲ",
    ironMeaning: "ಕ್ಲೋರೊಫಿಲ್ ಸಂಶ್ಲೇಷಣೆ",
    copperMeaning: "ಎಂಜೈಮ್ ಸಕ್ರಿಯಕ",
    boronMeaning: "ಪರಾಗಸ್ಪರ್ಶ ಮತ್ತು ಹಣ್ಣು ಕಟ್ಟುವಿಕೆ",

    // Nutrient Insights - Functions
    phFunction: "ಪೋಷಕಾಂಶ ಲಭ್ಯತೆ ಮತ್ತು ಸೂಕ್ಷ್ಮಜೀವಿ ಚಟುವಟಿಕೆಯ ಮೇಲೆ ಪರಿಣಾಮ ಬೀರುತ್ತದೆ",
    ecFunction: "ಬೇರಿನ ನೀರು ಹೀರಿಕೊಳ್ಳುವಿಕೆ ಮತ್ತು ಪೋಷಕ ಕರಗುವಿಕೆಯ ಮೇಲೆ ಪ್ರಭಾವ ಬೀರುತ್ತದೆ",
    ocFunction: "ಸೂಕ್ಷ್ಮಜೀವಿ ಜೀವನ, ರಚನೆ ಮತ್ತು ನೀರು ಧಾರಣವನ್ನು ಹೆಚ್ಚಿಸುತ್ತದೆ",
    nitrogenFunction: "ಎಲೆಗಳ ಬೆಳವಣಿಗೆ ಮತ್ತು ಕ್ಲೋರೊಫಿಲ್ ರಚನೆಯನ್ನು ಉತ್ತೇಜಿಸುತ್ತದೆ",
    phosphorusFunction: "ಬೇರಿನ ಬೆಳವಣಿಗೆ ಮತ್ತು ಹೂ ಬಿಡುವಿಕೆಗೆ ಬೆಂಬಲ ನೀಡುತ್ತದೆ",
    potassiumFunction: "ನೀರಿನ ಸಮತೋಲನ, ರೋಗ ನಿರೋಧಕ, ಹಣ್ಣಿನ ಗಾತ್ರದಲ್ಲಿ ಸಹಾಯ ಮಾಡುತ್ತದೆ",
    sulphurFunction: "ಎಂಜೈಮ್ ಕಾರ್ಯ, ಎಣ್ಣೆ ಸಂಶ್ಲೇಷಣೆ ಮತ್ತು ರುಚಿ ಸುಧಾರಿಸುತ್ತದೆ",
    magnesiumFunction: "ದ್ಯುತಿಸಂಶ್ಲೇಷಣೆ ಮತ್ತು ಎಂಜೈಮ್ ಸಕ್ರಿಯತೆಗೆ ಅಗತ್ಯ",
    calciumFunction: "ಬಲವಾದ ಕೋಶ ಗೋಡೆಗಳನ್ನು ನಿರ್ಮಿಸುತ್ತದೆ, ಹೂ ಕೊಳೆಯುವುದನ್ನು ತಡೆಯುತ್ತದೆ",
    zincFunction: "ಎಂಜೈಮ್ ಸಕ್ರಿಯತೆ, ಎಲೆ ವಿಸ್ತರಣೆ, ಬೇರೂರುವಿಕೆಗೆ ಅಗತ್ಯ",
    ironFunction: "ಹಸಿರು ಎಲೆ ರಚನೆ ಮತ್ತು ಉಸಿರಾಟವನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ",
    copperFunction: "ಪರಾಗ ಕಾರ್ಯಕ್ಷಮತೆ ಮತ್ತು ರೋಗ ನಿರೋಧಕದ ಮೇಲೆ ಪ್ರಭಾವ ಬೀರುತ್ತದೆ",
    boronFunction: "ಹೂ ಬಿಡುವಿಕೆ, ಹಣ್ಣು ಕಟ್ಟುವಿಕೆ, ಸಕ್ಕರೆ ಸಾಗಾಟ ಮತ್ತು ಬೀಜ ರಚನೆಗೆ ಸಹಾಯ ಮಾಡುತ್ತದೆ",

    // Derived Insights - Meanings
    cnRatioMeaning: "ಮಣ್ಣಿನ ಸಾವಯವ ಇಂಗಾಲ ಮತ್ತು ಲಭ್ಯ ಸಾರಜನಕದ ಅನುಪಾತ",
    cecTendencyMeaning: "ಮಣ್ಣಿನ ಪೋಷಕಾಂಶಗಳನ್ನು ಹಿಡಿದಿಟ್ಟುಕೊಳ್ಳುವ ಮತ್ತು ವಿನಿಮಯ ಮಾಡುವ ಸಾಮರ್ಥ್ಯ (OC, Ca, Mg, K, pH ಆಧಾರಿತ)",
    caMgRatioMeaning: "ಮಣ್ಣಿನಲ್ಲಿ ಕ್ಯಾಲ್ಸಿಯಂ ಮತ್ತು ಮ್ಯಾಗ್ನೀಸಿಯಂ ಮಟ್ಟಗಳ ನಡುವಿನ ಸಮತೋಲನ",
    kMgRatioMeaning: "ಪೊಟ್ಯಾಸಿಯಂ ಮತ್ತು ಮ್ಯಾಗ್ನೀಸಿಯಂ ಲಭ್ಯತೆಯ ನಡುವಿನ ಸಮತೋಲನ",

    // Derived Insights - Functions
    cnRatioFunction: "ಸಾವಯವ ಪದಾರ್ಥದ ಗುಣಮಟ್ಟವನ್ನು ಸೂಚಿಸುತ್ತದೆ; ಸೂಕ್ಷ್ಮಜೀವಿ ಚಟುವಟಿಕೆ ಮತ್ತು ಸಾರಜನಕ ಲಭ್ಯತೆಯ ಮೇಲೆ ಪರಿಣಾಮ ಬೀರುತ್ತದೆ",
    cecTendencyFunction: "ಬೇರಿನ ನೀರು ಹೀರಿಕೊಳ್ಳುವಿಕೆ ಮತ್ತು ಪೋಷಕ ಕರಗುವಿಕೆಯ ಮೇಲೆ ಪ್ರಭಾವ ಬೀರುತ್ತದೆ",
    caMgRatioFunction: "ಮಣ್ಣಿನ ರಚನೆ, ವಾತಾಯನ, ನೀರಿನ ಚಲನೆ ಮತ್ತು ಬೇರಿನ ನುಗ್ಗುವಿಕೆಯ ಮೇಲೆ ಪ್ರಭಾವ ಬೀರುತ್ತದೆ",
    kMgRatioFunction: "ಹೀರಿಕೊಳ್ಳುವಿಕೆಗಾಗಿ ಸ್ಪರ್ಧೆಯನ್ನು ನಿಯಂತ್ರಿಸುತ್ತದೆ; ಹಣ್ಣಿನ ಗುಣಮಟ್ಟ, ಒತ್ತಡ ಸಹಿಷ್ಣುತೆ ಮತ್ತು ಎಲೆ ಶಕ್ತಿಯ ಮೇಲೆ ಪರಿಣಾಮ ಬೀರುತ್ತದೆ",

    // Derived Indicators - Effects
    cnRatioLowEffect: "ಸಾವಯವ ಪದಾರ್ಥದ ವೇಗದ ವಿಭಜನೆ, ನೈಟ್ರೇಟ್ ಸೋರಿಕೆ ಹೆಚ್ಚಳ",
    cnRatioHighEffect: "ಪೋಷಕ ಲಾಕ್-ಅಪ್, ನಿಧಾನ ಸಾರಜನಕ ಖನಿಜೀಕರಣ",
    cecTendencyLowEffect: "ಕಳಪೆ ಪೋಷಕ ಧಾರಣ, ಸೋರಿಕೆಯ ಹೆಚ್ಚಿನ ಅಪಾಯ",
    cecTendencyHighEffect: "ಪೋಷಕಾಂಶಗಳು ತುಂಬಾ ಬಿಗಿಯಾಗಿ ಬಂಧಿಸಬಹುದು",
    caMgRatioLowEffect: "ಮಣ್ಣಿನ ಸಂಕೋಚನ, ಕಳಪೆ ವಾತಾಯನ, ಕಡಿಮೆ ನೀರಿನ ಒಳಹರಿವು",
    caMgRatioHighEffect: "ಪೋಷಕ ವಿರೋಧ, ವಿಶೇಷವಾಗಿ Mg ಮತ್ತು K ಕೊರತೆ",
    kMgRatioLowEffect: "ಸಂಭಾವ್ಯ Mg ಅತಿರೇಕ, ಹಣ್ಣಿನ ಪಕ್ವತೆ ವಿಳಂಬ ಆಗಬಹುದು",
    kMgRatioHighEffect: "K, Mg ಹೀರಿಕೊಳ್ಳುವಿಕೆಯನ್ನು ಹತ್ತಿಕ್ಕುತ್ತದೆ, ದುರ್ಬಲ ಕಾಂಡಗಳು",

    // Nutrient Blocking
    phosphorusBlocks: "ಸತು (Zn), ಕಬ್ಬಿಣ (Fe), ತಾಮ್ರ (Cu)",
    potassiumBlocks: "ಮ್ಯಾಗ್ನೀಸಿಯಂ (Mg), ಕ್ಯಾಲ್ಸಿಯಂ (Ca)",
    nitrogenBlocks: "ತಾಮ್ರ (Cu), ಬೋರಾನ್ (B)",

    // Table Headers - Fertilizer
    stage: "ಹಂತ",
    input: "ಒಳಹಾಕು",
    dose: "ಪ್ರಮಾಣ",
    method: "ವಿಧಾನ",

    // Table Headers - Derived Insights
    indicator: "ಸೂಚಕ",
    condition: "ಸ್ಥಿತಿ",
    imbalanceEffect: "ಅಸಮತೋಲನ ಪರಿಣಾಮ",

    // Table Headers - Nutrient Blocking
    blockingTitle: "ರಸಗೊಬ್ಬರ ಅನ್ವಯದ ಸಮಯದಲ್ಲಿ ನೆನಪಿನಲ್ಲಿಡಬೇಕಾದ ಅಂಶಗಳು",
    whenTooMuchOf: "ಹೆಚ್ಚಾದಾಗ...",
    itBlocks: "ಇದು ತಡೆಯುತ್ತದೆ...",

    // Table Headers - Crop Tips
    practice: "ಅಭ್ಯಾಸ",
    why: "ಏಕೆ",

    // Status/Levels
    low: "ಕಡಿಮೆ",
    medium: "ಸಾಮಾನ್ಯ",
    high: "ಹೆಚ್ಚು",

    // Messages
    cropTipsNotAvailable: "ಬೆಳೆ-ನಿರ್ದಿಷ್ಟ ಸಲಹೆಗಳು ಲಭ್ಯವಿಲ್ಲ",
    cropTipsNotAvailableDesc: "ನಮ್ಮಲ್ಲಿ \"{crop}\" ಗಾಗಿ ಕೃಷಿ ಸಲಹೆಗಳು ಈ ಕ್ಷಣದಲ್ಲಿ ಲಭ್ಯವಿಲ್ಲ. ನಂತರ ಮತ್ತೆ ಪರಿಶೀಲಿಸಿ ಅಥವಾ ಸಹಾಯಕ್ಕಾಗಿ ಸಂಪರ್ಕಿಸಿ.",
    availableCrops: "ಲಭ್ಯವಿರುವ ಬೆಳೆಗಳು",
    fertilizerNotAvailable: "ರಸಗೊಬ್ಬರ ಶಿಫಾರಸು ಲಭ್ಯವಿಲ್ಲ",
    fertilizerNotAvailableDesc: "ನಿಮ್ಮ ಮಣ್ಣಿಗಾಗಿ ರಸಗೊಬ್ಬರ ಶಿಫಾರಸುಗಳು ಈ ಕ್ಷಣದಲ್ಲಿ ಲಭ್ಯವಿಲ್ಲ. ನಂತರ ಮತ್ತೆ ಪರಿಶೀಲಿಸಿ ಅಥವಾ ಸಹಾಯಕ್ಕಾಗಿ ಸಂಪರ್ಕಿಸಿ.",

    // Derived Parameters Section
    derivedParametersSubtitle: "ಸಮಗ್ರ ವಿಶ್ಲೇಷಣೆಗಾಗಿ ಹೆಚ್ಚುವರಿ ಮಣ್ಣಿನ ಫಲವತ್ತತೆ ಸೂಚಕಗಳು.",

    // Notes
    phosphorusNote: "ಗಮನಿಸಿ: ಈ ವರದಿ ಫಾಸ್ಫರಸ್ ಮೌಲ್ಯಗಳನ್ನು P₂O₅ ಆಗಿ ವ್ಯಕ್ತಪಡಿಸುತ್ತದೆ. P₂O₅ ಅನ್ನು ಮೂಲ P ಗೆ ಪರಿವರ್ತಿಸಲು, ಮೌಲ್ಯವನ್ನು 0.436 ರಿಂದ ಗುಣಿಸಿ.",

    // Report Under Review
    underReviewHeading: "ರಿಪೋರ್ಟ್ ಸ್ಟೇಟಸ್: ಪರಿಶೀಲನೆ ನಡೆಯುತ್ತಿದೆ",
    underReviewBody: "ಒಂದು ಅಥವಾ ಹೆಚ್ಚಿನ ರಿಸಲ್ಟ್‌ಗಳನ್ನು ವೆರಿಫೈ ಮಾಡಬೇಕಿದೆ. ದಯವಿಟ್ಟು ನಮ್ಮ ಟೆಕ್ನಿಕಲ್ ಸಪೋರ್ಟ್ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ. ಫೈನಲ್ ರಿಪೋರ್ಟ್ ನೀಡುವ ಮೊದಲು ಮತ್ತೆ ಟೆಸ್ಟ್ ಮಾಡಬೇಕಾಗಬಹುದು.",

    warningUnderReview: "ಎಚ್ಚರಿಕೆ: ಈ ರಿಪೋರ್ಟ್‌ನಲ್ಲಿ ಕೆಲವು ತಪ್ಪುಗಳಿವೆ ಮತ್ತು ಸದ್ಯಕ್ಕೆ ಇದನ್ನು ಪರಿಶೀಲಿಸಲಾಗುತ್ತಿದೆ. ಇಲ್ಲಿ ತೋರಿಸಿರುವ ಫಲಿತಾಂಶಗಳು ಫೈನಲ್ ಅಲ್ಲ ಮತ್ತು ತಪ್ಪಾಗಿರಬಹುದು.\n\nನೀವು ಆದರೂ ಇದನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಲು ಬಯಸುವಿರಾ? (ನಿಲ್ಲಿಸಲು 'Cancel' ಒತ್ತಿ ಮತ್ತು ತಪ್ಪುಗಳನ್ನು ಸರಿಪಡಿಸಲು ಸಪೋರ್ಟ್ ಟೀಮ್ ಅನ್ನು ಸಂಪರ್ಕಿಸಿ).",

    // Disclaimer
    disclaimer: "ಹಕ್ಕುತ್ಯಾಗ",
    disclaimerWithPartner: "ಈ ಮಣ್ಣು ಪರೀಕ್ಷಾ ವರದಿಯನ್ನು Ekosight Technologies Private Limited ಮತ್ತು ಅದರ ಅಧಿಕೃತ ಪಾಲುದಾರ [Partner Name] ಜೊತೆಗೂಡಿ ತಯಾರಿಸಲಾಗಿದೆ. ಮಣ್ಣು ಪರೀಕ್ಷೆ, ವಿಶ್ಲೇಷಣೆ ಮತ್ತು ವರದಿಯಲ್ಲಿ ನೀಡಿದ ಫಲಿತಾಂಶಗಳ ಸಂಪೂರ್ಣ ಜವಾಬ್ದಾರಿ [Partner Name] ಅವರದ್ದಾಗಿದೆ. Ekosight Technologies ಈ ಪ್ರಕ್ರಿಯೆಯಲ್ಲಿ ಬಳಸಲಾದ ತಂತ್ರಜ್ಞಾನ, ಸಾಧನಗಳು ಮತ್ತು ವಿಶ್ಲೇಷಣಾ ಚೌಕಟ್ಟನ್ನು ಮಾತ್ರ ಒದಗಿಸುತ್ತದೆ.",
    disclaimerWithoutPartner: "ಈ ಮಣ್ಣು ಪರೀಕ್ಷಾ ವರದಿಯನ್ನು Ekosight Technologies Private Limited ಗ್ರಾಹಕರಿಂದ ಪಡೆದ ಮಾದರಿ ಮತ್ತು ಒದಗಿಸಿದ ಮಾಹಿತಿಯ ಆಧಾರದ ಮೇಲೆ ತಯಾರಿಸಿ ಹೊರಡಿಸಿದೆ. ಈ ವರದಿಯಲ್ಲಿ ನೀಡಿದ ಫಲಿತಾಂಶಗಳು ಮತ್ತು ಶಿಫಾರಸುಗಳು ಮಾರ್ಗದರ್ಶನ ಉದ್ದೇಶಕ್ಕಾಗಿ ಮಾತ್ರ. ನಿಜವಾದ ಕ್ಷೇತ್ರ ಫಲಿತಾಂಶಗಳು ಮಣ್ಣಿನ ವ್ಯತ್ಯಾಸ, ಪರಿಸರ ಅಂಶಗಳು ಮತ್ತು ಕೃಷಿ ಅಭ್ಯಾಸಗಳ ಪ್ರಕಾರ ಭಿನ್ನವಾಗಬಹುದು.",
    disclaimerText: "ಫಲಿತಾಂಶಗಳು ಪಡೆದ ಮಾದರಿ ಮತ್ತು ಗ್ರಾಹಕರು ನೀಡಿದ ಮಾಹಿತಿಗೆ ಮಾತ್ರ ಸಂಬಂಧಿಸಿವೆ. ಪ್ರಯೋಗಾಲಯಕ್ಕೆ ಮಾದರಿ ಸ್ವೀಕಾರದ ಮೊದಲು ಅದರ ಮೂಲ, ಗುರುತು ಅಥವಾ ಗುಣಮಟ್ಟಕ್ಕಾಗಿ Ekosight ಯಾವುದೇ ಜವಾಬ್ದಾರಿ ಹೊಂದಿಲ್ಲ. ಈ ವರದಿಯ ಮಾಹಿತಿ ಆಧಾರದ ಮೇಲೆ ನೀವು ತೆಗೆದುಕೊಳ್ಳುವ ಯಾವುದೇ ಕ್ರಮ ಸಂಪೂರ್ಣ ನಿಮ್ಮ ಸ್ವಂತ ಜೋಖಿಮದಲ್ಲಿದೆ.",
    waterDisclaimerTextWithPartner: "ಈ ನೀರಿನ ಪರೀಕ್ಷಾ ವರದಿಯನ್ನು Ekosight Technologies Private Limited ಮತ್ತು ಅದರ ಅಧಿಕೃತ ಪಾಲುದಾರ [Partner Name] ಸಹಯೋಗದೊಂದಿಗೆ ತಯಾರಿಸಲಾಗಿದೆ. ಪಾಲುದಾರರು ಪರೀಕ್ಷಾ ಫಲಿತಾಂಶಗಳ ನಿಖರತೆ ಮತ್ತು ವಿಶ್ವಾಸಾರ್ಹತೆಯ ಸಂಪೂರ್ಣ ಜವಾಬ್ದಾರಿಯನ್ನು ಹೊಂದಿರುತ್ತಾರೆ. ಫಲಿತಾಂಶಗಳು ಸ್ವೀಕರಿಸಿದ ಮಾದರಿ ಮತ್ತು ಪರೀಕ್ಷಾ ಸಮಯದಲ್ಲಿ ಅನ್ವಯಿಸಿದ ಷರತ್ತುಗಳಿಗೆ ಮಾತ್ರ ಮಾನ್ಯವಾಗಿರುತ್ತವೆ.",
  },

  tamil: {
    // Header
    inAssociationWith: "இணைந்து",

    // User Data Labels
    name: "பெயர்",
    mobile: "மொபைல்",
    address: "முகவரி",
    cityState: "நகர்/மாநிலம்",
    previousCrop: "முந்தைய பயிர்",
    farmSize: "நிலத்தின் அளவு",
    farmName: "நிலத்தின் பெயர்",
    nextCrop: "அடுத்த பயிர்",
    sampleCode: "மாதிரி குறியீடு",
    treatmentType: "சிகிச்சை வகை",
    sampleType: "மாதிரி வகை",
    reportDate: "தேதி",

    // Section Titles
    section1Title: "மண் பகுப்பாய்வு சுருக்கம்",
    section1Subtitle: "உங்கள் மண் மாதிரியில் நாங்கள் என்ன சோதித்தோம்.",
    section2Title: "விரிவான ஊட்டச்சத்து தகவல்கள்",
    section2Subtitle: "ஒவ்வொரு சோதிக்கப்பட்ட அளவுருவின் ஆழமான பகுப்பாய்வு.",
    section3Title: "உர பரிந்துரை",
    section3Subtitle: "இந்தப் பக்கம் எந்த உரம் பயன்படுத்த வேண்டும், எவ்வளவு மற்றும் எப்போது என்று சரியாகத் தெரிவிக்கிறது. இந்த திட்டத்தை பின்பற்றுங்கள்.",
    section4Title: "வழிவந்த நுண்ணறிவுகள் மற்றும் ஊட்டச்சத்து சமநிலை",
    section4Subtitle: "இந்தப் பிரிவு ஆழமான நுண்ணறிவுகளை வழங்குகிறது. பயனுள்ளது ஆனால் கட்டாயமில்லை.",
    section5Title: "பயிர்-குறிப்பிட்ட உதவிக்குறிப்புகள்",
    section5Subtitle: "சாகுபடிக்கான நிபுணர் உதவிக்குறிப்புகள். சிறந்த முடிவுகளுக்கு இந்த நடைமுறைகளை பின்பற்றுங்கள்.",

    // Water Report Section Title
    waterSection1Title: "நீர் பகுப்பாய்வு சுருக்கம்",
    waterSection1Subtitle: "உங்கள் நீர் மாதிரியில் நாங்கள் என்ன சோதித்தோம்.",
    waterRecommendationTitle: "நீர் சிகிச்சை பரிந்துரைகள்",
    waterRecommendationSubtitle: "உங்கள் நீர் தரத்திற்கான பரிந்துரைக்கப்பட்ட திருத்த நடவடிக்கைகள்",
    waterPerfect: "நீர் தரம் சிறப்பாக உள்ளது",
    waterPerfectDesc: "சோதிக்கப்பட்ட அளவுகோல்களின் அடிப்படையில் எந்த திருத்த சிகிச்சையும் தேவையில்லை.",
    waterRecommendationNote: "குறிப்பு: ஒரே செயல் பல அளவுகோல்களுக்கு பரிந்துரைக்கப்பட்டால் அதை மீண்டும் மீண்டும் செய்ய வேண்டாம். ஒரு செயல் பல அளவுகோல்களை மேம்படுத்தும், ஆகவே ஒருமுறை செய்தால் போதுமானது.",
    
    // Table Headers - Soil Analysis
    sNo: "வ.எண்.",
    parameter: "அளவுரு",
    idealRange: "சிறந்த வரம்பு",
    actualValue: "உண்மையான மதிப்பு",
    status: "நிலை",
    derivedParameters: "வழிவந்த அளவுருக்கள்",

    //BODL Note
    note: "குறிப்பு",
    bodlLabel: "BODL (கண்டறிதல் வரம்பிற்குக் கீழே)",
    bodlDescription:
      "சோதனை முறையின் குறைந்தபட்ச கண்டறிதல் வரம்பை விட அளவுருவின் செறிவு குறைவாக இருப்பதை இது குறிக்கிறது. அளவுரு முழுமையாக இல்லை என்று இது அவசியமாகக் குறிக்காது.",

    // Table Headers - Detailed Insights
    fertilityRating: "வளம் மதிப்பீடு",
    whatItMeans: "இதன் பொருள் என்ன?",
    functionInCropGrowth: "பயிர் வளர்ச்சியில் பங்கு",

    // Nutrient Insights - Meanings
    phMeaning: "மண்ணின் அமிலத்தன்மை/காரத்தன்மை",
    ecMeaning: "மண்ணில் உப்பு அளவு",
    ocMeaning: "மண்ணின் கரிம பொருள்",
    nitrogenMeaning: "வளர்ச்சி ஊட்டச்சத்து",
    phosphorusMeaning: "ஆற்றல் இடமாற்றம்",
    potassiumMeaning: "பழத்தின் தரக் கட்டுப்பாட்டாளர்",
    sulphurMeaning: "புரத தொகுப்பு",
    magnesiumMeaning: "கார்போபில்லின் மையம்",
    calciumMeaning: "செல் வலிமை",
    zincMeaning: "வளர்ச்சி ஹார்மோன் ஆதரவு",
    ironMeaning: "கார்போபில் தொகுப்பு",
    copperMeaning: "என்சைம் செயல்படுத்தி",
    boronMeaning: "மகரந்தச் சேர்க்கை மற்றும் பழம் பிடிக்கும்",

    // Nutrient Insights - Functions
    phFunction: "ஊட்டச்சத்து கிடைக்கும் தன்மை மற்றும் நுண்ணுயிர் செயல்பாட்டை பாதிக்கிறது",
    ecFunction: "வேர் நீர் உறிஞ்சுதல் மற்றும் ஊட்டச்சத்து கரைதிறனை பாதிக்கிறது",
    ocFunction: "நுண்ணுயிர் வாழ்க்கை, அமைப்பு மற்றும் நீர் தக்கவைப்பை மேம்படுத்துகிறது",
    nitrogenFunction: "இலை வளர்ச்சி மற்றும் கார்போபில் உருவாக்கத்தை ஊக்குவிக்கிறது",
    phosphorusFunction: "வேர் வளர்ச்சி மற்றும் பூக்கும் செயலுக்கு ஆதரவளிக்கிறது",
    potassiumFunction: "நீர் சமநிலை, நோய் எதிர்ப்பு, பழத்தின் அளவில் உதவுகிறது",
    sulphurFunction: "என்சைம் செயல்பாடு, எண்ணெய் தொகுப்பு மற்றும் சுவையை மேம்படுத்துகிறது",
    magnesiumFunction: "ஒளிச்சேர்க்கை மற்றும் என்சைம் செயல்பாட்டிற்கு அவசியம்",
    calciumFunction: "வலுவான செல் சுவர்களை உருவாக்குகிறது, மலர் அழுகலை தடுக்கிறது",
    zincFunction: "என்சைம் செயல்பாடு, இலை விரிவாக்கம், வேரூன்றலுக்கு தேவை",
    ironFunction: "பச்சை இலை உருவாக்கம் மற்றும் சுவாசத்தை ஆதரிக்கிறது",
    copperFunction: "மகரந்த செயல்திறன் மற்றும் நோய் எதிர்ப்பை பாதிக்கிறது",
    boronFunction: "பூக்கும், பழம் பிடிக்கும், சர்க்கரை போக்குவரத்து மற்றும் விதை உருவாக்கத்திற்கு உதவுகிறது",

    // Derived Insights - Meanings
    cnRatioMeaning: "மண்ணின் கரிம கார்பன் மற்றும் கிடைக்கும் நைட்ரஜன் விகிதம்",
    cecTendencyMeaning: "மண்ணின் ஊட்டச்சத்துகளை பிடித்து வைக்கும் மற்றும் பரிமாறிக்கொள்ளும் திறன் (OC, Ca, Mg, K, pH அடிப்படையில்)",
    caMgRatioMeaning: "மண்ணில் கால்சியம் மற்றும் மக்னீசியம் அளவுகளுக்கிடையேயான சமநிலை",
    kMgRatioMeaning: "பொட்டாசியம் மற்றும் மக்னீசியம் கிடைக்கும் தன்மைக்கிடையேயான சமநிலை",

    // Derived Insights - Functions
    cnRatioFunction: "கரிம பொருளின் தரத்தை குறிக்கிறது; நுண்ணுயிர் செயல்பாடு மற்றும் நைட்ரஜன் கிடைக்கும் தன்மையை பாதிக்கிறது",
    cecTendencyFunction: "வேர் நீர் உறிஞ்சுதல் மற்றும் ஊட்டச்சத்து கரைதிறனை பாதிக்கிறது",
    caMgRatioFunction: "மண்ணின் அமைப்பு, காற்றோட்டம், நீர் இயக்கம் மற்றும் வேர் ஊடுருவலை பாதிக்கிறது",
    kMgRatioFunction: "உறிஞ்சுதலுக்கான போட்டியை கட்டுப்படுத்துகிறது; பழத்தின் தரம், அழுத்த சகிப்புத்தன்மை மற்றும் இலை வலிமையை பாதிக்கிறது",

    // Derived Indicators - Effects
    cnRatioLowEffect: "கரிம பொருளின் விரைவான சிதைவு, நைட்ரேட் கசிவு அதிகரிப்பு",
    cnRatioHighEffect: "ஊட்டச்சத்து தேக்கம், மெதுவான நைட்ரஜன் கனிமாக்கம்",
    cecTendencyLowEffect: "மோசமான ஊட்டச்சத்து தக்கவைப்பு, கசிவு அபாயம் அதிகம்",
    cecTendencyHighEffect: "ஊட்டச்சத்துகள் மிகவும் இறுக்கமாக பிணைக்கப்படலாம்",
    caMgRatioLowEffect: "மண் இறுக்கம், மோசமான காற்றோட்டம், குறைந்த நீர் ஊடுருவல்",
    caMgRatioHighEffect: "ஊட்டச்சத்து விரோதம், குறிப்பாக Mg மற்றும் K குறைபாடு",
    kMgRatioLowEffect: "சாத்தியமான Mg அதிகப்படியாக, பழம் பழுக்கும் தாமதம் ஏற்படலாம்",
    kMgRatioHighEffect: "K, Mg உறிஞ்சுதலை அடக்குகிறது, பலவீனமான தண்டுகள்",

    // Nutrient Blocking
    phosphorusBlocks: "துத்தநாகம் (Zn), இரும்பு (Fe), தாமிரம் (Cu)",
    potassiumBlocks: "மக்னீசியம் (Mg), கால்சியம் (Ca)",
    nitrogenBlocks: "தாமிரம் (Cu), போரான் (B)",

    // Table Headers - Fertilizer
    stage: "நிலை",
    input: "உள்ளீடு",
    dose: "அளவு",
    method: "முறை",

    // Table Headers - Derived Insights
    indicator: "குறிகாட்டி",
    condition: "நிலை",
    imbalanceEffect: "சமநிலையின்மை விளைவு",

    // Table Headers - Nutrient Blocking
    blockingTitle: "உர பயன்பாட்டின் போது நினைவில் கொள்ள வேண்டிய விஷயங்கள்",
    whenTooMuchOf: "அதிகமாக இருக்கும்போது...",
    itBlocks: "இது தடுக்கிறது...",

    // Table Headers - Crop Tips
    practice: "நடைமுறை",
    why: "ஏன்",

    // Status/Levels
    low: "குறைவு",
    medium: "சாதாரண",
    high: "அதிகம்",

    // Messages
    cropTipsNotAvailable: "பயிர்-குறிப்பிட்ட உதவிக்குறிப்புகள் கிடைக்கவில்லை",
    cropTipsNotAvailableDesc: "தற்போது \"{crop}\" க்கான சாகுபடி உதவிக்குறிப்புகள் எங்களிடம் இல்லை. பின்னர் மீண்டும் சரிபார்க்கவும் அல்லது உதவிக்கு தொடர்பு கொள்ளவும்.",
    availableCrops: "கிடைக்கும் பயிர்கள்",
    fertilizerNotAvailable: "உர பரிந்துரை கிடைக்கவில்லை",
    fertilizerNotAvailableDesc: "தற்போது உங்கள் மண்ணுக்கான உர பரிந்துரைகள் எங்களிடம் இல்லை. பின்னர் மீண்டும் சரிபார்க்கவும் அல்லது உதவிக்கு தொடர்பு கொள்ளவும்.",

    // Derived Parameters Section
    derivedParametersSubtitle: "விரிவான பகுப்பாய்விற்கான கூடுதல் மண் வளம் குறிகாட்டிகள்.",

    // Notes
    phosphorusNote: "குறிப்பு: இந்த அறிக்கை பாஸ்பரஸ் மதிப்புகளை P₂O₅ ஆக வெளிப்படுத்துகிறது. P₂O₅ ஐ தனிம P ஆக மாற்ற, மதிப்பை 0.436 ஆல் பெருக்கவும்.",

    // Report Under Review
    underReviewHeading: "ரிப்போர்ட் ஸ்டேட்டஸ்: சரிபார்ப்பு நடைபெறுகிறது",
    underReviewBody: "ஒன்று அல்லது அதற்கு மேற்பட்ட ரிசல்ட்களை வெரிஃபை செய்ய வேண்டும். தயவுசெய்து எங்கள் டெக்னிக்கல் சப்போர்ட் குழுவைத் தொடர்புகொள்ளுங்கள். ஃபைனல் ரிப்போர்ட் வழங்குவதற்கு முன் மீண்டும் டெஸ்ட் செய்ய வேண்டியிருக்கலாம்.",

    warningUnderReview: "எச்சரிக்கை: இந்த ரிப்போர்ட்டில் சில தவறுகள் உள்ளன, தற்போது இது சரிபார்க்கப்பட்டு வருகிறது. காட்டப்படும் முடிவுகள் இறுதியானவை அல்ல, தவறாகவும் இருக்கலாம்.\n\nநீங்கள் இருந்தாலும் இதை டவுன்லோட் செய்ய வேண்டுமா? (நிறுத்த 'Cancel' ஐ அழுத்தவும், தவறுகளை சரிசெய்ய சப்போர்ட் குழுவை தொடர்பு கொள்ளவும்).",

    // Disclaimer
    disclaimer: "மறுப்பு",
    disclaimerWithPartner: "இந்த மண் பரிசோதனை அறிக்கையை Ekosight Technologies Private Limited மற்றும் அதன் அங்கீகரிக்கப்பட்ட பங்காளி [Partner Name] இணைந்து தயாரித்துள்ளனர். மண் பரிசோதனை, பகுப்பாய்வு மற்றும் அறிக்கையில் வழங்கப்பட்ட முடிவுகளுக்கான முழு பொறுப்பு [Partner Name] வசம் உள்ளது. Ekosight Technologies இந்த செயல்பாட்டில் பயன்படுத்தப்படும் தொழில்நுட்பம், கருவிகள் மற்றும் பகுப்பாய்வு கட்டமைப்பை மட்டுமே வழங்குகிறது.",
    disclaimerWithoutPartner: "இந்த மண் பரிசோதனை அறிக்கையை Ekosight Technologies Private Limited வாடிக்கையாளரிடமிருந்து பெறப்பட்ட மாதிரி மற்றும் வழங்கப்பட்ட தகவல்களின் அடிப்படையில் தயாரித்து வெளியிட்டுள்ளது. இந்த அறிக்கையில் வழங்கப்பட்ட முடிவுகள் மற்றும் பரிந்துரைகள் வழிகாட்டல் நோக்கங்களுக்காக மட்டுமே. உண்மையான வயல் முடிவுகள் மண் மாறுபாடு, சுற்றுச்சூழல் காரணிகள் மற்றும் விவசாய நடைமுறைகளுக்கு ஏற்ப வேறுபடலாம்.",
    disclaimerText: "முடிவுகள் பெறப்பட்ட மாதிரி மற்றும் வாடிக்கையாளர் வழங்கிய தகவல்களுடன் மட்டுமே தொடர்புடையவை. ஆய்வகத்திற்கு மாதிரி வருவதற்கு முன்பு அதன் தோற்றம், கண்டுபிடிப்பு அல்லது தரத்திற்கு Ekosight எந்த பொறுப்பும் ஏற்றுக்கொள்வதில்லை. இந்த அறிக்கையின் தகவல்களின் அடிப்படையில் நீங்கள் எடுக்கும் எந்தவொரு நடவடிக்கையும் முற்றிலும் உங்கள் சொந்த ஆபத்தில் உள்ளது.",
    waterDisclaimerTextWithPartner: "இந்த நீர் சோதனை அறிக்கை Ekosight Technologies Private Limited மற்றும் அதன் அங்கீகரிக்கப்பட்ட பங்குதாரர் [Partner Name] இணைந்து தயாரிக்கப்பட்டது. பங்குதாரர் சோதனை முடிவுகளின் துல்லியம் மற்றும் நம்பகத்தன்மைக்கு முழுப் பொறுப்பும் ஏற்றுக்கொள்கிறார். முடிவுகள் பெறப்பட்ட மாதிரி மற்றும் சோதனை நேரத்தில் பொருந்தும் நிபந்தனைகளுக்கு மட்டுமே செல்லுபடியாகும்.",
  },

  gujarati: {
    // Header
    inAssociationWith: "ના સહયોગથી",
    
    // User Data Labels
    name: "નામ",
    mobile: "મોબાઇલ",
    address: "સરનામું",
    cityState: "શહેર/રાજ્ય",
    previousCrop: "અગાઉનો પાક",
    farmSize: "ખેતરનું કદ",
    farmName: "ખેતરનું નામ",
    nextCrop: "આગામી પાક",
    sampleCode: "નમૂના કોડ",
    treatmentType: "સારવારનો પ્રકાર",
    sampleType: "નમૂનાનો પ્રકાર",
    reportDate: "તારીખ",
    
    // Section Titles
    section1Title: "માટી વિશ્લેષણ સારાંશ",
    section1Subtitle: "અમે તમારા માટીના નમૂનામાં આ ચકાસ્યું છે.",
    section2Title: "વિગતવાર પોષક તત્વોની માહિતી",
    section2Subtitle: "દરેક ચકાસાયેલ પેરામીટરની ઊંડાણપૂર્વકની માહિતી.",
    section3Title: "ખાતરની ભલામણ",
    section3Subtitle: "આ પૃષ્ઠ તમને બરાબર જણાવે છે કે કયા ખાતરોનો ઉપયોગ કરવો, કેટલો અને ક્યારે. આ યોજનાનું પાલન કરો.",
    section4Title: "તારવેલી માહિતી અને પોષક તત્વોનું સંતુલન",
    section4Subtitle: "આ વિભાગ ઊંડાણપૂર્વકની માહિતી આપે છે. વાંચવું ઉપયોગી છે પરંતુ ફરજિયાત નથી.",
    section5Title: "પાક-વિશિષ્ટ ટિપ્સ",
    section5Subtitle: "ખેતી માટે નિષ્ણાતોની ટિપ્સ. વધુ સારા પરિણામો માટે આ પ્રથાઓને અનુસરો.",

    //Water Report Section Title
    waterSection1Title: "પાણી વિશ્લેષણ સારાંશ",
    waterSection1Subtitle: "અમે તમારા પાણીના નમૂનામાં આ ચકાસ્યું છે.",
    waterRecommendationTitle: "પાણી શુદ્ધિકરણ ભલામણો",
    waterRecommendationSubtitle: "તમારી પાણીની ગુણવત્તા માટે સૂચવેલા સુધારાત્મક પગલાં",
    waterPerfect: "પાણીની ગુણવત્તા શ્રેષ્ઠ છે",
    waterPerfectDesc: "ચકાસાયેલ પેરામીટરના આધારે કોઈપણ સુધારાત્મક સારવારની જરૂર નથી.",
    waterRecommendationNote: "નોંધ: જ્યારે બહુવિધ પરિમાણો માટે સમાન ક્રિયાની ભલામણ કરવામાં આવે ત્યારે તેને પુનરાવર્તિત કરવાનું ટાળો. એક જ પ્રથા સામાન્ય રીતે ઘણા પરિમાણોમાં સુધારો કરે છે, તેથી એક જ વાર લાગુ કરવું પૂરતું છે.",

    // Table Headers - Soil Analysis
    sNo: "ક્રમ નં.",
    parameter: "પેરામીટર",
    idealRange: "આદર્શ શ્રેણી",
    actualValue: "વાસ્તવિક મૂલ્ય",
    status: "સ્થિતિ",
    derivedParameters: "તારવેલા પેરામીટર્સ",

    //BODL Note
    note: "નોંધ",
    bodlLabel: "BODL (શોધી શકાય તેવી મર્યાદા કરતાં ઓછું)",
    bodlDescription:
      "આ દર્શાવે છે કે પરિમાણની સાંદ્રતા પરીક્ષણ પદ્ધતિની ન્યૂનતમ શોધી શકાય તેવી મર્યાદા કરતાં ઓછી છે. તેનો અર્થ એ જરૂરી નથી કે પરિમાણ સંપૂર્ણપણે ગેરહાજર છે.",
    
    // Table Headers - Detailed Insights
    fertilityRating: "ફળદ્રુપતા રેટિંગ",
    whatItMeans: "આનો અર્થ શું છે?",
    functionInCropGrowth: "પાકના વિકાસમાં કાર્ય",
    
    // Nutrient Insights - Meanings
    phMeaning: "માટીની એસિડિટી/આલ્કલાઇનિટી",
    ecMeaning: "માટીમાં ક્ષારનું સ્તર",
    ocMeaning: "માટીમાં કાર્બનિક પદાર્થ",
    nitrogenMeaning: "વિકાસ માટે પોષક તત્વ",
    phosphorusMeaning: "ઊર્જા ટ્રાન્સફર",
    potassiumMeaning: "ફળની ગુણવત્તાનું નિયમનકાર",
    sulphurMeaning: "પ્રોટીન સંશ્લેષણ",
    magnesiumMeaning: "ક્લોરોફિલનું કેન્દ્ર",
    calciumMeaning: "કોષની મજબૂતાઈ",
    zincMeaning: "ગ્રોથ હોર્મોન સપોર્ટ",
    ironMeaning: "ક્લોરોફિલ સંશ્લેષણ",
    copperMeaning: "ઉત્સેચક સક્રિયકર્તા",
    boronMeaning: "પરાગનયન અને ફળ સેટ",
    
    // Nutrient Insights - Functions
    phFunction: "પોષક તત્વોની ઉપલબ્ધતા અને માઇક્રોબાયલ પ્રવૃત્તિને અસર કરે છે",
    ecFunction: "મૂળ દ્વારા પાણીના શોષણ અને પોષક દ્રાવ્યતાને પ્રભાવિત કરે છે",
    ocFunction: "માઇક્રોબાયલ જીવન, માળખું અને જળ જાળવણી વધારે છે",
    nitrogenFunction: "પાંદડાના વિકાસ અને ક્લોરોફિલની રચનાને પ્રોત્સાહન આપે છે",
    phosphorusFunction: "મૂળના વિકાસ અને ફૂલ આવવામાં મદદ કરે છે",
    potassiumFunction: "પાણીના સંતુલન, રોગ પ્રતિકારક શક્તિ અને ફળના કદમાં મદદ કરે છે",
    sulphurFunction: "ઉત્સેચક કાર્ય, તેલ સંશ્લેષણ અને સ્વાદ સુધારે છે",
    magnesiumFunction: "પ્રકાશસંશ્લેષણ અને ઉત્સેચક સક્રિયકરણ માટે આવશ્યક",
    calciumFunction: "મજબૂત કોષની દિવાલો બનાવે છે, ફૂલના સડાને અટકાવે છે",
    zincFunction: "ઉત્સેચક સક્રિયકરણ, પાંદડાના વિસ્તરણ અને મૂળ માટે જરૂરી",
    ironFunction: "લીલા પાંદડાની રચના અને શ્વસનને સમર્થન આપે છે",
    copperFunction: "પરાગની કાર્યક્ષમતા અને રોગ પ્રતિકારક શક્તિને પ્રભાવિત કરે છે",
    boronFunction: "ફૂલ, ફળ સેટ, ખાંડના પરિવહન અને બીજની રચનામાં મદદ કરે છે",
    
    // Derived Insights - Meanings
    cnRatioMeaning: "માટીના કાર્બનિક કાર્બન અને ઉપલબ્ધ નાઇટ્રોજનનો ગુણોત્તર",
    cecTendencyMeaning: "પોષક તત્વોને પકડી રાખવાની અને વિનિમય કરવાની માટીની ક્ષમતા (OC, Ca, Mg, K, pH આધારિત)",
    caMgRatioMeaning: "માટીમાં કેલ્શિય અને મેગ્નેશિયમના સ્તરો વચ્ચેનું સંતુલન",
    kMgRatioMeaning: "પોટેશિયમ અને મેગ્નેશિયમની ઉપલબ્ધતા વચ્ચેનું સંતુલન",
    
    // Derived Insights - Functions
    cnRatioFunction: "કાર્બનિક પદાર્થની ગુણવત્તા દર્શાવે છે; માઇક્રોબાયલ પ્રવૃત્તિ અને નાઇટ્રોજનની ઉપલબ્ધતાને અસર કરે છે",
    cecTendencyFunction: "મૂળ દ્વારા પાણીના શોષણ અને પોષક દ્રાવ્યતાને પ્રભાવિત કરે છે",
    caMgRatioFunction: "માટીની રચના, વાયુ-સંચાર, પાણીની હિલચાલ અને મૂળના પ્રવેશને પ્રભાવિત કરે છે",
    kMgRatioFunction: "શોષણ માટેની સ્પર્ધાને નિયંત્રિત કરે છે; ફળની ગુણવત્તા, તણાવ સહનશીલતા અને પાંદડાની મજબૂતાઈને અસર કરે છે",
    
    // Derived Indicators - Effects
    cnRatioLowEffect: "કાર્બનિક પદાર્થોનું ઝડપી ભંગાણ, નાઈટ્રેટ લિચિંગમાં વધારો",
    cnRatioHighEffect: "પોષક તત્વોનું લોક-અપ, ધીમું નાઇટ્રોજન ખનિજીકરણ",
    cecTendencyLowEffect: "નબળું પોષક જાળવણી, લિચિંગનું વધુ જોખમ",
    cecTendencyHighEffect: "પોષક તત્વો ખૂબ જ ચુસ્તપણે બંધાઈ શકે છે",
    caMgRatioLowEffect: "માટીનું કોમ્પેક્શન, નબળો વાયુ-સંચાર, ઓછું જળ ઘૂસણખોરી",
    caMgRatioHighEffect: "પોષક વિરોધીતા, ખાસ કરીને Mg અને K ની ઉણપ",
    kMgRatioLowEffect: "સંભવિત Mg વધુ પડતું, ફળ પાકવામાં વિલંબ થઈ શકે છે",
    kMgRatioHighEffect: "K, Mg ના શોષણને દબાવી દે છે, નબળા પ્રકાંડ",
    
    // Nutrient Blocking
    phosphorusBlocks: "ઝીંક (Zn), આયર્ન (Fe), કોપર (Cu)",
    potassiumBlocks: "મેગ્નેશિયમ (Mg), કેલ્શિય (Ca)",
    nitrogenBlocks: "કોપર (Cu), બોરોન (B)",
    
    // Table Headers - Fertilizer
    stage: "તબક્કો",
    input: "ઇનપુટ",
    dose: "ડોઝ",
    method: "પદ્ધતિ",
    
    // Table Headers - Derived Insights
    indicator: "સૂચક",
    condition: "સ્થિતિ",
    imbalanceEffect: "અસંતુલનની અસર",
    
    // Table Headers - Nutrient Blocking
    blockingTitle: "ખાતર લાગુ કરતી વખતે ધ્યાનમાં રાખવા જેવી બાબતો",
    whenTooMuchOf: "જ્યારે આ ખૂબ વધારે હોય...",
    itBlocks: "તે આને અવરોધે છે...",
    
    // Table Headers - Crop Tips
    practice: "પ્રથા",
    why: "શા માટે",
    
    // Status/Levels
    low: "ઓછું",
    medium: "સામાન્ય",
    high: "વધુ",
    
    // Messages
    cropTipsNotAvailable: "પાક-વિશિષ્ટ ટિપ્સ ઉપલબ્ધ નથી",
    cropTipsNotAvailableDesc: "અમારી પાસે આ સમયે \"{crop}\" માટે ખેતીની ટિપ્સ ઉપલબ્ધ નથી. કૃપા કરીને પછીથી તપાસો અથવા સહાય માટે સંપર્ક કરો.",
    availableCrops: "ઉપલબ્ધ પાકો",
    fertilizerNotAvailable: "ખાતરની ભલામણ ઉપલબ્ધ નથી",
    fertilizerNotAvailableDesc: "અમારી પાસે આ સમયે તમારી માટી માટે ખાતરની ભલામણો ઉપલબ્ધ નથી. કૃપા કરીને પછીથી તપાસો અથવા સહાય માટે સંપર્ક કરો.",
    
    // Derived Parameters Section
    derivedParametersSubtitle: "વ્યાપક વિશ્લેષણ માટે વધારાના માટી ફળદ્રુપતા સૂચકો.",
    
    // Notes
    phosphorusNote: "નોંધ: આ રિપોર્ટ ફોસ્ફરસના મૂલ્યોને P₂O₅ તરીકે દર્શાવે છે. P₂O₅ ને મૂળ તત્વ P માં રૂપાંતરિત કરવા માટે, મૂલ્યને 0.436 થી ગુણાકાર કરો.",

    warningUnderReview: "ચેતવણી: આ રિપોર્ટમાં કેટલીક ભૂલો છે અને હજુ તેનું ચેકિંગ ચાલી રહ્યું છે. બતાવેલ પરિણામો ફાઈનલ નથી અને ખોટા હોઈ શકે છે.\n\nશું તમે છતાં પણ આને ડાઉનલોડ કરવા માંગો છો? (રોકાવા માટે 'Cancel' દબાવો અને ભૂલ સુધારવા માટે સપોર્ટનો સંપર્ક કરો).",

    // Report Under Review
    underReviewHeading: "રિપોર્ટ સ્ટેટસ: તપાસ ચાલી રહી છે",
    underReviewBody: "એક અથવા વધુ રિઝલ્ટને વેરિફાઈ કરવાની જરૂર છે. કૃપા કરીને અમારી ટેક્નિકલ સપોર્ટ ટીમનો સંપર્ક કરો. ફાઈનલ રિપોર્ટ જારી કરતા પહેલાં ફરીથી ટેસ્ટ કરવો પડી શકે છે.",
    
    // Disclaimer
    disclaimer: "અસ્વીકરણ",
    disclaimerWithPartner: "આ માટી પરીક્ષણ રિપોર્ટ Ekosight Technologies Private Limited અને તેના અધિકૃત ભાગીદાર [Partner Name] ના સહયોગથી તૈયાર કરવામાં આવ્યો છે. માટીનું પરીક્ષણ કરવા, વિશ્લેષણ કરવા અને આ રિપોર્ટમાં રજૂ કરેલા પરિણામો પ્રદાન કરવા માટે [Partner Name] સંપૂર્ણપણે જવાબદાર છે. Ekosight Technologies આ પ્રક્રિયામાં ઉપયોગમાં લેવાતી પરીક્ષણ તકનીક, સાધનો અને વિશ્લેષણાત્મક માળખું પ્રદાન કરે છે પરંતુ ભાગીદાર પ્રયોગશાળા અથવા કર્મચારીઓ દ્વારા જનરેટ કરાયેલ વ્યક્તિગત પરીક્ષણ પરિણામોની સ્વતંત્ર રીતે ચકાસણી કે પુષ્ટિ કરતું નથી. ભાગીદાર ક્લાયન્ટ દ્વારા પ્રદાન કરેલ નમૂના(ઓ) ના આધારે પરિણામોની ચોકસાઈ, વિશ્વસનીયતા અને અર્થઘટન માટે સંપૂર્ણ જવાબદારી લે છે. પરીક્ષણ પરિણામો માત્ર પ્રાપ્ત થયેલ નમૂના માટે અને લાગુ કરાયેલ વિશિષ્ટ પરીક્ષણ શરતો હેઠળ જ માન્ય છે. આ પરિણામોમાંથી મેળવેલી ભલામણોનો ઉપયોગ માર્ગદર્શન તરીકે થવો જોઈએ; ખેતરની સ્થિતિ, મોસમી ફેરફારો અને કૃષિ પરિબળો વાસ્તવિક પરિણામોને પ્રભાવિત કરી શકે છે.",
    disclaimerWithoutPartner: "આ માટી પરીક્ષણ રિપોર્ટ Ekosight Technologies Private Limited દ્વારા પ્રાપ્ત નમૂના(ઓ) અને ક્લાયન્ટ દ્વારા પ્રદાન કરવામાં આવેલી માહિતીના આધારે તૈયાર અને જારી કરવામાં આવ્યો છે. આ રિપોર્ટમાં રજૂ કરાયેલ પરીક્ષણ, વિશ્લેષણ અને અર્થઘટન Ekosight ની માલિકીની તકનીક, સાધનો અને વિશ્લેષણાત્મક માળખાનો ઉપયોગ કરીને કરવામાં આવ્યું છે. ચોકસાઈ અને વિશ્વસનીયતા સુનિશ્ચિત કરવા માટે દરેક પ્રયાસ કરવામાં આવ્યા હોવા છતાં, પરિણામો પ્રાપ્ત થયેલ નમૂનાની સ્થિતિ અને અખંડિતતા પૂરતા મર્યાદિત છે. પ્રદાન કરવામાં આવેલ પરિણામો અને ભલામણો માત્ર માર્ગદર્શનના હેતુ માટે છે. વાસ્તવિક ખેતરના પરિણામો માટીની વિવિધતા, પર્યાવરણીય પરિબળો, પાક વ્યવસ્થાપન પ્રથાઓ અને મોસમી પરિસ્થિતિઓના આધારે બદલાઈ શકે છે. Ekosight Technologies આ રિપોર્ટ અથવા તેની ભલામણોના ઉપયોગના આધારે લેવામાં આવેલા કોઈપણ પ્રત્યક્ષ, પરોક્ષ અથવા પરિણામી નુકસાન, હાનિ અથવા નિર્ણયો માટે જવાબદાર કે ઉત્તરદાયી રહેશે નહીં. Ekosight Technologies Private Limited ની પૂર્વ લેખિત પરવાનગી વિના આ રિપોર્ટના કોઈપણ ભાગનું પુનરુત્પાદન અથવા વ્યાપારી કે જાહેર હેતુઓ માટે ઉપયોગ કરી શકાશે નહીં.",
    waterDisclaimerTextWithPartner: "આ જળ પરીક્ષણ રિપોર્ટ Ekosight Technologies Private Limited અને તેના અધિકૃત ભાગીદાર, [Partner Name] ના સહયોગથી તૈયાર કરવામાં આવ્યો છે. Ekosight Technologies Private Limited આ પ્રક્રિયામાં ઉપયોગમાં લેવાતી પરીક્ષણ તકનીક, સાધનો અને વિશ્લેષણાત્મક માળખું પ્રદાન કરે છે પરંતુ ભાગીદાર પ્રયોગશાળા અથવા વ્યક્તિગત દ્વારા જનરેટ કરાયેલ વ્યક્તિગત પરીક્ષણ પરિણામોની સ્વતંત્ર રીતે ચકાસણી કે પુષ્ટિ કરતું નથી. અધિકૃત ભાગીદાર ક્લાયન્ટ દ્વારા પ્રદાન કરેલ પાણીના નમૂના(ઓ) ના આધારે પરિણામોની ચોકસાઈ, વિશ્વસનીયતા અને અર્થઘટન માટે સંપૂર્ણ જવાબદારી લે છે. પરીક્ષણ પરિણામો માત્ર પ્રાપ્ત થયેલ નમૂના માટે અને વિશ્લેષણ સમયે લાગુ કરાયેલ વિશિષ્ટ પરીક્ષણ શરતો હેઠળ જ માન્ય છે. આ પરિણામોમાંથી મેળવેલી ભલામણો અથવા અર્થઘટન માત્ર સામાન્ય માર્ગદર્શન માટે છે. વાસ્તવિક પાણીની ગુણવત્તા અને યોગ્યતા સ્ત્રોતની સ્થિતિ, સંગ્રહ, હેન્ડલિંગ, મોસમી ફેરફારો અને સાઇટ-વિશિષ્ટ પર્યાવરણીય પરિબળોના કારણે બદલાઈ શકે છે.",
  },

  telugu: {
  // Header
  inAssociationWith: "సహకారంతో",

  // User Data Labels
  name: "పేరు",
  mobile: "మొబైల్",
  address: "చిరునామా",
  cityState: "నగరం/రాష్ట్రం",
  previousCrop: "మునుపటి పంట",
  farmSize: "వ్యవసాయ భూమి విస్తీర్ణం",
  farmName: "వ్యవసాయ భూమి పేరు",
  nextCrop: "తదుపరి పంట",
  sampleCode: "నమూనా కోడ్",
  treatmentType: "చికిత్స రకం",
  sampleType: "నమూనా రకం",
  reportDate: "తేదీ",

  // Section Titles
  section1Title: "నేల విశ్లేషణ సారాంశం",
  section1Subtitle: "మీ నేల నమూనాలో మేము పరీక్షించిన అంశాలు ఇవి.",

  section2Title: "పోషక పదార్థాల విశ్లేషణ",
  section2Subtitle: "పరీక్షించిన ప్రతి పరామితి గురించి వివరాలు.",

  section3Title: "ఎరువుల సిఫార్సు",
  section3Subtitle: "ఏ ఎరువులు, ఎంత మోతాదులో, ఎప్పుడు ఉపయోగించాలో ఈ విభాగం తెలియజేస్తుంది. ఈ ప్రణాళికను అనుసరించండి.",

  section4Title: "ఉత్పన్నమైన విశ్లేషణలు & పోషక సమతుల్యత",
  section4Subtitle: "ఈ విభాగం అదనపు విశ్లేషణలను అందిస్తుంది. చదవడం ఉపయోగకరమే కానీ తప్పనిసరి కాదు.",

  section5Title: "పంటకు ప్రత్యేకమైన సూచనలు",
  section5Subtitle: "మెరుగైన దిగుబడికి నిపుణుల సూచించిన సాగు పద్ధతులను అనుసరించండి.",

  // Water Report Section Title
  waterSection1Title: "నీటి విశ్లేషణ సారాంశం",
  waterSection1Subtitle: "మీ నీటి నమూనాలో మేము పరీక్షించిన అంశాలు ఇవి.",

  waterRecommendationTitle: "నీటి శుద్ధి సిఫార్సులు",
  waterRecommendationSubtitle: "మీ నీటి నాణ్యతను మెరుగుపరచడానికి సూచించిన చర్యలు",

  waterPerfect: "నీటి నాణ్యత అనుకూలంగా ఉంది",

  waterPerfectDesc: "పరీక్షించిన పరామితుల ఆధారంగా ఎటువంటి సరిదిద్దే చర్యలు అవసరం లేదు.",

  waterRecommendationNote:
    "గమనిక: ఒకే చర్యను అనేక పరామితుల కోసం సూచించినట్లయితే దానిని మళ్లీ మళ్లీ చేయవద్దు. ఒకే చర్య అనేక పరామితులను మెరుగుపరుస్తుంది కాబట్టి ఒక్కసారి చేయడం సరిపోతుంది.",

  // Table Headers - Soil Analysis
  sNo: "క్రమ సంఖ్య",
  parameter: "పరామితి",
  idealRange: "ఆదర్శ పరిధి",
  actualValue: "వాస్తవ విలువ",
  status: "స్థితి",
  derivedParameters: "ఉత్పన్నమైన పరామితులు",

  // BODL Note
  note: "గమనిక",
  bodlLabel: "BODL (గుర్తించే పరిమితి కంటే తక్కువ)",
  bodlDescription:
    "పరీక్షా పద్ధతి ద్వారా గుర్తించగల కనిష్ఠ పరిమితి కంటే పరామితి సాంద్రత తక్కువగా ఉందని ఇది సూచిస్తుంది. పరామితి పూర్తిగా లేదని దీని అర్థం తప్పనిసరిగా కాదు.",

  // Table Headers - Detailed Insights
  fertilityRating: "సారవంతత రేటింగ్",
  whatItMeans: "దీని అర్థం ఏమిటి?",
  functionInCropGrowth: "పంట పెరుగుదలలో పాత్ర",

  // Nutrient Insights - Meanings
  phMeaning: "నేల యొక్క ఆమ్లత్వం/క్షారత్వం",
  ecMeaning: "నేలలో ఉప్పు స్థాయి",
  ocMeaning: "నేలలో సేంద్రీయ పదార్థం",
  nitrogenMeaning: "పెరుగుదలకు అవసరమైన పోషకం",
  phosphorusMeaning: "శక్తి బదిలీకి అవసరమైన పోషకం",
  potassiumMeaning: "పండ్ల నాణ్యతను నియంత్రించే పోషకం",
  sulphurMeaning: "ప్రోటీన్ సంశ్లేషణకు అవసరమైన పోషకం",
  magnesiumMeaning: "క్లోరోఫిల్ యొక్క ప్రధాన భాగం",
  calciumMeaning: "కణ గోడలకు బలం అందించే పోషకం",
  zincMeaning: "వృద్ధి హార్మోన్లకు మద్దతు",
  ironMeaning: "క్లోరోఫిల్ ఏర్పాటుకు అవసరం",
  copperMeaning: "ఎంజైమ్‌లను క్రియాశీలం చేస్తుంది",
  boronMeaning: "పరాగసంపర్కం మరియు పండ్ల ఏర్పాటుకు అవసరం",

  // Nutrient Insights - Functions
  phFunction: "పోషకాల లభ్యత మరియు సూక్ష్మజీవుల కార్యకలాపాలను ప్రభావితం చేస్తుంది",
  ecFunction: "వేర్లు నీటిని గ్రహించే సామర్థ్యం మరియు పోషకాల ద్రావణీయతను ప్రభావితం చేస్తుంది",
  ocFunction: "సూక్ష్మజీవుల పెరుగుదల, నేల నిర్మాణం మరియు నీటి నిల్వ సామర్థ్యాన్ని మెరుగుపరుస్తుంది",
  nitrogenFunction: "ఆకుల పెరుగుదల మరియు క్లోరోఫిల్ ఏర్పాటును ప్రోత్సహిస్తుంది",
  phosphorusFunction: "వేర్ల అభివృద్ధి మరియు పుష్పించడాన్ని ప్రోత్సహిస్తుంది",
  potassiumFunction: "నీటి సమతుల్యత, వ్యాధి నిరోధకత మరియు పండ్ల పరిమాణాన్ని మెరుగుపరుస్తుంది",
  sulphurFunction: "ఎంజైమ్‌ల పనితీరు, నూనె సంశ్లేషణ మరియు రుచిని మెరుగుపరుస్తుంది",
  magnesiumFunction: "ప్రకాశ సంశ్లేషణ మరియు ఎంజైమ్‌ల క్రియాశీలతకు అత్యవసరం",
  calciumFunction: "బలమైన కణ గోడలను నిర్మించి, బ్లాసమ్-ఎండ్ రాట్‌ను నివారిస్తుంది",
  zincFunction: "ఎంజైమ్‌ల క్రియాశీలత, ఆకుల విస్తరణ మరియు వేర్ల పెరుగుదలకు అవసరం",
  ironFunction: "ఆకుపచ్చ ఆకుల ఏర్పాటుకు మరియు శ్వాసక్రియకు మద్దతు ఇస్తుంది",
  copperFunction: "పుప్పొడి జీవశక్తి మరియు వ్యాధి నిరోధకతను ప్రభావితం చేస్తుంది",
  boronFunction: "పుష్పించడం, పండ్ల ఏర్పాటు, చక్కెర రవాణా మరియు విత్తనాల ఏర్పాటుకు సహాయపడుతుంది",

  // Derived Insights - Meanings
  cnRatioMeaning: "నేలలోని సేంద్రీయ కార్బన్ మరియు అందుబాటులో ఉన్న నత్రజని మధ్య నిష్పత్తి",
  cecTendencyMeaning: "పోషకాలను నిల్వ చేసి మార్పిడి చేసే నేల సామర్థ్యం (OC, Ca, Mg, K, pH ఆధారంగా)",
  caMgRatioMeaning: "నేలలో కాల్షియం మరియు మెగ్నీషియం మధ్య సమతుల్యత",
  kMgRatioMeaning: "పొటాషియం మరియు మెగ్నీషియం లభ్యత మధ్య సమతుల్యత",

  // Derived Insights - Functions
  cnRatioFunction: "సేంద్రీయ పదార్థ నాణ్యతను సూచిస్తుంది; సూక్ష్మజీవుల కార్యకలాపం మరియు నత్రజని లభ్యతను ప్రభావితం చేస్తుంది",
  cecTendencyFunction: "వేర్లు నీటిని గ్రహించడం మరియు పోషకాల లభ్యతను ప్రభావితం చేస్తుంది",
  caMgRatioFunction: "నేల నిర్మాణం, గాలి ప్రసరణ, నీటి కదలిక మరియు వేర్ల పెరుగుదలను ప్రభావితం చేస్తుంది",
  kMgRatioFunction: "పోషకాల గ్రహణంలో పోటీని నియంత్రిస్తుంది; పండ్ల నాణ్యత, ఒత్తిడి తట్టుకునే శక్తి మరియు ఆకుల బలాన్ని ప్రభావితం చేస్తుంది",

  // Derived Indicators - Effects
  cnRatioLowEffect: "సేంద్రీయ పదార్థం వేగంగా కుళ్లిపోవడం, నైట్రేట్ లీకేజీ పెరగడం",
  cnRatioHighEffect: "పోషకాల బంధనం, నత్రజని ఖనిజీకరణ నెమ్మదించడం",

  cecTendencyLowEffect: "పోషకాలను నిల్వ చేసే సామర్థ్యం తగ్గి, లీకేజీ ప్రమాదం పెరుగుతుంది",
  cecTendencyHighEffect: "పోషకాలు నేలలో బలంగా బంధించబడే అవకాశం ఉంది",

  caMgRatioLowEffect: "నేల గట్టిపడటం, గాలి ప్రసరణ తగ్గడం, నీటి చొరబాటు తగ్గడం",
  caMgRatioHighEffect: "పోషకాల పరస్పర ప్రభావం వల్ల ముఖ్యంగా మెగ్నీషియం మరియు పొటాషియం లోపం ఏర్పడవచ్చు",

  kMgRatioLowEffect: "మెగ్నీషియం అధికంగా ఉండే అవకాశం, పండ్ల పరిపక్వత ఆలస్యం కావచ్చు",
  kMgRatioHighEffect: "అధిక పొటాషియం వల్ల మెగ్నీషియం గ్రహణం తగ్గి, కాండాలు బలహీనపడవచ్చు",

  // Nutrient Blocking
  phosphorusBlocks: "జింక్ (Zn), ఇనుము (Fe), రాగి (Cu)",
  potassiumBlocks: "మెగ్నీషియం (Mg), కాల్షియం (Ca)",
  nitrogenBlocks: "రాగి (Cu), బోరాన్ (B)",

  // Table Headers - Fertilizer
  stage: "దశ",
  input: "ఇన్‌పుట్",
  dose: "మోతాదు",
  method: "విధానం",

  // Table Headers - Derived Insights
  indicator: "సూచిక",
  condition: "స్థితి",
  imbalanceEffect: "అసమతుల్యత ప్రభావం",

  // Table Headers - Nutrient Blocking
  blockingTitle: "ఎరువుల వినియోగ సమయంలో గుర్తుంచుకోవాల్సిన ముఖ్యమైన విషయాలు",
  whenTooMuchOf: "అధికంగా ఉన్నప్పుడు...",
  itBlocks: "ఇది నిరోధించేది...",

  // Table Headers - Crop Tips
  practice: "పద్ధతి",
  why: "ఎందుకు",

  // Status/Levels
  low: "తక్కువ",
  medium: "సాధారణం",
  high: "అధికం",

  // Messages
  cropTipsNotAvailable: "ఈ పంటకు సంబంధించిన సూచనలు అందుబాటులో లేవు",

  cropTipsNotAvailableDesc:
    "\"{crop}\" పంటకు సంబంధించిన సాగు సూచనలు ప్రస్తుతం అందుబాటులో లేవు. దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి లేదా సహాయం కోసం మద్దతు బృందాన్ని సంప్రదించండి.",

  availableCrops: "అందుబాటులో ఉన్న పంటలు",

  fertilizerNotAvailable: "ఎరువుల సిఫార్సులు అందుబాటులో లేవు",

  fertilizerNotAvailableDesc:
    "మీ నేలకు సంబంధించిన ఎరువుల సిఫార్సులు ప్రస్తుతం అందుబాటులో లేవు. దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి లేదా సహాయం కోసం మద్దతు బృందాన్ని సంప్రదించండి.",

  // Derived Parameters Section
  derivedParametersSubtitle:
    "సమగ్ర నేల విశ్లేషణ కోసం అదనపు నేల సారవంతత సూచికలు.",

  // Notes
  phosphorusNote:
    "గమనిక: ఈ నివేదికలో ఫాస్ఫరస్ విలువలు P₂O₅ రూపంలో చూపించబడతాయి. P₂O₅ ను మూల ఫాస్ఫరస్ (P) గా మార్చడానికి విలువను 0.436తో గుణించండి.",

  // Report Under Review
  underReviewHeading: "రిపోర్ట్ స్టేటస్: చెక్ చేస్తున్నారు",
  underReviewBody: "ఒకటి లేదా అంతకంటే ఎక్కువ రిజల్ట్‌లను వెరిఫై చేయాల్సి ఉంది. దయచేసి మా టెక్నికల్ సపోర్ట్ టీమ్‌ను సంప్రదించండి. ఫైనల్ రిపోర్ట్ ఇవ్వడానికి ముందు మళ్లీ టెస్ట్ చేయాల్సి రావచ్చు.",

  warningUnderReview: "హెచ్చరిక: ఈ రిపోర్ట్‌లో కొన్ని తప్పులు ఉన్నాయి, ప్రస్తుతం దీన్ని చెక్ చేస్తున్నారు. ఇక్కడ చూపించిన వివరాలు ఫైనల్ కాదు మరియు తప్పు అయ్యే అవకాశం ఉంది.\n\nమీరు అయినా దీన్ని డౌన్‌లోడ్ చేయాలనుకుంటున్నారా? (ఆగడానికి 'Cancel' నొక్కండి, తప్పులను సరిచేయడానికి సపోర్ట్ టీమ్‌ని సంప్రదించండి).",

  // Disclaimer
  disclaimer: "నిరాకరణ",

  disclaimerWithPartner:
    "ఈ నేల పరీక్ష నివేదికను ఎకోసైట్ టెక్నాలజీస్ ప్రైవేట్ లిమిటెడ్ మరియు దాని అధీకృత భాగస్వామి [Partner Name] సహకారంతో సిద్ధం చేశారు. ఈ నివేదికలో చూపించిన నేల పరీక్షలు నిర్వహించడం, విశ్లేషణ చేయడం మరియు ఫలితాలను అందించడం పూర్తిగా [Partner Name] బాధ్యత. ఎకోసైట్ టెక్నాలజీస్ ఈ ప్రక్రియలో ఉపయోగించిన పరీక్షా సాంకేతికత, పరికరాలు మరియు విశ్లేషణాత్మక విధానాన్ని మాత్రమే అందిస్తుంది. భాగస్వామి ప్రయోగశాల లేదా సిబ్బంది రూపొందించిన వ్యక్తిగత పరీక్ష ఫలితాలను ఎకోసైట్ స్వతంత్రంగా ధృవీకరించదు లేదా నిర్ధారించదు. వినియోగదారు అందించిన నమూనా(లు) ఆధారంగా ఫలితాల ఖచ్చితత్వం, విశ్వసనీయత మరియు వివరణకు భాగస్వామే పూర్తిగా బాధ్యత వహిస్తారు. ఈ పరీక్షా ఫలితాలు అందుకున్న నమూనా మరియు పరీక్ష నిర్వహించిన పరిస్థితులకు మాత్రమే వర్తిస్తాయి. ఈ ఫలితాల ఆధారంగా ఇచ్చిన సిఫార్సులను మార్గదర్శకంగా మాత్రమే ఉపయోగించాలి. క్షేత్ర పరిస్థితులు, ఋతుపరమైన మార్పులు మరియు వ్యవసాయ నిర్వహణ పద్ధతుల కారణంగా వాస్తవ ఫలితాలు మారవచ్చు.",

  disclaimerWithoutPartner:
    "ఈ నేల పరీక్ష నివేదికను వినియోగదారు అందించిన నమూనా(లు) మరియు సమాచారాన్ని ఆధారంగా ఎకోసైట్ టెక్నాలజీస్ ప్రైవేట్ లిమిటెడ్ సిద్ధం చేసి విడుదల చేసింది. ఈ నివేదికలోని పరీక్షలు, విశ్లేషణ మరియు వివరణలు ఎకోసైట్ యొక్క స్వంత సాంకేతికత, పరికరాలు మరియు విశ్లేషణాత్మక విధానాల ఆధారంగా నిర్వహించబడ్డాయి. ఫలితాల ఖచ్చితత్వం మరియు విశ్వసనీయతను నిర్ధారించడానికి అన్ని జాగ్రత్తలు తీసుకున్నప్పటికీ, ఇవి అందుకున్న నమూనా యొక్క స్థితి మరియు నాణ్యతపై ఆధారపడి ఉంటాయి. ఈ నివేదికలోని ఫలితాలు మరియు సిఫార్సులు మార్గదర్శక ప్రయోజనాల కోసం మాత్రమే. నేల వైవిధ్యం, పర్యావరణ పరిస్థితులు, పంట నిర్వహణ పద్ధతులు మరియు ఋతుపరమైన మార్పుల వల్ల వాస్తవ ఫలితాలు భిన్నంగా ఉండవచ్చు. ఈ నివేదిక లేదా ఇందులోని సిఫార్సులను ఉపయోగించడం వల్ల కలిగే ప్రత్యక్ష, పరోక్ష లేదా అనుబంధ నష్టం, హాని లేదా నిర్ణయాలకు ఎకోసైట్ టెక్నాలజీస్ ప్రైవేట్ లిమిటెడ్ బాధ్యత వహించదు. ఎకోసైట్ టెక్నాలజీస్ ప్రైవేట్ లిమిటెడ్ యొక్క ముందస్తు లిఖితపూర్వక అనుమతి లేకుండా ఈ నివేదికలోని ఏ భాగాన్నీ పునర్ముద్రించరాదు లేదా వాణిజ్య లేదా ప్రజా ప్రయోజనాల కోసం ఉపయోగించరాదు.",

  waterDisclaimerTextWithPartner:
    "ఈ నీటి పరీక్ష నివేదికను ఎకోసైట్ టెక్నాలజీస్ ప్రైవేట్ లిమిటెడ్ మరియు దాని అధీకృత భాగస్వామి [Partner Name] సహకారంతో సిద్ధం చేశారు. ఈ ప్రక్రియలో ఉపయోగించిన పరీక్షా సాంకేతికత, పరికరాలు మరియు విశ్లేషణాత్మక విధానాన్ని ఎకోసైట్ టెక్నాలజీస్ ప్రైవేట్ లిమిటెడ్ అందిస్తుంది. అయితే, భాగస్వామి ప్రయోగశాల లేదా సిబ్బంది రూపొందించిన వ్యక్తిగత పరీక్ష ఫలితాలను ఎకోసైట్ స్వతంత్రంగా ధృవీకరించదు లేదా నిర్ధారించదు. వినియోగదారు అందించిన నీటి నమూనా(లు) ఆధారంగా ఫలితాల ఖచ్చితత్వం, విశ్వసనీయత మరియు వివరణకు అధీకృత భాగస్వామే పూర్తిగా బాధ్యత వహిస్తారు. ఈ పరీక్షా ఫలితాలు అందుకున్న నమూనా మరియు పరీక్ష నిర్వహించిన సమయంలో ఉన్న పరిస్థితులకు మాత్రమే వర్తిస్తాయి. ఈ ఫలితాల ఆధారంగా అందించిన సిఫార్సులు లేదా వివరణలు సాధారణ మార్గదర్శకాలుగా మాత్రమే పరిగణించాలి. నీటి మూలం, నిల్వ, నిర్వహణ, ఋతుపరమైన మార్పులు మరియు ప్రదేశానికి సంబంధించిన పర్యావరణ పరిస్థితుల కారణంగా వాస్తవ నీటి నాణ్యత మరియు వినియోగయోగ్యత మారవచ్చు.",
  },

  marathi: {
  // Header
  inAssociationWith: "यांच्या सहकार्याने",

  // User Data Labels
  name: "नाव",
  mobile: "मोबाईल",
  address: "पत्ता",
  cityState: "शहर/राज्य",
  previousCrop: "मागील पीक",
  farmSize: "शेतीचे क्षेत्रफळ",
  farmName: "शेतीचे नाव",
  nextCrop: "पुढील पीक",
  sampleCode: "नमुना कोड",
  treatmentType: "उपचार प्रकार",
  sampleType: "नमुना प्रकार",
  reportDate: "दिनांक",

  // Section Titles
  section1Title: "माती विश्लेषण सारांश",
  section1Subtitle: "तुमच्या मातीच्या नमुन्यात आम्ही तपासलेले घटक.",

  section2Title: "सविस्तर पोषकतत्त्व विश्लेषण",
  section2Subtitle: "तपासलेल्या प्रत्येक घटकाची सविस्तर माहिती.",

  section3Title: "खत शिफारस",
  section3Subtitle: "कोणते खत, किती प्रमाणात आणि केव्हा वापरायचे याची माहिती येथे दिली आहे. या योजनेचे पालन करा.",

  section4Title: "व्युत्पन्न विश्लेषण व पोषकतत्त्व संतुलन",
  section4Subtitle: "या विभागात अधिक सखोल माहिती दिली आहे. ती उपयुक्त आहे, परंतु वाचणे अनिवार्य नाही.",

  section5Title: "पीक-विशिष्ट सूचना",
  section5Subtitle: "चांगल्या उत्पादनासाठी तज्ज्ञांनी सुचवलेल्या शेती पद्धतींचे पालन करा.",

  // Water Report Section Title
  waterSection1Title: "पाणी विश्लेषण सारांश",
  waterSection1Subtitle: "तुमच्या पाण्याच्या नमुन्यात आम्ही तपासलेले घटक.",

  waterRecommendationTitle: "पाणी उपचार शिफारसी",
  waterRecommendationSubtitle: "तुमच्या पाण्याच्या गुणवत्तेसाठी सुचवलेल्या सुधारात्मक उपाययोजना",

  waterPerfect: "पाण्याची गुणवत्ता योग्य आहे",

  waterPerfectDesc: "तपासलेल्या घटकांच्या आधारे कोणत्याही सुधारात्मक उपचारांची आवश्यकता नाही.",

  waterRecommendationNote:
    "टीप: एकाच कृतीची शिफारस अनेक घटकांसाठी केली असल्यास ती पुन्हा पुन्हा करू नका. एकच उपाय अनेक घटक सुधारतो, त्यामुळे एकदाच करणे पुरेसे आहे.",

  // Table Headers - Soil Analysis
  sNo: "अनुक्रमांक",
  parameter: "घटक",
  idealRange: "आदर्श श्रेणी",
  actualValue: "प्रत्यक्ष मूल्य",
  status: "स्थिती",
  derivedParameters: "व्युत्पन्न घटक",
  
  // BODL Note
  note: "टीप",
  bodlLabel: "BODL (शोधण्याच्या मर्यादेपेक्षा कमी)",
  bodlDescription:
    "याचा अर्थ असा आहे की या घटकाची एकाग्रता चाचणी पद्धतीच्या किमान शोधण्याच्या मर्यादेपेक्षा कमी आहे. याचा अर्थ हा घटक पूर्णपणे अनुपस्थित आहे असे आवश्यक नाही.",

  // Table Headers - Detailed Insights
  fertilityRating: "सुपीकता श्रेणी",
  whatItMeans: "याचा अर्थ काय?",
  functionInCropGrowth: "पीक वाढीतील कार्य",

  // Nutrient Insights - Meanings
  phMeaning: "मातीची आम्लता/क्षारता",
  ecMeaning: "मातीतील क्षारांचे प्रमाण",
  ocMeaning: "मातीतील सेंद्रिय पदार्थ",
  nitrogenMeaning: "वाढीसाठी आवश्यक पोषकतत्त्व",
  phosphorusMeaning: "ऊर्जा हस्तांतरणासाठी आवश्यक पोषकतत्त्व",
  potassiumMeaning: "फळांच्या गुणवत्तेचे नियमन करणारे पोषकतत्त्व",
  sulphurMeaning: "प्रथिन निर्मितीसाठी आवश्यक पोषकतत्त्व",
  magnesiumMeaning: "क्लोरोफिलचा मुख्य घटक",
  calciumMeaning: "पेशींना मजबुती देणारे पोषकतत्त्व",
  zincMeaning: "वाढीच्या संप्रेरकांना सहाय्य करणारे पोषकतत्त्व",
  ironMeaning: "क्लोरोफिल निर्मितीसाठी आवश्यक",
  copperMeaning: "एन्झाइम सक्रिय करणारे पोषकतत्त्व",
  boronMeaning: "परागीकरण आणि फळधारणेसाठी आवश्यक",

  // Nutrient Insights - Functions
  phFunction: "पोषकतत्त्वांची उपलब्धता आणि सूक्ष्मजीवांच्या क्रियाशीलतेवर परिणाम करते",
  ecFunction: "मुळांची पाणी शोषण्याची क्षमता आणि पोषकतत्त्वांची विद्राव्यता प्रभावित करते",
  ocFunction: "सूक्ष्मजीवांची वाढ, मातीची रचना आणि पाणी धारण क्षमता सुधारते",
  nitrogenFunction: "पानांची वाढ आणि क्लोरोफिल निर्मितीला चालना देते",
  phosphorusFunction: "मुळांची वाढ आणि फुलोरा येण्यास मदत करते",
  potassiumFunction: "पाण्याचे संतुलन, रोगप्रतिकारक क्षमता आणि फळांचा आकार सुधारते",
  sulphurFunction: "एन्झाइम कार्य, तेल निर्मिती आणि चव सुधारते",
  magnesiumFunction: "प्रकाशसंश्लेषण आणि एन्झाइम सक्रियतेसाठी अत्यावश्यक",
  calciumFunction: "मजबूत पेशीभित्ती तयार करते आणि ब्लॉसम-एंड रॉट टाळते",
  zincFunction: "एन्झाइम सक्रियता, पानांचा विस्तार आणि मुळांच्या वाढीसाठी आवश्यक",
  ironFunction: "हिरव्या पानांची निर्मिती आणि श्वसनक्रियेस सहाय्य करते",
  copperFunction: "परागकणांची कार्यक्षमता आणि रोगप्रतिकारक क्षमता सुधारते",
  boronFunction: "फुलोरा, फळधारणा, साखरेचे वहन आणि बियांची निर्मिती यासाठी मदत करते",

  // Derived Insights - Meanings
  cnRatioMeaning: "मातीतील सेंद्रिय कार्बन आणि उपलब्ध नत्र यांचे गुणोत्तर",
  cecTendencyMeaning: "पोषकतत्त्वे धरून ठेवण्याची आणि त्यांची देवाणघेवाण करण्याची मातीची क्षमता (OC, Ca, Mg, K, pH यांच्या आधारे)",
  caMgRatioMeaning: "मातीतील कॅल्शियम आणि मॅग्नेशियम यांच्यातील संतुलन",
  kMgRatioMeaning: "पोटॅशियम आणि मॅग्नेशियम उपलब्धतेतील संतुलन",

  // Derived Insights - Functions
  cnRatioFunction: "सेंद्रिय पदार्थाची गुणवत्ता दर्शवते; सूक्ष्मजीवांची क्रियाशीलता आणि नत्राची उपलब्धता प्रभावित करते",
  cecTendencyFunction: "मुळांची पाणी शोषण्याची क्षमता आणि पोषकतत्त्वांची उपलब्धता प्रभावित करते",
  caMgRatioFunction: "मातीची रचना, हवेशीरपणा, पाण्याची हालचाल आणि मुळांची वाढ प्रभावित करते",
  kMgRatioFunction: "पोषकतत्त्वांच्या शोषणातील स्पर्धा नियंत्रित करते; फळांची गुणवत्ता, ताण सहन करण्याची क्षमता आणि पानांची मजबुती प्रभावित करते",

  // Derived Indicators - Effects
  cnRatioLowEffect: "सेंद्रिय पदार्थाचे जलद विघटन, नायट्रेट धूप वाढणे",
  cnRatioHighEffect: "पोषकतत्त्वे अडकून राहणे, नत्राचे खनिजीकरण मंदावणे",

  cecTendencyLowEffect: "पोषकतत्त्वे धरून ठेवण्याची क्षमता कमी, धूप होण्याचा धोका जास्त",
  cecTendencyHighEffect: "पोषकतत्त्वे मातीमध्ये खूप घट्ट बांधली जाऊ शकतात",

  caMgRatioLowEffect: "माती घट्ट होणे, हवेशीरपणा कमी होणे, पाण्याची झिरपण्याची क्षमता कमी होणे",
  caMgRatioHighEffect: "पोषकतत्त्वांमध्ये विरोध निर्माण होऊन विशेषतः मॅग्नेशियम आणि पोटॅशियमची कमतरता होऊ शकते",

  kMgRatioLowEffect: "मॅग्नेशियम जास्त असण्याची शक्यता, फळांची परिपक्वता उशिरा होऊ शकते",
  kMgRatioHighEffect: "अधिक पोटॅशियममुळे मॅग्नेशियमचे शोषण कमी होते आणि खोड कमकुवत होऊ शकते",

  // Nutrient Blocking
  phosphorusBlocks: "झिंक (Zn), लोह (Fe), तांबे (Cu)",
  potassiumBlocks: "मॅग्नेशियम (Mg), कॅल्शियम (Ca)",
  nitrogenBlocks: "तांबे (Cu), बोरॉन (B)",

    // Table Headers - Fertilizer
  stage: "टप्पा",
  input: "इनपुट",
  dose: "मात्रा",
  method: "पद्धत",

  // Table Headers - Derived Insights
  indicator: "सूचक",
  condition: "स्थिती",
  imbalanceEffect: "असंतुलनाचा परिणाम",

  // Table Headers - Nutrient Blocking
  blockingTitle: "खतांचा वापर करताना लक्षात ठेवण्यासारख्या महत्त्वाच्या बाबी",
  whenTooMuchOf: "जेव्हा याचे प्रमाण जास्त असते...",
  itBlocks: "हे अडथळा आणते...",

  // Table Headers - Crop Tips
  practice: "पद्धत",
  why: "का",

  // Status/Levels
  low: "कमी",
  medium: "सामान्य",
  high: "जास्त",

  // Messages
  cropTipsNotAvailable: "या पिकासाठी सूचना उपलब्ध नाहीत",

  cropTipsNotAvailableDesc:
    "\"{crop}\" या पिकासाठी लागवडीच्या सूचना सध्या उपलब्ध नाहीत. कृपया नंतर पुन्हा तपासा किंवा मदतीसाठी सहाय्यता विभागाशी संपर्क साधा.",

  availableCrops: "उपलब्ध पिके",

  fertilizerNotAvailable: "खताची शिफारस उपलब्ध नाही",

  fertilizerNotAvailableDesc:
    "तुमच्या मातीसाठी खतांच्या शिफारसी सध्या उपलब्ध नाहीत. कृपया नंतर पुन्हा तपासा किंवा मदतीसाठी सहाय्यता विभागाशी संपर्क साधा.",

  // Derived Parameters Section
  derivedParametersSubtitle:
    "संपूर्ण माती विश्लेषणासाठी अतिरिक्त मृदा सुपीकता निर्देशक.",

  // Notes
  phosphorusNote:
    "टीप: या अहवालात फॉस्फरसचे मूल्य P₂O₅ स्वरूपात दर्शविले आहे. P₂O₅ चे मूलद्रव्य फॉस्फरस (P) मध्ये रूपांतर करण्यासाठी मूल्याला 0.436 ने गुणा करा.",

  // Report Under Review
  underReviewHeading: "रिपोर्ट स्टेटस: तपासणी सुरू आहे",
  underReviewBody: "एक किंवा अधिक रिजल्ट्स वेरिफाय करणे गरजेचे आहे. कृपया आमच्या टेक्निकल सपोर्ट टीमशी संपर्क करा. फायनल रिपोर्ट देण्यापूर्वी पुन्हा टेस्ट करावी लागू शकते.",

  warningUnderReview: "चेतावणी: या रिपोर्टमध्ये काही चुका आहेत आणि सध्या त्याची तपासणी सुरू आहे. दाखवलेले निकाल फायनल नाहीत आणि चुकीचे असू शकतात.\n\nतुम्हाला तरीही हा रिपोर्ट डाउनलोड करायचा आहे का? (थांबण्यासाठी 'Cancel' वर क्लिक करा आणि चुका दुरुस्त करण्यासाठी सपोर्टशी संपर्क साधा).",

  // Disclaimer
  disclaimer: "अस्वीकरण",

  disclaimerWithPartner:
    "हा मृदा परीक्षण अहवाल Ekosight Technologies Private Limited आणि त्यांचे अधिकृत भागीदार [Partner Name] यांच्या सहकार्याने तयार करण्यात आला आहे. या अहवालामध्ये नमूद केलेल्या मृदा परीक्षणाचे संचालन, विश्लेषण आणि निकाल प्रदान करण्याची संपूर्ण जबाबदारी [Partner Name] यांची आहे. Ekosight Technologies या प्रक्रियेसाठी आवश्यक तंत्रज्ञान, साधने आणि विश्लेषणात्मक चौकट उपलब्ध करून देते; मात्र भागीदार प्रयोगशाळा किंवा कर्मचाऱ्यांनी तयार केलेल्या वैयक्तिक चाचणी निकालांची स्वतंत्र पडताळणी किंवा प्रमाणीकरण करत नाही. ग्राहकाने दिलेल्या नमुन्यांच्या आधारे निकालांची अचूकता, विश्वासार्हता आणि त्यांचे स्पष्टीकरण यासाठी भागीदार पूर्णपणे जबाबदार आहे. चाचणीचे निकाल फक्त प्राप्त नमुन्यावर आणि चाचणीच्या वेळी लागू असलेल्या परिस्थितींवर आधारित वैध आहेत. या निकालांवर आधारित शिफारसी केवळ मार्गदर्शनासाठी आहेत. प्रत्यक्ष शेतातील परिस्थिती, हंगामी बदल आणि कृषी व्यवस्थापन पद्धतींमुळे प्रत्यक्ष परिणाम वेगळे असू शकतात.",

  disclaimerWithoutPartner:
    "हा मृदा परीक्षण अहवाल ग्राहकाने दिलेल्या नमुन्यांवर आणि माहितीच्या आधारे Ekosight Technologies Private Limited यांनी तयार करून जारी केला आहे. या अहवालातील परीक्षण, विश्लेषण आणि स्पष्टीकरण Ekosight यांच्या मालकीच्या तंत्रज्ञान, साधने आणि विश्लेषणात्मक चौकटीचा वापर करून करण्यात आले आहे. अचूकता आणि विश्वासार्हता सुनिश्चित करण्यासाठी सर्वतोपरी प्रयत्न करण्यात आले असले तरी निकाल हे प्राप्त नमुन्याच्या स्थिती आणि गुणवत्तेपुरते मर्यादित आहेत. या अहवालातील निकाल आणि शिफारसी केवळ मार्गदर्शनासाठी आहेत. मातीतील विविधता, पर्यावरणीय परिस्थिती, पीक व्यवस्थापन पद्धती आणि हंगामी बदलांमुळे प्रत्यक्ष परिणाम भिन्न असू शकतात. या अहवालाचा किंवा त्यातील शिफारसींचा वापर करून घेतलेल्या निर्णयांमुळे होणाऱ्या कोणत्याही थेट, अप्रत्यक्ष किंवा परिणामी नुकसानासाठी Ekosight Technologies Private Limited जबाबदार राहणार नाही. Ekosight Technologies Private Limited यांची पूर्वलिखित परवानगी घेतल्याशिवाय या अहवालाचा कोणताही भाग पुनर्मुद्रित करणे किंवा व्यावसायिक अथवा सार्वजनिक उद्देशासाठी वापरणे प्रतिबंधित आहे.",

  waterDisclaimerTextWithPartner:
    "हा पाणी परीक्षण अहवाल Ekosight Technologies Private Limited आणि त्यांचे अधिकृत भागीदार [Partner Name] यांच्या सहकार्याने तयार करण्यात आला आहे. Ekosight Technologies Private Limited या प्रक्रियेसाठी आवश्यक तंत्रज्ञान, साधने आणि विश्लेषणात्मक चौकट उपलब्ध करून देते; मात्र भागीदार प्रयोगशाळा किंवा कर्मचाऱ्यांनी तयार केलेल्या वैयक्तिक चाचणी निकालांची स्वतंत्र पडताळणी किंवा प्रमाणीकरण करत नाही. ग्राहकाने दिलेल्या पाण्याच्या नमुन्यांच्या आधारे निकालांची अचूकता, विश्वासार्हता आणि त्यांचे स्पष्टीकरण यासाठी अधिकृत भागीदार पूर्णपणे जबाबदार आहे. चाचणीचे निकाल फक्त प्राप्त नमुन्यावर आणि विश्लेषणाच्या वेळी लागू असलेल्या परिस्थितींवर आधारित वैध आहेत. या निकालांवर आधारित शिफारसी किंवा स्पष्टीकरणे केवळ सामान्य मार्गदर्शनासाठी आहेत. पाण्याचा स्रोत, साठवण, हाताळणी, हंगामी बदल आणि स्थानिक पर्यावरणीय परिस्थिती यांमुळे पाण्याची प्रत्यक्ष गुणवत्ता आणि वापरयोग्यता बदलू शकते.",
  },

  odia: {
  // Header
  inAssociationWith: "ସହଯୋଗରେ",

  // User Data Labels
  name: "ନାମ",
  mobile: "ମୋବାଇଲ",
  address: "ଠିକଣା",
  cityState: "ସହର/ରାଜ୍ୟ",
  previousCrop: "ପୂର୍ବ ଫସଲ",
  farmSize: "ଚାଷ ଜମିର ଆକାର",
  farmName: "ଚାଷ ଜମିର ନାମ",
  nextCrop: "ପରବର୍ତ୍ତୀ ଫସଲ",
  sampleCode: "ନମୁନା କୋଡ୍",
  treatmentType: "ଚିକିତ୍ସା ପ୍ରକାର",
  sampleType: "ନମୁନା ପ୍ରକାର",
  reportDate: "ତାରିଖ",

  // Section Titles
  section1Title: "ମୃତ୍ତିକା ବିଶ୍ଳେଷଣ ସାରାଂଶ",
  section1Subtitle: "ଆପଣଙ୍କର ମୃତ୍ତିକା ନମୁନାରେ ଆମେ ପରୀକ୍ଷା କରିଥିବା ବିଷୟଗୁଡ଼ିକ।",

  section2Title: "ବିସ୍ତୃତ ପୋଷକ ତତ୍ତ୍ୱ ବିଶ୍ଳେଷଣ",
  section2Subtitle: "ପରୀକ୍ଷା କରାଯାଇଥିବା ପ୍ରତ୍ୟେକ ପାରାମିଟରର ବିସ୍ତୃତ ସୂଚନା।",

  section3Title: "ସାର ସୁପାରିଶ",
  section3Subtitle: "କେଉଁ ସାର, କେତେ ପରିମାଣରେ ଏବଂ କେବେ ବ୍ୟବହାର କରିବେ ତାହା ଏହି ପୃଷ୍ଠାରେ ଦିଆଯାଇଛି। ଏହି ଯୋଜନାକୁ ଅନୁସରଣ କରନ୍ତୁ।",

  section4Title: "ଉତ୍ପନ୍ନ ବିଶ୍ଳେଷଣ ଏବଂ ପୋଷକ ତତ୍ତ୍ୱ ସନ୍ତୁଳନ",
  section4Subtitle: "ଏହି ଅଂଶରେ ଅଧିକ ଗଭୀର ସୂଚନା ଦିଆଯାଇଛି। ଏହା ଉପଯୋଗୀ କିନ୍ତୁ ପଢ଼ିବା ବାଧ୍ୟତାମୂଳକ ନୁହେଁ।",

  section5Title: "ଫସଲ-ନିର୍ଦ୍ଦିଷ୍ଟ ପରାମର୍ଶ",
  section5Subtitle: "ଉତ୍ତମ ଉତ୍ପାଦନ ପାଇଁ ବିଶେଷଜ୍ଞଙ୍କ ପରାମର୍ଶିତ ଚାଷ ପଦ୍ଧତି ଅନୁସରଣ କରନ୍ତୁ।",

  // Water Report Section Title
  waterSection1Title: "ଜଳ ବିଶ୍ଳେଷଣ ସାରାଂଶ",
  waterSection1Subtitle: "ଆପଣଙ୍କର ଜଳ ନମୁନାରେ ଆମେ ପରୀକ୍ଷା କରିଥିବା ବିଷୟଗୁଡ଼ିକ।",

  waterRecommendationTitle: "ଜଳ ଚିକିତ୍ସା ସୁପାରିଶ",
  waterRecommendationSubtitle: "ଆପଣଙ୍କ ଜଳର ଗୁଣବତ୍ତା ସୁଧାର ପାଇଁ ପ୍ରସ୍ତାବିତ ସଂଶୋଧନମୂଳକ ପଦକ୍ଷେପ",

  waterPerfect: "ଜଳର ଗୁଣବତ୍ତା ଉତ୍ତମ ଅଛି",

  waterPerfectDesc: "ପରୀକ୍ଷା କରାଯାଇଥିବା ପାରାମିଟର ଅନୁଯାୟୀ କୌଣସି ସଂଶୋଧନମୂଳକ ଚିକିତ୍ସାର ଆବଶ୍ୟକତା ନାହିଁ।",

  waterRecommendationNote:
    "ଟିପ୍ପଣୀ: ଯଦି ଏକେ କାର୍ଯ୍ୟକୁ ଅନେକ ପାରାମିଟର ପାଇଁ ସୁପାରିଶ କରାଯାଇଥାଏ, ତେବେ ତାହାକୁ ପୁନରାବୃତ୍ତି କରନ୍ତୁ ନାହିଁ। ଏକମାତ୍ର ପଦକ୍ଷେପ ସାଧାରଣତଃ ଅନେକ ପାରାମିଟରକୁ ସୁଧାରିଥାଏ, ତେଣୁ ଥରେ କରିବା ଯଥେଷ୍ଟ।",
  
  // Table Headers - Soil Analysis
  sNo: "କ୍ରମ ସଂଖ୍ୟା",
  parameter: "ପାରାମିଟର",
  idealRange: "ଆଦର୍ଶ ସୀମା",
  actualValue: "ପ୍ରକୃତ ମୂଲ୍ୟ",
  status: "ସ୍ଥିତି",
  derivedParameters: "ଉତ୍ପନ୍ନ ପାରାମିଟର",

  //BODL Note
  note: "ଟିପ୍ପଣୀ",
  bodlLabel: "BODL (ଚିହ୍ନଟ ସୀମାଠାରୁ କମ୍)",
  bodlDescription:
    "ଏହା ସୂଚାଏ ଯେ ପାରାମିଟରର ଏକାଗ୍ରତା ପରୀକ୍ଷା ପଦ୍ଧତିର ସର୍ବନିମ୍ନ ଚିହ୍ନଟ ସୀମାଠାରୁ କମ୍ ଅଟେ। ଏହାର ଅର୍ଥ ପାରାମିଟରଟି ସମ୍ପୂର୍ଣ୍ଣ ଭାବେ ଅନୁପସ୍ଥିତ ବୋଲି ଆବଶ୍ୟକ ନୁହେଁ।",


  // Table Headers - Detailed Insights
  fertilityRating: "ଉର୍ବରତା ମୂଲ୍ୟାୟନ",
  whatItMeans: "ଏହାର ଅର୍ଥ କ'ଣ?",
  functionInCropGrowth: "ଫସଲ ବୃଦ୍ଧିରେ ଭୂମିକା",

  // Nutrient Insights - Meanings
  phMeaning: "ମାଟିର ଅମ୍ଳତା/କ୍ଷାରତା",
  ecMeaning: "ମାଟିରେ ଲବଣର ସ୍ତର",
  ocMeaning: "ମାଟିର ଜୈବିକ ପଦାର୍ଥ",
  nitrogenMeaning: "ବୃଦ୍ଧି ପାଇଁ ଆବଶ୍ୟକ ପୋଷକ ତତ୍ତ୍ୱ",
  phosphorusMeaning: "ଶକ୍ତି ସ୍ଥାନାନ୍ତରଣ ପାଇଁ ପୋଷକ ତତ୍ତ୍ୱ",
  potassiumMeaning: "ଫଳର ଗୁଣବତ୍ତା ନିୟନ୍ତ୍ରକ",
  sulphurMeaning: "ପ୍ରୋଟିନ ସଂଶ୍ଳେଷଣ ପାଇଁ ପୋଷକ ତତ୍ତ୍ୱ",
  magnesiumMeaning: "କ୍ଲୋରୋଫିଲର ମୁଖ୍ୟ ଉପାଦାନ",
  calciumMeaning: "କୋଷକୁ ଦୃଢତା ପ୍ରଦାନ କରେ",
  zincMeaning: "ବୃଦ୍ଧି ହରମୋନକୁ ସହାୟତା କରେ",
  ironMeaning: "କ୍ଲୋରୋଫିଲ ଗଠନ ପାଇଁ ଆବଶ୍ୟକ",
  copperMeaning: "ଏନ୍ଜାଇମକୁ ସକ୍ରିୟ କରେ",
  boronMeaning: "ପରାଗାୟନ ଓ ଫଳ ଧାରଣରେ ସାହାଯ୍ୟ କରେ",

  // Nutrient Insights - Functions
  phFunction: "ପୋଷକ ତତ୍ତ୍ୱର ଉପଲବ୍ଧତା ଏବଂ ଅଣୁଜୀବ କାର୍ଯ୍ୟକଳାପକୁ ପ୍ରଭାବିତ କରେ",
  ecFunction: "ମୂଳ ଦ୍ୱାରା ଜଳ ଶୋଷଣ ଏବଂ ପୋଷକ ତତ୍ତ୍ୱର ଦ୍ରାବ୍ୟତାକୁ ପ୍ରଭାବିତ କରେ",
  ocFunction: "ଅଣୁଜୀବ ବୃଦ୍ଧି, ମାଟିର ଗଠନ ଏବଂ ଜଳ ଧାରଣ କ୍ଷମତା ବୃଦ୍ଧି କରେ",
  nitrogenFunction: "ପତ୍ର ବୃଦ୍ଧି ଏବଂ କ୍ଲୋରୋଫିଲ ଗଠନକୁ ପ୍ରୋତ୍ସାହିତ କରେ",
  phosphorusFunction: "ମୂଳ ବିକାଶ ଏବଂ ଫୁଲ ଆସିବାରେ ସାହାଯ୍ୟ କରେ",
  potassiumFunction: "ଜଳ ସନ୍ତୁଳନ, ରୋଗ ପ୍ରତିରୋଧ କ୍ଷମତା ଏବଂ ଫଳର ଆକାରକୁ ସୁଧାରେ",
  sulphurFunction: "ଏନ୍ଜାଇମ କାର୍ଯ୍ୟ, ତେଲ ସଂଶ୍ଳେଷଣ ଏବଂ ସ୍ୱାଦକୁ ସୁଧାରେ",
  magnesiumFunction: "ପ୍ରକାଶ ସଂଶ୍ଳେଷଣ ଏବଂ ଏନ୍ଜାଇମ ସକ୍ରିୟତା ପାଇଁ ଅତ୍ୟାବଶ୍ୟକ",
  calciumFunction: "ଦୃଢ଼ କୋଷ ପ୍ରାଚୀର ଗଠନ କରେ ଏବଂ ବ୍ଲସମ୍-ଏଣ୍ଡ ରଟ୍ ରୋକେ",
  zincFunction: "ଏନ୍ଜାଇମ ସକ୍ରିୟତା, ପତ୍ର ବିସ୍ତାର ଏବଂ ମୂଳ ବୃଦ୍ଧି ପାଇଁ ଆବଶ୍ୟକ",
  ironFunction: "ସବୁଜ ପତ୍ର ଗଠନ ଏବଂ ଶ୍ୱସନ କ୍ରିୟାକୁ ସହାୟତା କରେ",
  copperFunction: "ପରାଗର ଜୀବନ୍ତତା ଏବଂ ରୋଗ ପ୍ରତିରୋଧ କ୍ଷମତାକୁ ପ୍ରଭାବିତ କରେ",
  boronFunction: "ଫୁଲ ଆସିବା, ଫଳ ଧାରଣ, ଶର୍କରା ପରିବହନ ଏବଂ ବୀଜ ଗଠନରେ ସାହାଯ୍ୟ କରେ",

  // Derived Insights - Meanings
  cnRatioMeaning: "ମାଟିର ଜୈବିକ କାର୍ବନ ଏବଂ ଉପଲବ୍ଧ ନାଇଟ୍ରୋଜେନର ଅନୁପାତ",
  cecTendencyMeaning: "ପୋଷକ ତତ୍ତ୍ୱକୁ ଧରି ରଖିବା ଏବଂ ବିନିମୟ କରିବାରେ ମାଟିର କ୍ଷମତା (OC, Ca, Mg, K, pH ଉପରେ ଆଧାରିତ)",
  caMgRatioMeaning: "ମାଟିରେ କ୍ୟାଲସିୟମ ଏବଂ ମ୍ୟାଗ୍ନେସିୟମ ମଧ୍ୟରେ ସନ୍ତୁଳନ",
  kMgRatioMeaning: "ପଟାସିୟମ ଏବଂ ମ୍ୟାଗ୍ନେସିୟମର ଉପଲବ୍ଧତା ମଧ୍ୟରେ ସନ୍ତୁଳନ",

  // Derived Insights - Functions
  cnRatioFunction: "ଜୈବିକ ପଦାର୍ଥର ଗୁଣବତ୍ତା ସୂଚାଏ; ଅଣୁଜୀବ କାର୍ଯ୍ୟକଳାପ ଏବଂ ନାଇଟ୍ରୋଜେନର ଉପଲବ୍ଧତାକୁ ପ୍ରଭାବିତ କରେ",
  cecTendencyFunction: "ମୂଳ ଦ୍ୱାରା ଜଳ ଶୋଷଣ ଏବଂ ପୋଷକ ତତ୍ତ୍ୱର ଉପଲବ୍ଧତାକୁ ପ୍ରଭାବିତ କରେ",
  caMgRatioFunction: "ମାଟିର ଗଠନ, ବାୟୁ ଚଳାଚଳ, ଜଳର ଗତିବିଧି ଏବଂ ମୂଳ ବିକାଶକୁ ପ୍ରଭାବିତ କରେ",
  kMgRatioFunction: "ପୋଷକ ତତ୍ତ୍ୱ ଶୋଷଣରେ ପ୍ରତିସ୍ପର୍ଦ୍ଧାକୁ ନିୟନ୍ତ୍ରଣ କରେ; ଫଳର ଗୁଣବତ୍ତା, ପ୍ରତିକୂଳ ପରିସ୍ଥିତି ସହିବା କ୍ଷମତା ଏବଂ ପତ୍ରର ଦୃଢତାକୁ ପ୍ରଭାବିତ କରେ",

  // Derived Indicators - Effects
  cnRatioLowEffect: "ଜୈବିକ ପଦାର୍ଥ ଶୀଘ୍ର ବିଘଟନ ହୁଏ, ନାଇଟ୍ରେଟ ଲିଚିଂ ବଢ଼ିଯାଏ",
  cnRatioHighEffect: "ପୋଷକ ତତ୍ତ୍ୱ ବନ୍ଧି ରହିଯାଏ, ନାଇଟ୍ରୋଜେନର ଖଣିଜୀକରଣ ଧୀର ହୁଏ",

  cecTendencyLowEffect: "ପୋଷକ ତତ୍ତ୍ୱ ଧରି ରଖିବାର କ୍ଷମତା କମିଯାଏ, ଲିଚିଂର ଝୁମ୍ପ ବଢ଼ିଯାଏ",
  cecTendencyHighEffect: "ପୋଷକ ତତ୍ତ୍ୱ ମାଟିରେ ଅତ୍ୟଧିକ ଦୃଢ଼ ଭାବରେ ବନ୍ଧି ରହିପାରେ",

  caMgRatioLowEffect: "ମାଟି କଠିନ ହୋଇଯାଏ, ବାୟୁ ଚଳାଚଳ କମିଯାଏ ଏବଂ ଜଳ ପ୍ରବେଶ କମିଯାଏ",
  caMgRatioHighEffect: "ପୋଷକ ତତ୍ତ୍ୱ ମଧ୍ୟରେ ବିରୋଧ ସୃଷ୍ଟି ହୋଇ ବିଶେଷକରି ମ୍ୟାଗ୍ନେସିୟମ ଏବଂ ପଟାସିୟମର ଅଭାବ ହୋଇପାରେ",

  kMgRatioLowEffect: "ମ୍ୟାଗ୍ନେସିୟମ ଅଧିକ ହେବାର ସମ୍ଭାବନା, ଫଳ ପାଚିବାରେ ବିଳମ୍ବ ହୋଇପାରେ",
  kMgRatioHighEffect: "ଅଧିକ ପଟାସିୟମ ମ୍ୟାଗ୍ନେସିୟମର ଶୋଷଣକୁ ଦମନ କରେ, ଫଳରେ ଦୁର୍ବଳ କାଣ୍ଡ ସୃଷ୍ଟି ହୁଏ",

  // Nutrient Blocking
  phosphorusBlocks: "ଜିଙ୍କ (Zn), ଲୌହ (Fe), ତମ୍ବା (Cu)",
  potassiumBlocks: "ମ୍ୟାଗ୍ନେସିୟମ (Mg), କ୍ୟାଲସିୟମ (Ca)",
  nitrogenBlocks: "ତମ୍ବା (Cu), ବୋରନ (B)",

  // Table Headers - Fertilizer
  stage: "ପର୍ଯ୍ୟାୟ",
  input: "ଇନପୁଟ୍",
  dose: "ମାତ୍ରା",
  method: "ପଦ୍ଧତି",

  // Table Headers - Derived Insights
  indicator: "ସୂଚକ",
  condition: "ସ୍ଥିତି",
  imbalanceEffect: "ଅସନ୍ତୁଳନର ପ୍ରଭାବ",

  // Table Headers - Nutrient Blocking
  blockingTitle: "ସାର ପ୍ରୟୋଗ ସମୟରେ ମନେ ରଖିବାକୁ ଥିବା ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ବିଷୟ",
  whenTooMuchOf: "ଯେତେବେଳେ ଏହାର ପରିମାଣ ଅଧିକ ହୁଏ...",
  itBlocks: "ଏହା ବାଧା ଦେଇଥାଏ...",

  // Table Headers - Crop Tips
  practice: "ପଦ୍ଧତି",
  why: "କାହିଁକି",

  // Status/Levels
  low: "କମ୍",
  medium: "ସାଧାରଣ",
  high: "ଅଧିକ",

  // Messages
  cropTipsNotAvailable: "ଏହି ଫସଲ ପାଇଁ ପରାମର୍ଶ ଉପଲବ୍ଧ ନାହିଁ",

  cropTipsNotAvailableDesc:
    "\"{crop}\" ଫସଲ ପାଇଁ ଚାଷ ସମ୍ବନ୍ଧୀୟ ପରାମର୍ଶ ବର୍ତ୍ତମାନ ଉପଲବ୍ଧ ନାହିଁ। ଦୟାକରି ପରେ ପୁଣିଥରେ ଯାଞ୍ଚ କରନ୍ତୁ କିମ୍ବା ସହାୟତା ପାଇଁ ସପୋର୍ଟ ସହିତ ଯୋଗାଯୋଗ କରନ୍ତୁ।",

  availableCrops: "ଉପଲବ୍ଧ ଫସଲଗୁଡ଼ିକ",

  fertilizerNotAvailable: "ସାର ସୁପାରିଶ ଉପଲବ୍ଧ ନାହିଁ",

  fertilizerNotAvailableDesc:
    "ଆପଣଙ୍କର ମାଟି ପାଇଁ ସାର ସୁପାରିଶ ବର୍ତ୍ତମାନ ଉପଲବ୍ଧ ନାହିଁ। ଦୟାକରି ପରେ ପୁଣିଥରେ ଯାଞ୍ଚ କରନ୍ତୁ କିମ୍ବା ସହାୟତା ପାଇଁ ସପୋର୍ଟ ସହିତ ଯୋଗାଯୋଗ କରନ୍ତୁ।",

  // Derived Parameters Section
  derivedParametersSubtitle:
    "ସମ୍ପୂର୍ଣ୍ଣ ମୃତ୍ତିକା ବିଶ୍ଳେଷଣ ପାଇଁ ଅତିରିକ୍ତ ମୃତ୍ତିକା ଉର୍ବରତା ସୂଚକଗୁଡ଼ିକ।",

  // Notes
  phosphorusNote:
    "ଟିପ୍ପଣୀ: ଏହି ରିପୋର୍ଟରେ ଫସଫରସର ମୂଲ୍ୟ P₂O₅ ରୂପରେ ଦର୍ଶାଯାଇଛି। P₂O₅ କୁ ମୌଳିକ ଫସଫରସ (P) ରେ ପରିବର୍ତ୍ତନ କରିବା ପାଇଁ ମୂଲ୍ୟକୁ 0.436 ସହିତ ଗୁଣନ କରନ୍ତୁ।",

  // Report Under Review
  underReviewHeading: "ରିପୋର୍ଟ ଷ୍ଟାଟସ୍: ଯାଞ୍ଚ ଚାଲିଛି",
  underReviewBody: "ଗୋଟିଏ କିମ୍ବା ଅଧିକ ରିଜଲ୍ଟକୁ ଭେରିଫାଇ କରିବା ଦରକାର। ଦୟାକରି ଆମ ଟେକ୍ନିକାଲ୍ ସପୋର୍ଟ ଟିମ୍ ସହିତ ଯୋଗାଯୋଗ କରନ୍ତୁ। ଫାଇନାଲ୍ ରିପୋର୍ଟ ଦେବା ପୂର୍ବରୁ ପୁଣିଥରେ ଟେଷ୍ଟ କରିବାକୁ ପଡ଼ିପାରେ।",

  warningUnderReview: "ଚେତାବନୀ: ଏହି ରିପୋର୍ଟରେ କିଛି ଭୁଲ ଅଛି ଏବଂ ବର୍ତ୍ତମାନ ଏହାକୁ ଚେକ୍ କରାଯାଉଛି। ଦେଖାଯାଇଥିବା ରେଜଲ୍ଟ ଫାଇନାଲ୍ ନୁହେଁ ଏବଂ ଭୁଲ ହୋଇପାରେ।\n\nଆପଣ ତଥାପି ଏହାକୁ ଡାଉନଲୋଡ୍ କରିବାକୁ ଚାହୁଁଛନ୍ତି କି? (ଅଟକିବା ପାଇଁ 'Cancel' ଦବାନ୍ତୁ ଏବଂ ଭୁଲ ଠିକ୍ କରିବାକୁ ସପୋର୍ଟ ସହିତ ଯୋଗାଯୋଗ କରନ୍ତୁ)।",

  // Disclaimer
  disclaimer: "ଅସ୍ୱୀକରଣ",

  disclaimerWithPartner:
    "ଏହି ମୃତ୍ତିକା ପରୀକ୍ଷା ରିପୋର୍ଟ Ekosight Technologies Private Limited ଏବଂ ଏହାର ଅଧିକୃତ ସହଯୋଗୀ [Partner Name]ଙ୍କ ସହଯୋଗରେ ପ୍ରସ୍ତୁତ କରାଯାଇଛି। ଏହି ରିପୋର୍ଟରେ ଉଲ୍ଲେଖିତ ମୃତ୍ତିକା ପରୀକ୍ଷା, ବିଶ୍ଳେଷଣ ଏବଂ ଫଳାଫଳ ପ୍ରଦାନ କରିବାର ସମ୍ପୂର୍ଣ୍ଣ ଦାୟିତ୍ୱ [Partner Name]ଙ୍କର। Ekosight Technologies ଏହି ପ୍ରକ୍ରିୟାରେ ବ୍ୟବହୃତ ପରୀକ୍ଷା ପ୍ରଯୁକ୍ତି, ଉପକରଣ ଏବଂ ବିଶ୍ଳେଷଣାତ୍ମକ ଢାଞ୍ଚା ପ୍ରଦାନ କରେ, କିନ୍ତୁ ସହଯୋଗୀ ପରୀକ୍ଷାଗାର କିମ୍ବା କର୍ମଚାରୀଙ୍କ ଦ୍ୱାରା ପ୍ରସ୍ତୁତ ବ୍ୟକ୍ତିଗତ ପରୀକ୍ଷା ଫଳାଫଳକୁ ସ୍ୱାଧୀନ ଭାବେ ଯାଞ୍ଚ କିମ୍ବା ପ୍ରମାଣିତ କରେ ନାହିଁ। ଗ୍ରାହକଙ୍କ ଦ୍ୱାରା ପ୍ରଦାନ କରାଯାଇଥିବା ନମୁନା ଆଧାରରେ ଫଳାଫଳର ସଠିକତା, ବିଶ୍ୱସନୀୟତା ଏବଂ ବ୍ୟାଖ୍ୟା ପାଇଁ ସହଯୋଗୀ ସମ୍ପୂର୍ଣ୍ଣ ଭାବେ ଦାୟୀ। ପରୀକ୍ଷା ଫଳାଫଳ କେବଳ ପ୍ରାପ୍ତ ନମୁନା ଏବଂ ପରୀକ୍ଷା ସମୟରେ ପ୍ରୟୋଗ ହୋଇଥିବା ପରିସ୍ଥିତି ପାଇଁ ମାତ୍ର ବୈଧ। ଏହି ଫଳାଫଳ ଆଧାରିତ ସୁପାରିଶଗୁଡ଼ିକ କେବଳ ମାର୍ଗଦର୍ଶନ ପାଇଁ। କ୍ଷେତ୍ର ପରିସ୍ଥିତି, ଋତୁଗତ ପରିବର୍ତ୍ତନ ଏବଂ କୃଷି ପରିଚାଳନା ପଦ୍ଧତି କାରଣରୁ ପ୍ରକୃତ ଫଳାଫଳ ଭିନ୍ନ ହୋଇପାରେ।",

  disclaimerWithoutPartner:
    "ଏହି ମୃତ୍ତିକା ପରୀକ୍ଷା ରିପୋର୍ଟ ଗ୍ରାହକଙ୍କ ଦ୍ୱାରା ପ୍ରଦାନ କରାଯାଇଥିବା ନମୁନା ଏବଂ ସୂଚନା ଆଧାରରେ Ekosight Technologies Private Limited ଦ୍ୱାରା ପ୍ରସ୍ତୁତ ଏବଂ ଜାରି କରାଯାଇଛି। ଏହି ରିପୋର୍ଟରେ ଥିବା ପରୀକ୍ଷା, ବିଶ୍ଳେଷଣ ଏବଂ ବ୍ୟାଖ୍ୟା Ekosightର ସ୍ୱାମୀତ୍ୱାଧୀନ ପ୍ରଯୁକ୍ତି, ଉପକରଣ ଏବଂ ବିଶ୍ଳେଷଣାତ୍ମକ ଢାଞ୍ଚା ବ୍ୟବହାର କରି କରାଯାଇଛି। ସଠିକତା ଏବଂ ବିଶ୍ୱସନୀୟତା ନିଶ୍ଚିତ କରିବାକୁ ସମସ୍ତ ପ୍ରୟାସ କରାଯାଇଥିଲେ ମଧ୍ୟ, ଫଳାଫଳ ପ୍ରାପ୍ତ ନମୁନାର ସ୍ଥିତି ଏବଂ ଗୁଣବତ୍ତା ପର୍ଯ୍ୟନ୍ତ ସୀମିତ। ଏହି ରିପୋର୍ଟରେ ଥିବା ଫଳାଫଳ ଏବଂ ସୁପାରିଶଗୁଡ଼ିକ କେବଳ ମାର୍ଗଦର୍ଶନ ପାଇଁ। ମାଟିର ବିଭିନ୍ନତା, ପରିବେଶଗତ ପରିସ୍ଥିତି, ଫସଲ ପରିଚାଳନା ପଦ୍ଧତି ଏବଂ ଋତୁଗତ ପରିବର୍ତ୍ତନ ହେତୁ ପ୍ରକୃତ ଫଳାଫଳ ଭିନ୍ନ ହୋଇପାରେ। ଏହି ରିପୋର୍ଟ କିମ୍ବା ଏହାର ସୁପାରିଶ ବ୍ୟବହାର କରି ନିଆଯାଇଥିବା କୌଣସି ପ୍ରତ୍ୟକ୍ଷ, ପରୋକ୍ଷ କିମ୍ବା ପରିଣାମସ୍ୱରୂପ କ୍ଷତି, ହାନି କିମ୍ବା ନିଷ୍ପତ୍ତି ପାଇଁ Ekosight Technologies Private Limited ଦାୟୀ ରହିବ ନାହିଁ। Ekosight Technologies Private Limitedଙ୍କ ପୂର୍ବ ଲିଖିତ ଅନୁମତି ବିନା ଏହି ରିପୋର୍ଟର କୌଣସି ଅଂଶକୁ ପୁନଃପ୍ରକାଶ କିମ୍ବା ବାଣିଜ୍ୟିକ କିମ୍ବା ସାର୍ବଜନୀନ ଉଦ୍ଦେଶ୍ୟରେ ବ୍ୟବହାର କରାଯିବ ନାହିଁ।",

  waterDisclaimerTextWithPartner:
    "ଏହି ଜଳ ପରୀକ୍ଷା ରିପୋର୍ଟ Ekosight Technologies Private Limited ଏବଂ ଏହାର ଅଧିକୃତ ସହଯୋଗୀ [Partner Name]ଙ୍କ ସହଯୋଗରେ ପ୍ରସ୍ତୁତ କରାଯାଇଛି। Ekosight Technologies Private Limited ଏହି ପ୍ରକ୍ରିୟାରେ ବ୍ୟବହୃତ ପରୀକ୍ଷା ପ୍ରଯୁକ୍ତି, ଉପକରଣ ଏବଂ ବିଶ୍ଳେଷଣାତ୍ମକ ଢାଞ୍ଚା ପ୍ରଦାନ କରେ, କିନ୍ତୁ ସହଯୋଗୀ ପରୀକ୍ଷାଗାର କିମ୍ବା କର୍ମଚାରୀଙ୍କ ଦ୍ୱାରା ପ୍ରସ୍ତୁତ ବ୍ୟକ୍ତିଗତ ପରୀକ୍ଷା ଫଳାଫଳକୁ ସ୍ୱାଧୀନ ଭାବେ ଯାଞ୍ଚ କିମ୍ବା ପ୍ରମାଣିତ କରେ ନାହିଁ। ଗ୍ରାହକଙ୍କ ଦ୍ୱାରା ପ୍ରଦାନ କରାଯାଇଥିବା ଜଳ ନମୁନା ଆଧାରରେ ଫଳାଫଳର ସଠିକତା, ବିଶ୍ୱସନୀୟତା ଏବଂ ବ୍ୟାଖ୍ୟା ପାଇଁ ଅଧିକୃତ ସହଯୋଗୀ ସମ୍ପୂର୍ଣ୍ଣ ଭାବେ ଦାୟୀ। ପରୀକ୍ଷା ଫଳାଫଳ କେବଳ ପ୍ରାପ୍ତ ନମୁନା ଏବଂ ବିଶ୍ଳେଷଣ ସମୟରେ ପ୍ରୟୋଗ ହୋଇଥିବା ପରିସ୍ଥିତି ପାଇଁ ବୈଧ। ଏହି ଫଳାଫଳ ଆଧାରିତ ସୁପାରିଶ କିମ୍ବା ବ୍ୟାଖ୍ୟା କେବଳ ସାଧାରଣ ମାର୍ଗଦର୍ଶନ ପାଇଁ। ଜଳର ଉତ୍ସ, ସଂରକ୍ଷଣ, ପରିଚାଳନା, ଋତୁଗତ ପରିବର୍ତ୍ତନ ଏବଂ ସ୍ଥାନଭିତ୍ତିକ ପରିବେଶଗତ ପରିସ୍ଥିତି ହେତୁ ପ୍ରକୃତ ଜଳ ଗୁଣବତ୍ତା ଏବଂ ବ୍ୟବହାରଯୋଗ୍ୟତା ଭିନ୍ନ ହୋଇପାରେ।",
  },
  
  bengali: {
    // Header
    inAssociationWith: "সহযোগিতায়",

    // User Data Labels
    name: "নাম",
    mobile: "মোবাইল",
    address: "ঠিকানা",
    cityState: "শহর/রাজ্য",
    previousCrop: "পূর্ববর্তী ফসল",
    farmSize: "খামারের আকার",
    farmName: "খামারের নাম",
    nextCrop: "পরবর্তী ফসল",
    sampleCode: "নমুনা কোড",
    treatmentType: "চিকিৎসার ধরন",
    sampleType: "নমুনার ধরন",
    reportDate: "তারিখ",

    // Section Titles
    section1Title: "মাটির বিশ্লেষণের সারাংশ",
    section1Subtitle: "আপনার মাটির নমুনায় আমরা যা পরীক্ষা করেছি।",

    section2Title: "পুষ্টি উপাদানের বিস্তারিত বিশ্লেষণ",
    section2Subtitle: "পরীক্ষিত প্রতিটি উপাদানের বিস্তারিত তথ্য।",

    section3Title: "সারের সুপারিশ",
    section3Subtitle: "এই অংশে কোন সার, কত পরিমাণে এবং কখন ব্যবহার করবেন তা উল্লেখ করা হয়েছে। এই পরিকল্পনা অনুসরণ করুন।",

    section4Title: "উৎপন্ন বিশ্লেষণ ও পুষ্টির ভারসাম্য",
    section4Subtitle: "এই অংশে অতিরিক্ত বিশ্লেষণ দেওয়া হয়েছে। এটি উপকারী, তবে পড়া বাধ্যতামূলক নয়।",

    section5Title: "ফসলভিত্তিক পরামর্শ",
    section5Subtitle: "উন্নত ফলনের জন্য বিশেষজ্ঞদের চাষাবাদ সংক্রান্ত পরামর্শ।",

    // Water Report Section
    waterSection1Title: "জলের বিশ্লেষণের সারাংশ",
    waterSection1Subtitle: "আপনার জলের নমুনায় আমরা যা পরীক্ষা করেছি।",

    waterRecommendationTitle: "জল শোধনের সুপারিশ",
    waterRecommendationSubtitle: "আপনার জলের গুণমান অনুযায়ী প্রস্তাবিত সংশোধনমূলক ব্যবস্থা",

    waterPerfect: "জলের গুণমান সর্বোত্তম",
    waterPerfectDesc: "পরীক্ষিত মানদণ্ড অনুযায়ী কোনো সংশোধনমূলক ব্যবস্থা প্রয়োজন নেই।",

    waterRecommendationNote:
      "দ্রষ্টব্য: একই পদক্ষেপ যদি একাধিক উপাদানের জন্য সুপারিশ করা হয়, তবে তা বারবার করার প্রয়োজন নেই। একটি সঠিক ব্যবস্থা সাধারণত একাধিক সমস্যার উন্নতি ঘটায়, তাই একবার প্রয়োগ করাই যথেষ্ট।",

    // Table Headers - Soil Analysis
    sNo: "ক্রমিক নং",
    parameter: "উপাদান",
    idealRange: "আদর্শ সীমা",
    actualValue: "প্রকৃত মান",
    status: "অবস্থা",
    derivedParameters: "উৎপন্ন উপাদান",

    // BODL Note
    note: "দ্রষ্টব্য",
    bodlLabel: "BODL (সনাক্তকরণ সীমার নিচে)",
    bodlDescription:
      "এটি নির্দেশ করে যে প্যারামিটারের ঘনত্ব পরীক্ষার পদ্ধতির ন্যূনতম সনাক্তকরণ সীমার নিচে রয়েছে। এর অর্থ এই নয় যে প্যারামিটারটি সম্পূর্ণভাবে অনুপস্থিত।",

    // Table Headers - Detailed Insights
    fertilityRating: "উর্বরতার স্তর",
    whatItMeans: "এর অর্থ কী?",
    functionInCropGrowth: "ফসলের বৃদ্ধিতে ভূমিকা",

        // Nutrient Insights - Meanings
    phMeaning: "মাটির অম্লতা/ক্ষারত্ব",
    ecMeaning: "মাটিতে লবণের মাত্রা",
    ocMeaning: "মাটির জৈব পদার্থ",
    nitrogenMeaning: "বৃদ্ধির জন্য প্রয়োজনীয় পুষ্টি",
    phosphorusMeaning: "শক্তি স্থানান্তর",
    potassiumMeaning: "ফলের গুণমান নিয়ন্ত্রক",
    sulphurMeaning: "প্রোটিন সংশ্লেষণ",
    magnesiumMeaning: "ক্লোরোফিলের মূল উপাদান",
    calciumMeaning: "কোষের দৃঢ়তা",
    zincMeaning: "বৃদ্ধি হরমোনে সহায়ক",
    ironMeaning: "ক্লোরোফিল গঠনে সহায়ক",
    copperMeaning: "এনজাইম সক্রিয়কারী",
    boronMeaning: "পরাগায়ন ও ফল ধারণ",

    // Nutrient Insights - Functions
    phFunction: "পুষ্টি উপাদানের প্রাপ্যতা ও অণুজীবের কার্যকলাপকে প্রভাবিত করে",
    ecFunction: "শিকড়ের পানি গ্রহণ ও পুষ্টি দ্রবণীয়তাকে প্রভাবিত করে",
    ocFunction: "অণুজীবের বৃদ্ধি, মাটির গঠন ও পানি ধারণ ক্ষমতা বাড়ায়",
    nitrogenFunction: "পাতার বৃদ্ধি ও ক্লোরোফিল গঠনে সহায়তা করে",
    phosphorusFunction: "শিকড়ের বৃদ্ধি ও ফুল ফোটায় সহায়তা করে",
    potassiumFunction: "জলের ভারসাম্য, রোগ প্রতিরোধ ও ফলের আকার উন্নত করে",
    sulphurFunction: "এনজাইমের কার্যকারিতা, তেল সংশ্লেষণ ও স্বাদ উন্নত করে",
    magnesiumFunction: "প্রকাশ-সংশ্লেষণ ও এনজাইম সক্রিয়করণের জন্য অপরিহার্য",
    calciumFunction: "কোষপ্রাচীরকে শক্তিশালী করে এবং ব্লসম-এন্ড রট প্রতিরোধ করে",
    zincFunction: "এনজাইম সক্রিয়করণ, পাতার বিস্তার ও শিকড় বৃদ্ধিতে প্রয়োজনীয়",
    ironFunction: "সবুজ পাতা গঠন ও শ্বাস-প্রশ্বাস প্রক্রিয়ায় সহায়তা করে",
    copperFunction: "পরাগের কার্যক্ষমতা ও রোগ প্রতিরোধ ক্ষমতা বাড়ায়",
    boronFunction: "ফুল ফোটা, ফল ধারণ, শর্করা পরিবহন ও বীজ গঠনে সহায়তা করে",

    // Derived Insights - Meanings
    cnRatioMeaning: "মাটির জৈব কার্বন ও উপলব্ধ নাইট্রোজেনের অনুপাত",
    cecTendencyMeaning: "পুষ্টি ধরে রাখা ও বিনিময় করার মাটির ক্ষমতা (OC, Ca, Mg, K ও pH-এর ভিত্তিতে)",
    caMgRatioMeaning: "মাটিতে ক্যালসিয়াম ও ম্যাগনেসিয়ামের ভারসাম্য",
    kMgRatioMeaning: "পটাশিয়াম ও ম্যাগনেসিয়ামের প্রাপ্যতার ভারসাম্য",

    // Derived Insights - Functions
    cnRatioFunction: "জৈব পদার্থের গুণমান নির্দেশ করে; অণুজীবের কার্যকলাপ ও নাইট্রোজেনের প্রাপ্যতাকে প্রভাবিত করে",
    cecTendencyFunction: "মাটির পুষ্টি ধারণ ক্ষমতা ও শিকড়ের পুষ্টি গ্রহণকে প্রভাবিত করে",
    caMgRatioFunction: "মাটির গঠন, বায়ু চলাচল, পানি প্রবাহ ও শিকড়ের প্রবেশকে প্রভাবিত করে",
    kMgRatioFunction: "পুষ্টি গ্রহণের প্রতিযোগিতা নিয়ন্ত্রণ করে; ফলের গুণমান, চাপ সহনশীলতা ও পাতার দৃঢ়তাকে প্রভাবিত করে",

    // Derived Indicators - Effects
    cnRatioLowEffect: "জৈব পদার্থ দ্রুত ভেঙে যায় এবং নাইট্রেট ধুয়ে যাওয়ার ঝুঁকি বাড়ে",
    cnRatioHighEffect: "পুষ্টি আটকে যায় এবং নাইট্রোজেন খনিজায়ন ধীর হয়",
    cecTendencyLowEffect: "পুষ্টি ধারণ ক্ষমতা কম, ধুয়ে যাওয়ার ঝুঁকি বেশি",
    cecTendencyHighEffect: "পুষ্টি অতিরিক্ত শক্তভাবে আবদ্ধ থাকতে পারে",
    caMgRatioLowEffect: "মাটি শক্ত হয়ে যায়, বায়ু চলাচল কমে এবং পানি প্রবেশ বাধাগ্রস্ত হয়",
    caMgRatioHighEffect: "পুষ্টির পারস্পরিক বাধা সৃষ্টি হয়, বিশেষ করে Mg ও K-এর ঘাটতি দেখা দিতে পারে",
    kMgRatioLowEffect: "ম্যাগনেসিয়ামের আধিক্য হতে পারে, ফলে ফল পাকতে দেরি হতে পারে",
    kMgRatioHighEffect: "পটাশিয়াম ম্যাগনেসিয়াম গ্রহণে বাধা দেয়, ফলে কাণ্ড দুর্বল হয়",

    // Nutrient Blocking
    phosphorusBlocks: "জিঙ্ক (Zn), লোহা (Fe), তামা (Cu)",
    potassiumBlocks: "ম্যাগনেসিয়াম (Mg), ক্যালসিয়াম (Ca)",
    nitrogenBlocks: "তামা (Cu), বোরন (B)",

        // Table Headers - Fertilizer
    stage: "পর্যায়",
    input: "উপকরণ",
    dose: "মাত্রা",
    method: "প্রয়োগ পদ্ধতি",

    // Table Headers - Derived Insights
    indicator: "সূচক",
    condition: "অবস্থা",
    imbalanceEffect: "ভারসাম্যহীনতার প্রভাব",

    // Table Headers - Nutrient Blocking
    blockingTitle: "সার প্রয়োগের সময় মনে রাখার বিষয়",
    whenTooMuchOf: "যখন অতিরিক্ত থাকে...",
    itBlocks: "এটি বাধা দেয়...",

    // Table Headers - Crop Tips
    practice: "পরামর্শ",
    why: "কারণ",

    // Status/Levels
    low: "কম",
    medium: "স্বাভাবিক",
    high: "বেশি",

    // Messages
    cropTipsNotAvailable: "ফসলভিত্তিক পরামর্শ উপলব্ধ নয়",
    cropTipsNotAvailableDesc:
      "বর্তমানে \"{crop}\" ফসলের জন্য আমাদের কাছে চাষাবাদ সংক্রান্ত পরামর্শ নেই। অনুগ্রহ করে পরে আবার দেখুন অথবা সহায়তার জন্য সাপোর্টের সাথে যোগাযোগ করুন।",

    availableCrops: "উপলব্ধ ফসল",

    fertilizerNotAvailable: "সারের সুপারিশ উপলব্ধ নয়",
    fertilizerNotAvailableDesc:
      "বর্তমানে আপনার মাটির জন্য আমাদের কাছে সারের সুপারিশ নেই। অনুগ্রহ করে পরে আবার দেখুন অথবা সহায়তার জন্য সাপোর্টের সাথে যোগাযোগ করুন।",

    // Derived Parameters Section
    derivedParametersSubtitle:
      "মাটির উর্বরতার অতিরিক্ত সূচকসমূহ, যা আরও বিস্তৃত বিশ্লেষণ প্রদান করে।",

    // Notes
    phosphorusNote:
      "দ্রষ্টব্য: এই প্রতিবেদনে ফসফরাসের মান P₂O₅ আকারে প্রকাশ করা হয়েছে। P₂O₅-কে মৌলিক ফসফরাস (P)-এ রূপান্তর করতে মানকে 0.436 দ্বারা গুণ করুন।",

    // Report Under Review
    underReviewHeading: "রিপোর্ট স্ট্যাটাস: চেক করা হচ্ছে",
    underReviewBody: "এক বা একাধিক রেজাল্ট ভেরিফাই করা দরকার। অনুগ্রহ করে আমাদের টেকনিক্যাল সাপোর্ট টিমের সঙ্গে যোগাযোগ করুন। ফাইনাল রিপোর্ট দেওয়ার আগে আবার টেস্ট করতে হতে পারে।",

    warningUnderReview: "সতর্কতা: এই রিপোর্টে কিছু ভুল আছে এবং বর্তমানে এটি চেক করা হচ্ছে। দেখানো রেজাল্টগুলো ফাইনাল নয় এবং ভুল হতে পারে।\n\nআপনি কি তবুও এটি ডাউনলোড করতে চান? (থামার জন্য 'Cancel' চাপুন এবং ভুলগুলো ঠিক করতে সাপোর্টের সাথে যোগাযোগ করুন)।",

        // Disclaimer
    disclaimer: "দাবিত্যাগ",

    disclaimerWithPartner:
      "এই মাটি পরীক্ষার প্রতিবেদনটি Ekosight Technologies Private Limited এবং তাদের অনুমোদিত অংশীদার [Partner Name]-এর সহযোগিতায় প্রস্তুত করা হয়েছে। এই প্রতিবেদনে প্রদত্ত মাটি পরীক্ষা, বিশ্লেষণ এবং ফলাফল প্রদানের সম্পূর্ণ দায়িত্ব [Partner Name]-এর। Ekosight Technologies Private Limited এই প্রক্রিয়ায় ব্যবহৃত পরীক্ষার প্রযুক্তি, সরঞ্জাম এবং বিশ্লেষণাত্মক কাঠামো প্রদান করে, তবে অংশীদার ল্যাবরেটরি বা কর্মীদের দ্বারা প্রস্তুত পৃথক পরীক্ষার ফলাফল স্বাধীনভাবে যাচাই বা সত্যতা নিশ্চিত করে না। গ্রাহকের সরবরাহকৃত নমুনার ভিত্তিতে ফলাফলের যথার্থতা, নির্ভরযোগ্যতা এবং ব্যাখ্যার সম্পূর্ণ দায়িত্ব অনুমোদিত অংশীদারের। পরীক্ষার ফলাফল শুধুমাত্র প্রাপ্ত নমুনা এবং পরীক্ষার সময় প্রযোজ্য নির্দিষ্ট শর্তের জন্যই বৈধ। এই ফলাফলের ভিত্তিতে প্রদত্ত সুপারিশসমূহ শুধুমাত্র নির্দেশিকা হিসেবে বিবেচ্য; মাঠের অবস্থা, মৌসুমি পরিবর্তন এবং কৃষি-সংক্রান্ত বিভিন্ন কারণের কারণে বাস্তব ফলাফল ভিন্ন হতে পারে।",

    disclaimerWithoutPartner:
      "এই মাটি পরীক্ষার প্রতিবেদনটি গ্রাহকের সরবরাহকৃত নমুনা ও তথ্যের ভিত্তিতে Ekosight Technologies Private Limited কর্তৃক প্রস্তুত ও প্রকাশ করা হয়েছে। এই প্রতিবেদনে উপস্থাপিত পরীক্ষা, বিশ্লেষণ এবং ব্যাখ্যা Ekosight-এর নিজস্ব প্রযুক্তি, সরঞ্জাম এবং বিশ্লেষণাত্মক কাঠামো ব্যবহার করে সম্পন্ন হয়েছে। যথাসম্ভব নির্ভুলতা ও নির্ভরযোগ্যতা নিশ্চিত করার চেষ্টা করা হলেও, ফলাফল শুধুমাত্র প্রাপ্ত নমুনার অবস্থা ও গুণগত মানের ওপর নির্ভরশীল। প্রদত্ত ফলাফল ও সুপারিশ শুধুমাত্র নির্দেশনামূলক উদ্দেশ্যে প্রদান করা হয়েছে। মাটির স্বাভাবিক বৈচিত্র্য, পরিবেশগত অবস্থা, ফসল ব্যবস্থাপনা এবং মৌসুমি পরিবর্তনের কারণে প্রকৃত ফলাফল ভিন্ন হতে পারে। এই প্রতিবেদনের তথ্য বা সুপারিশ ব্যবহার করে গৃহীত কোনো সিদ্ধান্ত বা তার ফলে সৃষ্ট প্রত্যক্ষ, পরোক্ষ বা আনুষঙ্গিক ক্ষতির জন্য Ekosight Technologies Private Limited দায়ী থাকবে না। Ekosight Technologies Private Limited-এর পূর্বানুমতি ছাড়া এই প্রতিবেদনের কোনো অংশ বাণিজ্যিক বা জনসাধারণের উদ্দেশ্যে পুনরুৎপাদন বা ব্যবহার করা যাবে না।",

    waterDisclaimerTextWithPartner:
      "এই জল পরীক্ষার প্রতিবেদনটি Ekosight Technologies Private Limited এবং তাদের অনুমোদিত অংশীদার [Partner Name]-এর সহযোগিতায় প্রস্তুত করা হয়েছে। Ekosight Technologies Private Limited এই প্রক্রিয়ায় ব্যবহৃত পরীক্ষার প্রযুক্তি, সরঞ্জাম এবং বিশ্লেষণাত্মক কাঠামো প্রদান করে, তবে অংশীদার ল্যাবরেটরি বা কর্মীদের দ্বারা প্রস্তুত পৃথক পরীক্ষার ফলাফল স্বাধীনভাবে যাচাই বা সত্যতা নিশ্চিত করে না। গ্রাহকের সরবরাহকৃত জলের নমুনার ভিত্তিতে ফলাফলের যথার্থতা, নির্ভরযোগ্যতা এবং ব্যাখ্যার সম্পূর্ণ দায়িত্ব অনুমোদিত অংশীদারের। পরীক্ষার ফলাফল শুধুমাত্র প্রাপ্ত নমুনা এবং বিশ্লেষণের সময় প্রযোজ্য নির্দিষ্ট পরীক্ষার শর্তের জন্যই বৈধ। এই ফলাফলের ভিত্তিতে প্রদত্ত সুপারিশ বা ব্যাখ্যা শুধুমাত্র সাধারণ নির্দেশিকা হিসেবে বিবেচ্য। জলের উৎস, সংরক্ষণ, ব্যবহার পদ্ধতি, মৌসুমি পরিবর্তন এবং স্থানভেদে পরিবেশগত অবস্থার কারণে প্রকৃত জলমান ও উপযোগিতা ভিন্ন হতে পারে।",
  }
}

// Helper function to get translation
export const getTranslation = (language = 'english') => {
  const lang = language.toLowerCase()
  return translations[lang] || translations.english
}

export const bookingTranslations = {
  en: {
    // Test Type
    soilTest: "Soil Test",
    waterTest: "Water Test",

    // Farm
    selectExistingFarm: "Select Existing Farm (Optional)",
    chooseFarm: "-- Choose Farm from your profile --",
    createNewFarm: "+ Create New Farm",

    // Recommendation
    enableLocationRecommendation: "Enable Location-Based Recommendations",
    locationRecommendationHint: "(Customize prescriptions for your state)",

    // Fields
    farmName: "Farm Name",
    waterSampleName: "Water Sample Name",
    comments: "Comments",
    entityId: "Entity ID",
    farmSize: "Farm Size",
    previousCrop: "Previous Crop",
    nextCrop: "Next Crop",
    treatment: "Treatment",

    // Buttons
    addSample: "Add Sample",
    submitBooking: "Submit Booking",

    // Photos
    bookingPhotos: "Booking Verification Photos (Optional)",
    waterBookingPhotos: "Water Sample Photos (Optional)",
    sampleCollection: "Sample Collection / Digging",
    waterCollection: "Water Collection Photos",
    sampleMixing: "Sample Mixing",
    samplePackaging: "Sample Packaging / Bags",
    addMorePhotos: "+ Add More Photos",
    takeUploadPhoto: "+ Take / Upload Photo",
    uploading: "Uploading...",

    // Success Modal
    bookingSuccessful: "Booking Successful!",
    sample: "Sample",
    farm: "Farm",
    id: "ID",
    notedDetails: "I have noted the details",
    close: "Close",
    loadingCrops: "Loading crops...",

    treatment: "Treatment",
    notApplicable: "Not Applicable",
    initialControl: "Initial Control",
    initialTreated: "Initial Treated",
    finalControl: "Final Control",
    finalTreated: "Final Treated",

    bookingForm: "Booking Form",
    bookingGuidelines: "Booking Guidelines",

    // Accordion
    selectTestType: "Select Test Type",
    fillSampleDetails: "Fill Sample Details",
    multipleSamples: "Multiple Samples",
    bookingPhotosOptional: "Booking Photos (Optional)",
    beforeSubmitting: "Before Submitting",

    // Select Test Type
    selectTestTypeDesc1: "Select Soil Test or Water Test before entering sample details.",
    selectTestTypeDesc2: "Changing the test type will reset the current sample details.",

    // Fill Sample Details
    fillSampleDetailsDesc1: "Enter a meaningful Farm Name.",
    fillSampleDetailsDesc2: "Select an existing farm to automatically fill farm details whenever available.",
    fillSampleDetailsDesc3: "Complete all mandatory fields marked with *.",
    fillSampleDetailsDesc4: "Add comments only if they are relevant to the sample.",

    treeAge: "Tree Age",
    treeAgeNote: "Leave this as 0 or ignore it if the crop is not a tree.",

    // Multiple Samples
    multipleSamplesDesc1: "Use Add Sample to include multiple samples in the same booking.",
    multipleSamplesDesc2: "Each sample should represent a different field or location.",
    multipleSamplesDesc3: "Review all sample details before submitting the booking.",

    // Photos
    bookingPhotosDesc1: "Upload clear photos of sample collection, mixing and packaging whenever possible.",
    bookingPhotosDesc2: "You can upload multiple photos for each category.",
    bookingPhotosDesc3: "Photos help improve traceability and sample verification.",

    // Submit
    beforeSubmittingDesc1: "Review all entered information carefully.",
    beforeSubmittingDesc2: "Ensure the correct farm is selected for each sample.",
    beforeSubmittingDesc3: "Keep the generated Sample IDs safe after successful booking for future reference."
  },

  hi: {
    // Test Type
    soilTest: "मिट्टी परीक्षण",
    waterTest: "पानी परीक्षण",

    // Farm
    selectExistingFarm: "मौजूदा खेत चुनें (वैकल्पिक)",
    chooseFarm: "-- अपनी प्रोफ़ाइल से खेत चुनें --",
    createNewFarm: "+ नया खेत बनाएं",

    // Recommendation
    enableLocationRecommendation: "स्थान आधारित सिफारिशें सक्षम करें",
    locationRecommendationHint: "(अपने राज्य के अनुसार सिफारिशें प्राप्त करें)",

    // Fields
    farmName: "खेत का नाम",
    waterSampleName: "पानी के नमूने का नाम",
    comments: "टिप्पणियाँ",
    entityId: "एंटिटी आईडी",
    farmSize: "खेत का आकार",
    previousCrop: "पिछली फसल",
    nextCrop: "अगली फसल",

    // Buttons
    addSample: "नमूना जोड़ें",
    submitBooking: "बुकिंग सबमिट करें",

    // Photos
    bookingPhotos: "बुकिंग सत्यापन फ़ोटो (वैकल्पिक)",
    waterBookingPhotos: "पानी के नमूने की फ़ोटो (वैकल्पिक)",
    sampleCollection: "नमूना संग्रह / खुदाई",
    waterCollection: "पानी संग्रह फ़ोटो",
    sampleMixing: "नमूना मिश्रण",
    samplePackaging: "नमूना पैकेजिंग / बैग",
    addMorePhotos: "+ और फ़ोटो जोड़ें",
    takeUploadPhoto: "+ फ़ोटो लें / अपलोड करें",
    uploading: "अपलोड हो रहा है...",

    // Success Modal
    bookingSuccessful: "बुकिंग सफल हुई!",
    sample: "नमूना",
    farm: "खेत",
    id: "आईडी",
    notedDetails: "मैंने विवरण नोट कर लिया है",
    close: "बंद करें",
    loadingCrops: "फसलें लोड हो रही हैं...",

    treatment: "उपचार",
    notApplicable: "लागू नहीं",
    initialControl: "प्रारंभिक नियंत्रण",
    initialTreated: "प्रारंभिक उपचारित",
    finalControl: "अंतिम नियंत्रण",
    finalTreated: "अंतिम उपचारित",

    bookingForm: "बुकिंग फ़ॉर्म",
    bookingGuidelines: "बुकिंग दिशानिर्देश",

    selectTestType: "परीक्षण का प्रकार चुनें",
    fillSampleDetails: "नमूना विवरण भरें",
    multipleSamples: "एकाधिक नमूने",
    bookingPhotosOptional: "बुकिंग फ़ोटो (वैकल्पिक)",
    beforeSubmitting: "सबमिट करने से पहले",

    selectTestTypeDesc1: "नमूना विवरण भरने से पहले मिट्टी परीक्षण या पानी परीक्षण चुनें।",
    selectTestTypeDesc2: "परीक्षण का प्रकार बदलने पर वर्तमान नमूना विवरण रीसेट हो जाएगा।",

    fillSampleDetailsDesc1: "खेत का अर्थपूर्ण नाम दर्ज करें।",
    fillSampleDetailsDesc2: "यदि उपलब्ध हो तो खेत का विवरण स्वतः भरने के लिए मौजूदा खेत चुनें।",
    fillSampleDetailsDesc3: " * से चिह्नित सभी आवश्यक फ़ील्ड भरें।",
    fillSampleDetailsDesc4: "टिप्पणियाँ केवल आवश्यक होने पर ही जोड़ें।",

    treeAge: "पेड़ की आयु",
    treeAgeNote: "यदि फसल पेड़ नहीं है, तो इसे 0 रहने दें या अनदेखा करें।",

    multipleSamplesDesc1: "एक ही बुकिंग में कई नमूने जोड़ने के लिए Add Sample का उपयोग करें।",
    multipleSamplesDesc2: "प्रत्येक नमूना अलग खेत या स्थान का होना चाहिए।",
    multipleSamplesDesc3: "बुकिंग सबमिट करने से पहले सभी नमूनों का विवरण जाँच लें।",

    bookingPhotosDesc1: "जहाँ संभव हो, नमूना संग्रह, मिश्रण और पैकेजिंग की स्पष्ट फ़ोटो अपलोड करें।",
    bookingPhotosDesc2: "प्रत्येक श्रेणी में एक से अधिक फ़ोटो अपलोड किए जा सकते हैं।",
    bookingPhotosDesc3: "फ़ोटो नमूने के सत्यापन और ट्रेसबिलिटी में सहायता करती हैं।",

    beforeSubmittingDesc1: "सबमिट करने से पहले सभी जानकारी ध्यान से जाँचें।",
    beforeSubmittingDesc2: "सुनिश्चित करें कि प्रत्येक नमूने के लिए सही खेत चुना गया है।",
    beforeSubmittingDesc3: "बुकिंग सफल होने के बाद प्राप्त Sample ID सुरक्षित रखें।"
  }
};

export const createFarmTranslations = {
  en: {
    english: "English",
    hindi: "हिन्दी",

    createFarmFor: "Create a Farm for",
    loading: "Loading...",

    geoFencing: "Geo fencing: Add Fence here",
    allowLocation: "Allow location access to enable auto detection of location.",

    boundaryNotDrawn: "Boundary not drawn.",
    boundaryNotDrawnDesc:
      'Tap "Draw Farm Boundary", mark all corners of the farm, then close the polygon by clicking the first point. The farm cannot be saved without a complete boundary.',

    boundaryIncomplete: "Boundary incomplete.",
    boundaryIncompleteDesc:
      "Only {{points}} point(s) recorded — a closed polygon needs at least 3 corners. Please reset and redraw.",

    boundaryCaptured: "Farm boundary captured — {{points}} points.",

    otherDetails: "Other Details",
    farmName: "Farm Name",
    enterFarmName: "Enter Farm Name",
    farmNameHint:
      "Any name will work. It will work as an identifier for the farmer and the field officer.",

    farmSize: "Farm Size",
    farmSizePlaceholder: "Farm Size",
    farmSizeUnit: "Farm Size Unit",

    reset: "Reset",
    submit: "Submit",

    instructions: "Farm Creation Instructions",

    instruction1:
      "Allow location access so the map opens near your current location.",
    instruction2:
      'Tap "Draw Farm Boundary" on the map before marking the farm.',
    instruction3:
      "Tap each corner of the farm boundary in order. Add enough points to match the actual shape of the field.",
    instruction4:
      "Finish the boundary by tapping the first point again to close the polygon.",
    instruction5:
      "Verify that the highlighted boundary matches the farm before saving.",
    instruction6:
      "Enter a recognizable farm name. The calculated farm size can be adjusted if required.",
    instruction7:
      "The farm cannot be created until a valid closed boundary has been drawn."
  },

  hi: {
    english: "English",
    hindi: "हिन्दी",

    createFarmFor: "के लिए खेत बनाएं",
    loading: "लोड हो रहा है...",

    geoFencing: "जियो फेंसिंग: यहाँ सीमा जोड़ें",
    allowLocation: "स्थान की स्वतः पहचान के लिए लोकेशन अनुमति दें।",

    boundaryNotDrawn: "सीमा नहीं बनाई गई।",
    boundaryNotDrawnDesc:
      'मानचित्र पर "Draw Farm Boundary" दबाएँ, खेत के सभी कोनों को चिह्नित करें और पहले बिंदु पर क्लिक करके सीमा बंद करें।',

    boundaryIncomplete: "सीमा अधूरी है।",
    boundaryIncompleteDesc:
      "केवल {{points}} बिंदु दर्ज किए गए हैं। कृपया सीमा दोबारा बनाएं।",

    boundaryCaptured: "खेत की सीमा सफलतापूर्वक दर्ज की गई।",

    otherDetails: "अन्य विवरण",
    farmName: "खेत का नाम",
    enterFarmName: "खेत का नाम दर्ज करें",
    farmNameHint:
      "कोई भी नाम दिया जा सकता है। यह किसान और फील्ड ऑफिसर के लिए पहचान के रूप में उपयोग होगा।",

    farmSize: "खेत का आकार",
    farmSizePlaceholder: "खेत का आकार",
    farmSizeUnit: "खेत के आकार की इकाई",

    reset: "रीसेट",
    submit: "सबमिट",

    instructions: "खेत बनाने के निर्देश",

    instruction1:
      "लोकेशन अनुमति दें ताकि मानचित्र आपके वर्तमान स्थान पर खुले।",
    instruction2:
      'खेत की सीमा बनाने से पहले "Draw Farm Boundary" दबाएँ।',
    instruction3:
      "खेत के प्रत्येक कोने को क्रम से चिह्नित करें।",
    instruction4:
      "पहले बिंदु पर फिर से क्लिक करके सीमा पूरी करें।",
    instruction5:
      "सहेजने से पहले सुनिश्चित करें कि सीमा सही है।",
    instruction6:
      "खेत का पहचान योग्य नाम दर्ज करें। आवश्यकता होने पर खेत का आकार बदला जा सकता है।",
    instruction7:
      "मान्य बंद सीमा बनाए बिना खेत नहीं बनाया जा सकता।"
  }
};
